(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaec4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaec4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fpoVQ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b37c87c8e4f9720f$export$ffb0004e005737fa; }, function (v) { return $b37c87c8e4f9720f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $b37c87c8e4f9720f$export$34b9dba7ce09269b; }, function (v) { return $b37c87c8e4f9720f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $b37c87c8e4f9720f$export$25062201e9e25d76; }, function (v) { return $b37c87c8e4f9720f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b37c87c8e4f9720f$export$ffb0004e005737fa;
var $b37c87c8e4f9720f$export$34b9dba7ce09269b;
var $b37c87c8e4f9720f$export$25062201e9e25d76;
"use strict";
var $b37c87c8e4f9720f$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b37c87c8e4f9720f$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $b37c87c8e4f9720f$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $b37c87c8e4f9720f$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$b37c87c8e4f9720f$export$ffb0004e005737fa = $b37c87c8e4f9720f$var$REACT_FRAGMENT_TYPE;
$b37c87c8e4f9720f$export$34b9dba7ce09269b = $b37c87c8e4f9720f$var$jsxProd;
$b37c87c8e4f9720f$export$25062201e9e25d76 = $b37c87c8e4f9720f$var$jsxProd;

});

parcelRegister("exX0H", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $a971ebfca53ecae7$export$882461b6382ed46c; }, function (v) { return $a971ebfca53ecae7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a971ebfca53ecae7$export$757ceba2d55c277e; }, function (v) { return $a971ebfca53ecae7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $a971ebfca53ecae7$export$83d89fbfd8236492; }, function (v) { return $a971ebfca53ecae7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a971ebfca53ecae7$export$882461b6382ed46c;
var $a971ebfca53ecae7$export$757ceba2d55c277e;
var $a971ebfca53ecae7$export$83d89fbfd8236492;
"use strict";

var $d0NqH = parcelRequire("d0NqH");

var $cvMSo = parcelRequire("cvMSo");

var $hVGez = parcelRequire("hVGez");
function $a971ebfca53ecae7$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $a971ebfca53ecae7$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $a971ebfca53ecae7$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $a971ebfca53ecae7$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $a971ebfca53ecae7$var$assertIsMounted(fiber) {
    if ($a971ebfca53ecae7$var$getNearestMountedFiber(fiber) !== fiber) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(188));
}
function $a971ebfca53ecae7$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $a971ebfca53ecae7$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $a971ebfca53ecae7$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $a971ebfca53ecae7$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $a971ebfca53ecae7$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $a971ebfca53ecae7$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $a971ebfca53ecae7$var$assign = Object.assign, $a971ebfca53ecae7$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $a971ebfca53ecae7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a971ebfca53ecae7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a971ebfca53ecae7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a971ebfca53ecae7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a971ebfca53ecae7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a971ebfca53ecae7$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $a971ebfca53ecae7$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a971ebfca53ecae7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a971ebfca53ecae7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a971ebfca53ecae7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $a971ebfca53ecae7$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a971ebfca53ecae7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $a971ebfca53ecae7$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $a971ebfca53ecae7$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $a971ebfca53ecae7$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a971ebfca53ecae7$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $a971ebfca53ecae7$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a971ebfca53ecae7$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a971ebfca53ecae7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $a971ebfca53ecae7$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $a971ebfca53ecae7$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $a971ebfca53ecae7$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $a971ebfca53ecae7$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $a971ebfca53ecae7$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $a971ebfca53ecae7$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $a971ebfca53ecae7$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $a971ebfca53ecae7$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $a971ebfca53ecae7$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $a971ebfca53ecae7$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $a971ebfca53ecae7$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $a971ebfca53ecae7$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $a971ebfca53ecae7$var$getComponentNameFromType(type.type) || "Memo";
        case $a971ebfca53ecae7$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $a971ebfca53ecae7$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $a971ebfca53ecae7$var$isArrayImpl = Array.isArray, $a971ebfca53ecae7$var$ReactSharedInternals = $cvMSo.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $a971ebfca53ecae7$var$ReactDOMSharedInternals = $hVGez.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $a971ebfca53ecae7$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $a971ebfca53ecae7$var$valueStack = [], $a971ebfca53ecae7$var$index = -1;
function $a971ebfca53ecae7$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $a971ebfca53ecae7$var$pop(cursor) {
    0 > $a971ebfca53ecae7$var$index || (cursor.current = $a971ebfca53ecae7$var$valueStack[$a971ebfca53ecae7$var$index], $a971ebfca53ecae7$var$valueStack[$a971ebfca53ecae7$var$index] = null, $a971ebfca53ecae7$var$index--);
}
function $a971ebfca53ecae7$var$push(cursor, value) {
    $a971ebfca53ecae7$var$index++;
    $a971ebfca53ecae7$var$valueStack[$a971ebfca53ecae7$var$index] = cursor.current;
    cursor.current = value;
}
var $a971ebfca53ecae7$var$contextStackCursor = $a971ebfca53ecae7$var$createCursor(null), $a971ebfca53ecae7$var$contextFiberStackCursor = $a971ebfca53ecae7$var$createCursor(null), $a971ebfca53ecae7$var$rootInstanceStackCursor = $a971ebfca53ecae7$var$createCursor(null), $a971ebfca53ecae7$var$hostTransitionProviderCursor = $a971ebfca53ecae7$var$createCursor(null);
function $a971ebfca53ecae7$var$pushHostContainer(fiber, nextRootInstance) {
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$rootInstanceStackCursor, nextRootInstance);
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$contextFiberStackCursor, fiber);
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $a971ebfca53ecae7$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $a971ebfca53ecae7$var$getOwnHostContext(nextRootInstance), fiber = $a971ebfca53ecae7$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$contextStackCursor);
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$contextStackCursor, fiber);
}
function $a971ebfca53ecae7$var$popHostContainer() {
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$contextStackCursor);
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$contextFiberStackCursor);
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$rootInstanceStackCursor);
}
function $a971ebfca53ecae7$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$hostTransitionProviderCursor, fiber);
    var context = $a971ebfca53ecae7$var$contextStackCursor.current;
    var JSCompiler_inline_result = $a971ebfca53ecae7$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$contextFiberStackCursor, fiber), $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$contextStackCursor, JSCompiler_inline_result));
}
function $a971ebfca53ecae7$var$popHostContext(fiber) {
    $a971ebfca53ecae7$var$contextFiberStackCursor.current === fiber && ($a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$contextStackCursor), $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$contextFiberStackCursor));
    $a971ebfca53ecae7$var$hostTransitionProviderCursor.current === fiber && ($a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$hostTransitionProviderCursor), $a971ebfca53ecae7$var$HostTransitionContext._currentValue = $a971ebfca53ecae7$var$sharedNotPendingObject);
}
var $a971ebfca53ecae7$var$hasOwnProperty = Object.prototype.hasOwnProperty, $a971ebfca53ecae7$var$scheduleCallback$3 = $d0NqH.unstable_scheduleCallback, $a971ebfca53ecae7$var$cancelCallback$1 = $d0NqH.unstable_cancelCallback, $a971ebfca53ecae7$var$shouldYield = $d0NqH.unstable_shouldYield, $a971ebfca53ecae7$var$requestPaint = $d0NqH.unstable_requestPaint, $a971ebfca53ecae7$var$now = $d0NqH.unstable_now, $a971ebfca53ecae7$var$getCurrentPriorityLevel = $d0NqH.unstable_getCurrentPriorityLevel, $a971ebfca53ecae7$var$ImmediatePriority = $d0NqH.unstable_ImmediatePriority, $a971ebfca53ecae7$var$UserBlockingPriority = $d0NqH.unstable_UserBlockingPriority, $a971ebfca53ecae7$var$NormalPriority$1 = $d0NqH.unstable_NormalPriority, $a971ebfca53ecae7$var$LowPriority = $d0NqH.unstable_LowPriority, $a971ebfca53ecae7$var$IdlePriority = $d0NqH.unstable_IdlePriority, $a971ebfca53ecae7$var$log$1 = $d0NqH.log, $a971ebfca53ecae7$var$unstable_setDisableYieldValue = $d0NqH.unstable_setDisableYieldValue, $a971ebfca53ecae7$var$rendererID = null, $a971ebfca53ecae7$var$injectedHook = null;
function $a971ebfca53ecae7$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $a971ebfca53ecae7$var$log$1 && $a971ebfca53ecae7$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($a971ebfca53ecae7$var$injectedHook && "function" === typeof $a971ebfca53ecae7$var$injectedHook.setStrictMode) try {
        $a971ebfca53ecae7$var$injectedHook.setStrictMode($a971ebfca53ecae7$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $a971ebfca53ecae7$var$clz32 = Math.clz32 ? Math.clz32 : $a971ebfca53ecae7$var$clz32Fallback, $a971ebfca53ecae7$var$log = Math.log, $a971ebfca53ecae7$var$LN2 = Math.LN2;
function $a971ebfca53ecae7$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($a971ebfca53ecae7$var$log(x) / $a971ebfca53ecae7$var$LN2 | 0) | 0;
}
var $a971ebfca53ecae7$var$nextTransitionLane = 256, $a971ebfca53ecae7$var$nextRetryLane = 4194304;
function $a971ebfca53ecae7$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $a971ebfca53ecae7$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $a971ebfca53ecae7$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $a971ebfca53ecae7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $a971ebfca53ecae7$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $a971ebfca53ecae7$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $a971ebfca53ecae7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $a971ebfca53ecae7$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $a971ebfca53ecae7$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $a971ebfca53ecae7$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a971ebfca53ecae7$var$claimNextTransitionLane() {
    var lane = $a971ebfca53ecae7$var$nextTransitionLane;
    $a971ebfca53ecae7$var$nextTransitionLane <<= 1;
    0 === ($a971ebfca53ecae7$var$nextTransitionLane & 4194048) && ($a971ebfca53ecae7$var$nextTransitionLane = 256);
    return lane;
}
function $a971ebfca53ecae7$var$claimNextRetryLane() {
    var lane = $a971ebfca53ecae7$var$nextRetryLane;
    $a971ebfca53ecae7$var$nextRetryLane <<= 1;
    0 === ($a971ebfca53ecae7$var$nextRetryLane & 62914560) && ($a971ebfca53ecae7$var$nextRetryLane = 4194304);
    return lane;
}
function $a971ebfca53ecae7$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $a971ebfca53ecae7$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $a971ebfca53ecae7$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $a971ebfca53ecae7$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $a971ebfca53ecae7$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $a971ebfca53ecae7$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $a971ebfca53ecae7$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $a971ebfca53ecae7$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $a971ebfca53ecae7$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $a971ebfca53ecae7$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $a971ebfca53ecae7$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $a971ebfca53ecae7$var$resolveUpdatePriority() {
    var updatePriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $a971ebfca53ecae7$var$getEventPriority(updatePriority.type);
}
function $a971ebfca53ecae7$var$runWithPriority(priority, fn) {
    var previousPriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
    try {
        return $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $a971ebfca53ecae7$var$randomKey = Math.random().toString(36).slice(2), $a971ebfca53ecae7$var$internalInstanceKey = "__reactFiber$" + $a971ebfca53ecae7$var$randomKey, $a971ebfca53ecae7$var$internalPropsKey = "__reactProps$" + $a971ebfca53ecae7$var$randomKey, $a971ebfca53ecae7$var$internalContainerInstanceKey = "__reactContainer$" + $a971ebfca53ecae7$var$randomKey, $a971ebfca53ecae7$var$internalEventHandlersKey = "__reactEvents$" + $a971ebfca53ecae7$var$randomKey, $a971ebfca53ecae7$var$internalEventHandlerListenersKey = "__reactListeners$" + $a971ebfca53ecae7$var$randomKey, $a971ebfca53ecae7$var$internalEventHandlesSetKey = "__reactHandles$" + $a971ebfca53ecae7$var$randomKey, $a971ebfca53ecae7$var$internalRootNodeResourcesKey = "__reactResources$" + $a971ebfca53ecae7$var$randomKey, $a971ebfca53ecae7$var$internalHoistableMarker = "__reactMarker$" + $a971ebfca53ecae7$var$randomKey;
function $a971ebfca53ecae7$var$detachDeletedInstance(node) {
    delete node[$a971ebfca53ecae7$var$internalInstanceKey];
    delete node[$a971ebfca53ecae7$var$internalPropsKey];
    delete node[$a971ebfca53ecae7$var$internalEventHandlersKey];
    delete node[$a971ebfca53ecae7$var$internalEventHandlerListenersKey];
    delete node[$a971ebfca53ecae7$var$internalEventHandlesSetKey];
}
function $a971ebfca53ecae7$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$a971ebfca53ecae7$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$a971ebfca53ecae7$var$internalContainerInstanceKey] || parentNode[$a971ebfca53ecae7$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $a971ebfca53ecae7$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$a971ebfca53ecae7$var$internalInstanceKey]) return parentNode;
                targetNode = $a971ebfca53ecae7$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $a971ebfca53ecae7$var$getInstanceFromNode(node) {
    if (node = node[$a971ebfca53ecae7$var$internalInstanceKey] || node[$a971ebfca53ecae7$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $a971ebfca53ecae7$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(33));
}
function $a971ebfca53ecae7$var$getResourcesFromRoot(root) {
    var resources = root[$a971ebfca53ecae7$var$internalRootNodeResourcesKey];
    resources || (resources = root[$a971ebfca53ecae7$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $a971ebfca53ecae7$var$markNodeAsHoistable(node) {
    node[$a971ebfca53ecae7$var$internalHoistableMarker] = !0;
}
var $a971ebfca53ecae7$var$allNativeEvents = new Set(), $a971ebfca53ecae7$var$registrationNameDependencies = {};
function $a971ebfca53ecae7$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $a971ebfca53ecae7$var$registerDirectEvent(registrationName, dependencies);
    $a971ebfca53ecae7$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $a971ebfca53ecae7$var$registerDirectEvent(registrationName, dependencies) {
    $a971ebfca53ecae7$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$a971ebfca53ecae7$var$allNativeEvents.add(dependencies[registrationName]);
}
var $a971ebfca53ecae7$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $a971ebfca53ecae7$var$illegalAttributeNameCache = {}, $a971ebfca53ecae7$var$validatedAttributeNameCache = {};
function $a971ebfca53ecae7$var$isAttributeNameSafe(attributeName) {
    if ($a971ebfca53ecae7$var$hasOwnProperty.call($a971ebfca53ecae7$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($a971ebfca53ecae7$var$hasOwnProperty.call($a971ebfca53ecae7$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($a971ebfca53ecae7$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $a971ebfca53ecae7$var$validatedAttributeNameCache[attributeName] = !0;
    $a971ebfca53ecae7$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $a971ebfca53ecae7$var$setValueForAttribute(node, name, value) {
    if ($a971ebfca53ecae7$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $a971ebfca53ecae7$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $a971ebfca53ecae7$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $a971ebfca53ecae7$var$prefix, $a971ebfca53ecae7$var$suffix;
function $a971ebfca53ecae7$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $a971ebfca53ecae7$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $a971ebfca53ecae7$var$prefix = match && match[1] || "";
        $a971ebfca53ecae7$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $a971ebfca53ecae7$var$prefix + name + $a971ebfca53ecae7$var$suffix;
}
var $a971ebfca53ecae7$var$reentry = !1;
function $a971ebfca53ecae7$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $a971ebfca53ecae7$var$reentry) return "";
    $a971ebfca53ecae7$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $a971ebfca53ecae7$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $a971ebfca53ecae7$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $a971ebfca53ecae7$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $a971ebfca53ecae7$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $a971ebfca53ecae7$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $a971ebfca53ecae7$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $a971ebfca53ecae7$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $a971ebfca53ecae7$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $a971ebfca53ecae7$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $a971ebfca53ecae7$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $a971ebfca53ecae7$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $a971ebfca53ecae7$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $a971ebfca53ecae7$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $a971ebfca53ecae7$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $a971ebfca53ecae7$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $a971ebfca53ecae7$var$trackValueOnNode(node) {
    var valueField = $a971ebfca53ecae7$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $a971ebfca53ecae7$var$track(node) {
    node._valueTracker || (node._valueTracker = $a971ebfca53ecae7$var$trackValueOnNode(node));
}
function $a971ebfca53ecae7$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $a971ebfca53ecae7$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $a971ebfca53ecae7$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $a971ebfca53ecae7$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $a971ebfca53ecae7$var$getToStringValue(value);
        } else element.value !== "" + $a971ebfca53ecae7$var$getToStringValue(value) && (element.value = "" + $a971ebfca53ecae7$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $a971ebfca53ecae7$var$setDefaultValue(element, type, $a971ebfca53ecae7$var$getToStringValue(value)) : null != defaultValue ? $a971ebfca53ecae7$var$setDefaultValue(element, type, $a971ebfca53ecae7$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $a971ebfca53ecae7$var$getToStringValue(name) : element.removeAttribute("name");
}
function $a971ebfca53ecae7$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $a971ebfca53ecae7$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $a971ebfca53ecae7$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $a971ebfca53ecae7$var$setDefaultValue(node, type, value) {
    "number" === type && $a971ebfca53ecae7$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $a971ebfca53ecae7$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $a971ebfca53ecae7$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $a971ebfca53ecae7$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $a971ebfca53ecae7$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $a971ebfca53ecae7$var$getToStringValue(defaultValue) : "";
}
function $a971ebfca53ecae7$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(92));
            if ($a971ebfca53ecae7$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $a971ebfca53ecae7$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $a971ebfca53ecae7$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $a971ebfca53ecae7$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $a971ebfca53ecae7$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $a971ebfca53ecae7$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $a971ebfca53ecae7$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $a971ebfca53ecae7$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $a971ebfca53ecae7$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $a971ebfca53ecae7$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a971ebfca53ecae7$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $a971ebfca53ecae7$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $a971ebfca53ecae7$var$sanitizeURL(url) {
    return $a971ebfca53ecae7$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $a971ebfca53ecae7$var$currentReplayingEvent = null;
function $a971ebfca53ecae7$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $a971ebfca53ecae7$var$restoreTarget = null, $a971ebfca53ecae7$var$restoreQueue = null;
function $a971ebfca53ecae7$var$restoreStateOfTarget(target) {
    var internalInstance = $a971ebfca53ecae7$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$a971ebfca53ecae7$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $a971ebfca53ecae7$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$a971ebfca53ecae7$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(90));
                            $a971ebfca53ecae7$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $a971ebfca53ecae7$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $a971ebfca53ecae7$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $a971ebfca53ecae7$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $a971ebfca53ecae7$var$isInsideEventHandler = !1;
function $a971ebfca53ecae7$var$batchedUpdates$1(fn, a, b) {
    if ($a971ebfca53ecae7$var$isInsideEventHandler) return fn(a, b);
    $a971ebfca53ecae7$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($a971ebfca53ecae7$var$isInsideEventHandler = !1, null !== $a971ebfca53ecae7$var$restoreTarget || null !== $a971ebfca53ecae7$var$restoreQueue) {
            if ($a971ebfca53ecae7$var$flushSyncWork$1(), $a971ebfca53ecae7$var$restoreTarget && (a = $a971ebfca53ecae7$var$restoreTarget, fn = $a971ebfca53ecae7$var$restoreQueue, $a971ebfca53ecae7$var$restoreQueue = $a971ebfca53ecae7$var$restoreTarget = null, $a971ebfca53ecae7$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$a971ebfca53ecae7$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $a971ebfca53ecae7$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$a971ebfca53ecae7$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $a971ebfca53ecae7$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a971ebfca53ecae7$var$passiveBrowserEventsSupported = !1;
if ($a971ebfca53ecae7$var$canUseDOM) try {
    var $a971ebfca53ecae7$var$options = {};
    Object.defineProperty($a971ebfca53ecae7$var$options, "passive", {
        get: function() {
            $a971ebfca53ecae7$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $a971ebfca53ecae7$var$options, $a971ebfca53ecae7$var$options);
    window.removeEventListener("test", $a971ebfca53ecae7$var$options, $a971ebfca53ecae7$var$options);
} catch (e) {
    $a971ebfca53ecae7$var$passiveBrowserEventsSupported = !1;
}
var $a971ebfca53ecae7$var$root = null, $a971ebfca53ecae7$var$startText = null, $a971ebfca53ecae7$var$fallbackText = null;
function $a971ebfca53ecae7$var$getData() {
    if ($a971ebfca53ecae7$var$fallbackText) return $a971ebfca53ecae7$var$fallbackText;
    var start, startValue = $a971ebfca53ecae7$var$startText, startLength = startValue.length, end, endValue = "value" in $a971ebfca53ecae7$var$root ? $a971ebfca53ecae7$var$root.value : $a971ebfca53ecae7$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $a971ebfca53ecae7$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $a971ebfca53ecae7$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $a971ebfca53ecae7$var$functionThatReturnsTrue() {
    return !0;
}
function $a971ebfca53ecae7$var$functionThatReturnsFalse() {
    return !1;
}
function $a971ebfca53ecae7$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $a971ebfca53ecae7$var$functionThatReturnsTrue : $a971ebfca53ecae7$var$functionThatReturnsFalse;
        this.isPropagationStopped = $a971ebfca53ecae7$var$functionThatReturnsFalse;
        return this;
    }
    $a971ebfca53ecae7$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $a971ebfca53ecae7$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $a971ebfca53ecae7$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $a971ebfca53ecae7$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $a971ebfca53ecae7$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a971ebfca53ecae7$var$SyntheticEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$EventInterface), $a971ebfca53ecae7$var$UIEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$EventInterface, {
    view: 0,
    detail: 0
}), $a971ebfca53ecae7$var$SyntheticUIEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$UIEventInterface), $a971ebfca53ecae7$var$lastMovementX, $a971ebfca53ecae7$var$lastMovementY, $a971ebfca53ecae7$var$lastMouseEvent, $a971ebfca53ecae7$var$MouseEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a971ebfca53ecae7$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $a971ebfca53ecae7$var$lastMouseEvent && ($a971ebfca53ecae7$var$lastMouseEvent && "mousemove" === event.type ? ($a971ebfca53ecae7$var$lastMovementX = event.screenX - $a971ebfca53ecae7$var$lastMouseEvent.screenX, $a971ebfca53ecae7$var$lastMovementY = event.screenY - $a971ebfca53ecae7$var$lastMouseEvent.screenY) : $a971ebfca53ecae7$var$lastMovementY = $a971ebfca53ecae7$var$lastMovementX = 0, $a971ebfca53ecae7$var$lastMouseEvent = event);
        return $a971ebfca53ecae7$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $a971ebfca53ecae7$var$lastMovementY;
    }
}), $a971ebfca53ecae7$var$SyntheticMouseEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$MouseEventInterface), $a971ebfca53ecae7$var$DragEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$MouseEventInterface, {
    dataTransfer: 0
}), $a971ebfca53ecae7$var$SyntheticDragEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$DragEventInterface), $a971ebfca53ecae7$var$FocusEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$UIEventInterface, {
    relatedTarget: 0
}), $a971ebfca53ecae7$var$SyntheticFocusEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$FocusEventInterface), $a971ebfca53ecae7$var$AnimationEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a971ebfca53ecae7$var$SyntheticAnimationEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$AnimationEventInterface), $a971ebfca53ecae7$var$ClipboardEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $a971ebfca53ecae7$var$SyntheticClipboardEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$ClipboardEventInterface), $a971ebfca53ecae7$var$CompositionEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$EventInterface, {
    data: 0
}), $a971ebfca53ecae7$var$SyntheticCompositionEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$CompositionEventInterface), $a971ebfca53ecae7$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a971ebfca53ecae7$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a971ebfca53ecae7$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a971ebfca53ecae7$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $a971ebfca53ecae7$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $a971ebfca53ecae7$var$getEventModifierState() {
    return $a971ebfca53ecae7$var$modifierStateGetter;
}
var $a971ebfca53ecae7$var$KeyboardEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $a971ebfca53ecae7$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $a971ebfca53ecae7$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $a971ebfca53ecae7$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a971ebfca53ecae7$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $a971ebfca53ecae7$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $a971ebfca53ecae7$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $a971ebfca53ecae7$var$SyntheticKeyboardEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$KeyboardEventInterface), $a971ebfca53ecae7$var$PointerEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a971ebfca53ecae7$var$SyntheticPointerEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$PointerEventInterface), $a971ebfca53ecae7$var$TouchEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a971ebfca53ecae7$var$getEventModifierState
}), $a971ebfca53ecae7$var$SyntheticTouchEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$TouchEventInterface), $a971ebfca53ecae7$var$TransitionEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a971ebfca53ecae7$var$SyntheticTransitionEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$TransitionEventInterface), $a971ebfca53ecae7$var$WheelEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a971ebfca53ecae7$var$SyntheticWheelEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$WheelEventInterface), $a971ebfca53ecae7$var$ToggleEventInterface = $a971ebfca53ecae7$var$assign({}, $a971ebfca53ecae7$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $a971ebfca53ecae7$var$SyntheticToggleEvent = $a971ebfca53ecae7$var$createSyntheticEvent($a971ebfca53ecae7$var$ToggleEventInterface), $a971ebfca53ecae7$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $a971ebfca53ecae7$var$canUseCompositionEvent = $a971ebfca53ecae7$var$canUseDOM && "CompositionEvent" in window, $a971ebfca53ecae7$var$documentMode = null;
$a971ebfca53ecae7$var$canUseDOM && "documentMode" in document && ($a971ebfca53ecae7$var$documentMode = document.documentMode);
var $a971ebfca53ecae7$var$canUseTextInputEvent = $a971ebfca53ecae7$var$canUseDOM && "TextEvent" in window && !$a971ebfca53ecae7$var$documentMode, $a971ebfca53ecae7$var$useFallbackCompositionData = $a971ebfca53ecae7$var$canUseDOM && (!$a971ebfca53ecae7$var$canUseCompositionEvent || $a971ebfca53ecae7$var$documentMode && 8 < $a971ebfca53ecae7$var$documentMode && 11 >= $a971ebfca53ecae7$var$documentMode), $a971ebfca53ecae7$var$SPACEBAR_CHAR = String.fromCharCode(32), $a971ebfca53ecae7$var$hasSpaceKeypress = !1;
function $a971ebfca53ecae7$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $a971ebfca53ecae7$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a971ebfca53ecae7$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $a971ebfca53ecae7$var$isComposing = !1;
function $a971ebfca53ecae7$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $a971ebfca53ecae7$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $a971ebfca53ecae7$var$hasSpaceKeypress = !0;
            return $a971ebfca53ecae7$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $a971ebfca53ecae7$var$SPACEBAR_CHAR && $a971ebfca53ecae7$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $a971ebfca53ecae7$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($a971ebfca53ecae7$var$isComposing) return "compositionend" === domEventName || !$a971ebfca53ecae7$var$canUseCompositionEvent && $a971ebfca53ecae7$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $a971ebfca53ecae7$var$getData(), $a971ebfca53ecae7$var$fallbackText = $a971ebfca53ecae7$var$startText = $a971ebfca53ecae7$var$root = null, $a971ebfca53ecae7$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $a971ebfca53ecae7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $a971ebfca53ecae7$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a971ebfca53ecae7$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$a971ebfca53ecae7$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $a971ebfca53ecae7$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $a971ebfca53ecae7$var$restoreTarget ? $a971ebfca53ecae7$var$restoreQueue ? $a971ebfca53ecae7$var$restoreQueue.push(target) : $a971ebfca53ecae7$var$restoreQueue = [
        target
    ] : $a971ebfca53ecae7$var$restoreTarget = target;
    inst = $a971ebfca53ecae7$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $a971ebfca53ecae7$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $a971ebfca53ecae7$var$activeElement$1 = null, $a971ebfca53ecae7$var$activeElementInst$1 = null;
function $a971ebfca53ecae7$var$runEventInBatch(dispatchQueue) {
    $a971ebfca53ecae7$var$processDispatchQueue(dispatchQueue, 0);
}
function $a971ebfca53ecae7$var$getInstIfValueChanged(targetInst) {
    var targetNode = $a971ebfca53ecae7$var$getNodeFromInstance(targetInst);
    if ($a971ebfca53ecae7$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $a971ebfca53ecae7$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $a971ebfca53ecae7$var$isInputEventSupported = !1;
if ($a971ebfca53ecae7$var$canUseDOM) {
    var $a971ebfca53ecae7$var$JSCompiler_inline_result$jscomp$282;
    if ($a971ebfca53ecae7$var$canUseDOM) {
        var $a971ebfca53ecae7$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$a971ebfca53ecae7$var$isSupported$jscomp$inline_417) {
            var $a971ebfca53ecae7$var$element$jscomp$inline_418 = document.createElement("div");
            $a971ebfca53ecae7$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $a971ebfca53ecae7$var$isSupported$jscomp$inline_417 = "function" === typeof $a971ebfca53ecae7$var$element$jscomp$inline_418.oninput;
        }
        $a971ebfca53ecae7$var$JSCompiler_inline_result$jscomp$282 = $a971ebfca53ecae7$var$isSupported$jscomp$inline_417;
    } else $a971ebfca53ecae7$var$JSCompiler_inline_result$jscomp$282 = !1;
    $a971ebfca53ecae7$var$isInputEventSupported = $a971ebfca53ecae7$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $a971ebfca53ecae7$var$stopWatchingForValueChange() {
    $a971ebfca53ecae7$var$activeElement$1 && ($a971ebfca53ecae7$var$activeElement$1.detachEvent("onpropertychange", $a971ebfca53ecae7$var$handlePropertyChange), $a971ebfca53ecae7$var$activeElementInst$1 = $a971ebfca53ecae7$var$activeElement$1 = null);
}
function $a971ebfca53ecae7$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $a971ebfca53ecae7$var$getInstIfValueChanged($a971ebfca53ecae7$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $a971ebfca53ecae7$var$createAndAccumulateChangeEvent(dispatchQueue, $a971ebfca53ecae7$var$activeElementInst$1, nativeEvent, $a971ebfca53ecae7$var$getEventTarget(nativeEvent));
        $a971ebfca53ecae7$var$batchedUpdates$1($a971ebfca53ecae7$var$runEventInBatch, dispatchQueue);
    }
}
function $a971ebfca53ecae7$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($a971ebfca53ecae7$var$stopWatchingForValueChange(), $a971ebfca53ecae7$var$activeElement$1 = target, $a971ebfca53ecae7$var$activeElementInst$1 = targetInst, $a971ebfca53ecae7$var$activeElement$1.attachEvent("onpropertychange", $a971ebfca53ecae7$var$handlePropertyChange)) : "focusout" === domEventName && $a971ebfca53ecae7$var$stopWatchingForValueChange();
}
function $a971ebfca53ecae7$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $a971ebfca53ecae7$var$getInstIfValueChanged($a971ebfca53ecae7$var$activeElementInst$1);
}
function $a971ebfca53ecae7$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $a971ebfca53ecae7$var$getInstIfValueChanged(targetInst);
}
function $a971ebfca53ecae7$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $a971ebfca53ecae7$var$getInstIfValueChanged(targetInst);
}
function $a971ebfca53ecae7$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a971ebfca53ecae7$var$objectIs = "function" === typeof Object.is ? Object.is : $a971ebfca53ecae7$var$is;
function $a971ebfca53ecae7$var$shallowEqual(objA, objB) {
    if ($a971ebfca53ecae7$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$a971ebfca53ecae7$var$hasOwnProperty.call(objB, currentKey) || !$a971ebfca53ecae7$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $a971ebfca53ecae7$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $a971ebfca53ecae7$var$getNodeForCharacterOffset(root, offset) {
    var node = $a971ebfca53ecae7$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $a971ebfca53ecae7$var$getLeafNode(node);
    }
}
function $a971ebfca53ecae7$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $a971ebfca53ecae7$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $a971ebfca53ecae7$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $a971ebfca53ecae7$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $a971ebfca53ecae7$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $a971ebfca53ecae7$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $a971ebfca53ecae7$var$skipSelectionChangeEvent = $a971ebfca53ecae7$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $a971ebfca53ecae7$var$activeElement = null, $a971ebfca53ecae7$var$activeElementInst = null, $a971ebfca53ecae7$var$lastSelection = null, $a971ebfca53ecae7$var$mouseDown = !1;
function $a971ebfca53ecae7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $a971ebfca53ecae7$var$mouseDown || null == $a971ebfca53ecae7$var$activeElement || $a971ebfca53ecae7$var$activeElement !== $a971ebfca53ecae7$var$getActiveElement(doc) || (doc = $a971ebfca53ecae7$var$activeElement, "selectionStart" in doc && $a971ebfca53ecae7$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $a971ebfca53ecae7$var$lastSelection && $a971ebfca53ecae7$var$shallowEqual($a971ebfca53ecae7$var$lastSelection, doc) || ($a971ebfca53ecae7$var$lastSelection = doc, doc = $a971ebfca53ecae7$var$accumulateTwoPhaseListeners($a971ebfca53ecae7$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $a971ebfca53ecae7$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $a971ebfca53ecae7$var$activeElement)));
}
function $a971ebfca53ecae7$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $a971ebfca53ecae7$var$vendorPrefixes = {
    animationend: $a971ebfca53ecae7$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $a971ebfca53ecae7$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $a971ebfca53ecae7$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $a971ebfca53ecae7$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $a971ebfca53ecae7$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $a971ebfca53ecae7$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $a971ebfca53ecae7$var$makePrefixMap("Transition", "TransitionEnd")
}, $a971ebfca53ecae7$var$prefixedEventNames = {}, $a971ebfca53ecae7$var$style = {};
$a971ebfca53ecae7$var$canUseDOM && ($a971ebfca53ecae7$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $a971ebfca53ecae7$var$vendorPrefixes.animationend.animation, delete $a971ebfca53ecae7$var$vendorPrefixes.animationiteration.animation, delete $a971ebfca53ecae7$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $a971ebfca53ecae7$var$vendorPrefixes.transitionend.transition);
function $a971ebfca53ecae7$var$getVendorPrefixedEventName(eventName) {
    if ($a971ebfca53ecae7$var$prefixedEventNames[eventName]) return $a971ebfca53ecae7$var$prefixedEventNames[eventName];
    if (!$a971ebfca53ecae7$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $a971ebfca53ecae7$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $a971ebfca53ecae7$var$style) return $a971ebfca53ecae7$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $a971ebfca53ecae7$var$ANIMATION_END = $a971ebfca53ecae7$var$getVendorPrefixedEventName("animationend"), $a971ebfca53ecae7$var$ANIMATION_ITERATION = $a971ebfca53ecae7$var$getVendorPrefixedEventName("animationiteration"), $a971ebfca53ecae7$var$ANIMATION_START = $a971ebfca53ecae7$var$getVendorPrefixedEventName("animationstart"), $a971ebfca53ecae7$var$TRANSITION_RUN = $a971ebfca53ecae7$var$getVendorPrefixedEventName("transitionrun"), $a971ebfca53ecae7$var$TRANSITION_START = $a971ebfca53ecae7$var$getVendorPrefixedEventName("transitionstart"), $a971ebfca53ecae7$var$TRANSITION_CANCEL = $a971ebfca53ecae7$var$getVendorPrefixedEventName("transitioncancel"), $a971ebfca53ecae7$var$TRANSITION_END = $a971ebfca53ecae7$var$getVendorPrefixedEventName("transitionend"), $a971ebfca53ecae7$var$topLevelEventsToReactNames = new Map(), $a971ebfca53ecae7$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$a971ebfca53ecae7$var$simpleEventPluginEvents.push("scrollEnd");
function $a971ebfca53ecae7$var$registerSimpleEvent(domEventName, reactName) {
    $a971ebfca53ecae7$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $a971ebfca53ecae7$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $a971ebfca53ecae7$var$CapturedStacks = new WeakMap();
function $a971ebfca53ecae7$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $a971ebfca53ecae7$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $a971ebfca53ecae7$var$getStackByFiberInDevAndProd(source)
        };
        $a971ebfca53ecae7$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $a971ebfca53ecae7$var$getStackByFiberInDevAndProd(source)
    };
}
var $a971ebfca53ecae7$var$concurrentQueues = [], $a971ebfca53ecae7$var$concurrentQueuesIndex = 0, $a971ebfca53ecae7$var$concurrentlyUpdatedLanes = 0;
function $a971ebfca53ecae7$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $a971ebfca53ecae7$var$concurrentQueuesIndex, i = $a971ebfca53ecae7$var$concurrentlyUpdatedLanes = $a971ebfca53ecae7$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $a971ebfca53ecae7$var$concurrentQueues[i];
        $a971ebfca53ecae7$var$concurrentQueues[i++] = null;
        var queue = $a971ebfca53ecae7$var$concurrentQueues[i];
        $a971ebfca53ecae7$var$concurrentQueues[i++] = null;
        var update = $a971ebfca53ecae7$var$concurrentQueues[i];
        $a971ebfca53ecae7$var$concurrentQueues[i++] = null;
        var lane = $a971ebfca53ecae7$var$concurrentQueues[i];
        $a971ebfca53ecae7$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $a971ebfca53ecae7$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $a971ebfca53ecae7$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $a971ebfca53ecae7$var$concurrentQueues[$a971ebfca53ecae7$var$concurrentQueuesIndex++] = fiber;
    $a971ebfca53ecae7$var$concurrentQueues[$a971ebfca53ecae7$var$concurrentQueuesIndex++] = queue;
    $a971ebfca53ecae7$var$concurrentQueues[$a971ebfca53ecae7$var$concurrentQueuesIndex++] = update;
    $a971ebfca53ecae7$var$concurrentQueues[$a971ebfca53ecae7$var$concurrentQueuesIndex++] = lane;
    $a971ebfca53ecae7$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $a971ebfca53ecae7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $a971ebfca53ecae7$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $a971ebfca53ecae7$var$getRootForUpdatedFiber(fiber);
}
function $a971ebfca53ecae7$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $a971ebfca53ecae7$var$enqueueUpdate$1(fiber, null, null, lane);
    return $a971ebfca53ecae7$var$getRootForUpdatedFiber(fiber);
}
function $a971ebfca53ecae7$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $a971ebfca53ecae7$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $a971ebfca53ecae7$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $a971ebfca53ecae7$var$nestedUpdateCount) throw $a971ebfca53ecae7$var$nestedUpdateCount = 0, $a971ebfca53ecae7$var$rootWithNestedUpdates = null, Error($a971ebfca53ecae7$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $a971ebfca53ecae7$var$emptyContextObject = {};
function $a971ebfca53ecae7$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a971ebfca53ecae7$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $a971ebfca53ecae7$var$FiberNode(tag, pendingProps, key, mode);
}
function $a971ebfca53ecae7$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $a971ebfca53ecae7$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $a971ebfca53ecae7$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $a971ebfca53ecae7$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $a971ebfca53ecae7$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $a971ebfca53ecae7$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $a971ebfca53ecae7$var$isHostHoistableType(type, pendingProps, $a971ebfca53ecae7$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $a971ebfca53ecae7$var$REACT_ACTIVITY_TYPE:
            return type = $a971ebfca53ecae7$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $a971ebfca53ecae7$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $a971ebfca53ecae7$var$REACT_FRAGMENT_TYPE:
            return $a971ebfca53ecae7$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $a971ebfca53ecae7$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $a971ebfca53ecae7$var$REACT_PROFILER_TYPE:
            return type = $a971ebfca53ecae7$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $a971ebfca53ecae7$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $a971ebfca53ecae7$var$REACT_SUSPENSE_TYPE:
            return type = $a971ebfca53ecae7$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $a971ebfca53ecae7$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $a971ebfca53ecae7$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $a971ebfca53ecae7$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $a971ebfca53ecae7$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $a971ebfca53ecae7$var$REACT_PROVIDER_TYPE:
                case $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $a971ebfca53ecae7$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $a971ebfca53ecae7$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $a971ebfca53ecae7$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $a971ebfca53ecae7$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($a971ebfca53ecae7$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $a971ebfca53ecae7$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $a971ebfca53ecae7$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $a971ebfca53ecae7$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $a971ebfca53ecae7$var$createFiberFromText(content, mode, lanes) {
    content = $a971ebfca53ecae7$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $a971ebfca53ecae7$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $a971ebfca53ecae7$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $a971ebfca53ecae7$var$forkStack = [], $a971ebfca53ecae7$var$forkStackIndex = 0, $a971ebfca53ecae7$var$treeForkProvider = null, $a971ebfca53ecae7$var$treeForkCount = 0, $a971ebfca53ecae7$var$idStack = [], $a971ebfca53ecae7$var$idStackIndex = 0, $a971ebfca53ecae7$var$treeContextProvider = null, $a971ebfca53ecae7$var$treeContextId = 1, $a971ebfca53ecae7$var$treeContextOverflow = "";
function $a971ebfca53ecae7$var$pushTreeFork(workInProgress, totalChildren) {
    $a971ebfca53ecae7$var$forkStack[$a971ebfca53ecae7$var$forkStackIndex++] = $a971ebfca53ecae7$var$treeForkCount;
    $a971ebfca53ecae7$var$forkStack[$a971ebfca53ecae7$var$forkStackIndex++] = $a971ebfca53ecae7$var$treeForkProvider;
    $a971ebfca53ecae7$var$treeForkProvider = workInProgress;
    $a971ebfca53ecae7$var$treeForkCount = totalChildren;
}
function $a971ebfca53ecae7$var$pushTreeId(workInProgress, totalChildren, index) {
    $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex++] = $a971ebfca53ecae7$var$treeContextId;
    $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex++] = $a971ebfca53ecae7$var$treeContextOverflow;
    $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex++] = $a971ebfca53ecae7$var$treeContextProvider;
    $a971ebfca53ecae7$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $a971ebfca53ecae7$var$treeContextId;
    workInProgress = $a971ebfca53ecae7$var$treeContextOverflow;
    var baseLength = 32 - $a971ebfca53ecae7$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $a971ebfca53ecae7$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $a971ebfca53ecae7$var$treeContextId = 1 << 32 - $a971ebfca53ecae7$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $a971ebfca53ecae7$var$treeContextOverflow = length + workInProgress;
    } else $a971ebfca53ecae7$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $a971ebfca53ecae7$var$treeContextOverflow = workInProgress;
}
function $a971ebfca53ecae7$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($a971ebfca53ecae7$var$pushTreeFork(workInProgress, 1), $a971ebfca53ecae7$var$pushTreeId(workInProgress, 1, 0));
}
function $a971ebfca53ecae7$var$popTreeContext(workInProgress) {
    for(; workInProgress === $a971ebfca53ecae7$var$treeForkProvider;)$a971ebfca53ecae7$var$treeForkProvider = $a971ebfca53ecae7$var$forkStack[--$a971ebfca53ecae7$var$forkStackIndex], $a971ebfca53ecae7$var$forkStack[$a971ebfca53ecae7$var$forkStackIndex] = null, $a971ebfca53ecae7$var$treeForkCount = $a971ebfca53ecae7$var$forkStack[--$a971ebfca53ecae7$var$forkStackIndex], $a971ebfca53ecae7$var$forkStack[$a971ebfca53ecae7$var$forkStackIndex] = null;
    for(; workInProgress === $a971ebfca53ecae7$var$treeContextProvider;)$a971ebfca53ecae7$var$treeContextProvider = $a971ebfca53ecae7$var$idStack[--$a971ebfca53ecae7$var$idStackIndex], $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex] = null, $a971ebfca53ecae7$var$treeContextOverflow = $a971ebfca53ecae7$var$idStack[--$a971ebfca53ecae7$var$idStackIndex], $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex] = null, $a971ebfca53ecae7$var$treeContextId = $a971ebfca53ecae7$var$idStack[--$a971ebfca53ecae7$var$idStackIndex], $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex] = null;
}
var $a971ebfca53ecae7$var$hydrationParentFiber = null, $a971ebfca53ecae7$var$nextHydratableInstance = null, $a971ebfca53ecae7$var$isHydrating = !1, $a971ebfca53ecae7$var$hydrationErrors = null, $a971ebfca53ecae7$var$rootOrSingletonContext = !1, $a971ebfca53ecae7$var$HydrationMismatchException = Error($a971ebfca53ecae7$var$formatProdErrorMessage(519));
function $a971ebfca53ecae7$var$throwOnHydrationMismatch(fiber) {
    var error = Error($a971ebfca53ecae7$var$formatProdErrorMessage(418, ""));
    $a971ebfca53ecae7$var$queueHydrationError($a971ebfca53ecae7$var$createCapturedValueAtFiber(error, fiber));
    throw $a971ebfca53ecae7$var$HydrationMismatchException;
}
function $a971ebfca53ecae7$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$a971ebfca53ecae7$var$internalInstanceKey] = fiber;
    instance[$a971ebfca53ecae7$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("cancel", instance);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $a971ebfca53ecae7$var$mediaEventTypes.length; type++)$a971ebfca53ecae7$var$listenToNonDelegatedEvent($a971ebfca53ecae7$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("error", instance);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("invalid", instance);
            $a971ebfca53ecae7$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $a971ebfca53ecae7$var$track(instance);
            break;
        case "select":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("invalid", instance), $a971ebfca53ecae7$var$initTextarea(instance, props.value, props.defaultValue, props.children), $a971ebfca53ecae7$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $a971ebfca53ecae7$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($a971ebfca53ecae7$var$listenToNonDelegatedEvent("beforetoggle", instance), $a971ebfca53ecae7$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $a971ebfca53ecae7$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $a971ebfca53ecae7$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $a971ebfca53ecae7$var$noop$1), instance = !0) : instance = !1;
    instance || $a971ebfca53ecae7$var$throwOnHydrationMismatch(fiber);
}
function $a971ebfca53ecae7$var$popToNextHostParent(fiber) {
    for($a971ebfca53ecae7$var$hydrationParentFiber = fiber.return; $a971ebfca53ecae7$var$hydrationParentFiber;)switch($a971ebfca53ecae7$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $a971ebfca53ecae7$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $a971ebfca53ecae7$var$rootOrSingletonContext = !0;
            return;
        default:
            $a971ebfca53ecae7$var$hydrationParentFiber = $a971ebfca53ecae7$var$hydrationParentFiber.return;
    }
}
function $a971ebfca53ecae7$var$popHydrationState(fiber) {
    if (fiber !== $a971ebfca53ecae7$var$hydrationParentFiber) return !1;
    if (!$a971ebfca53ecae7$var$isHydrating) return $a971ebfca53ecae7$var$popToNextHostParent(fiber), $a971ebfca53ecae7$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $a971ebfca53ecae7$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $a971ebfca53ecae7$var$nextHydratableInstance && $a971ebfca53ecae7$var$throwOnHydrationMismatch(fiber);
    $a971ebfca53ecae7$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $a971ebfca53ecae7$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $a971ebfca53ecae7$var$nextHydratableInstance, $a971ebfca53ecae7$var$isSingletonScope(fiber.type) ? (fiber = $a971ebfca53ecae7$var$previousHydratableOnEnteringScopedSingleton, $a971ebfca53ecae7$var$previousHydratableOnEnteringScopedSingleton = null, $a971ebfca53ecae7$var$nextHydratableInstance = fiber) : $a971ebfca53ecae7$var$nextHydratableInstance = tag) : $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$hydrationParentFiber ? $a971ebfca53ecae7$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $a971ebfca53ecae7$var$resetHydrationState() {
    $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$hydrationParentFiber = null;
    $a971ebfca53ecae7$var$isHydrating = !1;
}
function $a971ebfca53ecae7$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $a971ebfca53ecae7$var$hydrationErrors;
    null !== queuedErrors && (null === $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors ? $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors = queuedErrors : $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors.push.apply($a971ebfca53ecae7$var$workInProgressRootRecoverableErrors, queuedErrors), $a971ebfca53ecae7$var$hydrationErrors = null);
    return queuedErrors;
}
function $a971ebfca53ecae7$var$queueHydrationError(error) {
    null === $a971ebfca53ecae7$var$hydrationErrors ? $a971ebfca53ecae7$var$hydrationErrors = [
        error
    ] : $a971ebfca53ecae7$var$hydrationErrors.push(error);
}
var $a971ebfca53ecae7$var$valueCursor = $a971ebfca53ecae7$var$createCursor(null), $a971ebfca53ecae7$var$currentlyRenderingFiber$1 = null, $a971ebfca53ecae7$var$lastContextDependency = null;
function $a971ebfca53ecae7$var$pushProvider(providerFiber, context, nextValue) {
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $a971ebfca53ecae7$var$popProvider(context) {
    context._currentValue = $a971ebfca53ecae7$var$valueCursor.current;
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$valueCursor);
}
function $a971ebfca53ecae7$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $a971ebfca53ecae7$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $a971ebfca53ecae7$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $a971ebfca53ecae7$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $a971ebfca53ecae7$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $a971ebfca53ecae7$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $a971ebfca53ecae7$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($a971ebfca53ecae7$var$HostTransitionContext) : current = [
                $a971ebfca53ecae7$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $a971ebfca53ecae7$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $a971ebfca53ecae7$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$a971ebfca53ecae7$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $a971ebfca53ecae7$var$prepareToReadContext(workInProgress) {
    $a971ebfca53ecae7$var$currentlyRenderingFiber$1 = workInProgress;
    $a971ebfca53ecae7$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $a971ebfca53ecae7$var$readContext(context) {
    return $a971ebfca53ecae7$var$readContextForConsumer($a971ebfca53ecae7$var$currentlyRenderingFiber$1, context);
}
function $a971ebfca53ecae7$var$readContextDuringReconciliation(consumer, context) {
    null === $a971ebfca53ecae7$var$currentlyRenderingFiber$1 && $a971ebfca53ecae7$var$prepareToReadContext(consumer);
    return $a971ebfca53ecae7$var$readContextForConsumer(consumer, context);
}
function $a971ebfca53ecae7$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $a971ebfca53ecae7$var$lastContextDependency) {
        if (null === consumer) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(308));
        $a971ebfca53ecae7$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $a971ebfca53ecae7$var$lastContextDependency = $a971ebfca53ecae7$var$lastContextDependency.next = context;
    return value;
}
var $a971ebfca53ecae7$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $a971ebfca53ecae7$var$scheduleCallback$2 = $d0NqH.unstable_scheduleCallback, $a971ebfca53ecae7$var$NormalPriority = $d0NqH.unstable_NormalPriority, $a971ebfca53ecae7$var$CacheContext = {
    $$typeof: $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $a971ebfca53ecae7$var$createCache() {
    return {
        controller: new $a971ebfca53ecae7$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $a971ebfca53ecae7$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $a971ebfca53ecae7$var$scheduleCallback$2($a971ebfca53ecae7$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $a971ebfca53ecae7$var$currentEntangledListeners = null, $a971ebfca53ecae7$var$currentEntangledPendingCount = 0, $a971ebfca53ecae7$var$currentEntangledLane = 0, $a971ebfca53ecae7$var$currentEntangledActionThenable = null;
function $a971ebfca53ecae7$var$entangleAsyncAction(transition, thenable) {
    if (null === $a971ebfca53ecae7$var$currentEntangledListeners) {
        var entangledListeners = $a971ebfca53ecae7$var$currentEntangledListeners = [];
        $a971ebfca53ecae7$var$currentEntangledPendingCount = 0;
        $a971ebfca53ecae7$var$currentEntangledLane = $a971ebfca53ecae7$var$requestTransitionLane();
        $a971ebfca53ecae7$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $a971ebfca53ecae7$var$currentEntangledPendingCount++;
    thenable.then($a971ebfca53ecae7$var$pingEngtangledActionScope, $a971ebfca53ecae7$var$pingEngtangledActionScope);
    return thenable;
}
function $a971ebfca53ecae7$var$pingEngtangledActionScope() {
    if (0 === --$a971ebfca53ecae7$var$currentEntangledPendingCount && null !== $a971ebfca53ecae7$var$currentEntangledListeners) {
        null !== $a971ebfca53ecae7$var$currentEntangledActionThenable && ($a971ebfca53ecae7$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $a971ebfca53ecae7$var$currentEntangledListeners;
        $a971ebfca53ecae7$var$currentEntangledListeners = null;
        $a971ebfca53ecae7$var$currentEntangledLane = 0;
        $a971ebfca53ecae7$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $a971ebfca53ecae7$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $a971ebfca53ecae7$var$prevOnStartTransitionFinish = $a971ebfca53ecae7$var$ReactSharedInternals.S;
$a971ebfca53ecae7$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $a971ebfca53ecae7$var$entangleAsyncAction(transition, returnValue);
    null !== $a971ebfca53ecae7$var$prevOnStartTransitionFinish && $a971ebfca53ecae7$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $a971ebfca53ecae7$var$resumedCache = $a971ebfca53ecae7$var$createCursor(null);
function $a971ebfca53ecae7$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $a971ebfca53ecae7$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $a971ebfca53ecae7$var$workInProgressRoot.pooledCache;
}
function $a971ebfca53ecae7$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$resumedCache, $a971ebfca53ecae7$var$resumedCache.current) : $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$resumedCache, prevCachePool.pool);
}
function $a971ebfca53ecae7$var$getSuspendedCache() {
    var cacheFromPool = $a971ebfca53ecae7$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $a971ebfca53ecae7$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $a971ebfca53ecae7$var$SuspenseException = Error($a971ebfca53ecae7$var$formatProdErrorMessage(460)), $a971ebfca53ecae7$var$SuspenseyCommitException = Error($a971ebfca53ecae7$var$formatProdErrorMessage(474)), $a971ebfca53ecae7$var$SuspenseActionException = Error($a971ebfca53ecae7$var$formatProdErrorMessage(542)), $a971ebfca53ecae7$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $a971ebfca53ecae7$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $a971ebfca53ecae7$var$noop$3() {}
function $a971ebfca53ecae7$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($a971ebfca53ecae7$var$noop$3, $a971ebfca53ecae7$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $a971ebfca53ecae7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($a971ebfca53ecae7$var$noop$3, $a971ebfca53ecae7$var$noop$3);
            else {
                thenableState = $a971ebfca53ecae7$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $a971ebfca53ecae7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $a971ebfca53ecae7$var$suspendedThenable = thenable;
            throw $a971ebfca53ecae7$var$SuspenseException;
    }
}
var $a971ebfca53ecae7$var$suspendedThenable = null;
function $a971ebfca53ecae7$var$getSuspendedThenable() {
    if (null === $a971ebfca53ecae7$var$suspendedThenable) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(459));
    var thenable = $a971ebfca53ecae7$var$suspendedThenable;
    $a971ebfca53ecae7$var$suspendedThenable = null;
    return thenable;
}
function $a971ebfca53ecae7$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $a971ebfca53ecae7$var$SuspenseException || rejectedReason === $a971ebfca53ecae7$var$SuspenseActionException) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(483));
}
var $a971ebfca53ecae7$var$hasForceUpdate = !1;
function $a971ebfca53ecae7$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $a971ebfca53ecae7$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $a971ebfca53ecae7$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a971ebfca53ecae7$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($a971ebfca53ecae7$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $a971ebfca53ecae7$var$getRootForUpdatedFiber(fiber);
        $a971ebfca53ecae7$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $a971ebfca53ecae7$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $a971ebfca53ecae7$var$getRootForUpdatedFiber(fiber);
}
function $a971ebfca53ecae7$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $a971ebfca53ecae7$var$markRootEntangled(root, lane);
    }
}
function $a971ebfca53ecae7$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $a971ebfca53ecae7$var$didReadFromEntangledAsyncAction = !1;
function $a971ebfca53ecae7$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($a971ebfca53ecae7$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $a971ebfca53ecae7$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $a971ebfca53ecae7$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $a971ebfca53ecae7$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $a971ebfca53ecae7$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $a971ebfca53ecae7$var$currentEntangledLane && ($a971ebfca53ecae7$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $a971ebfca53ecae7$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $a971ebfca53ecae7$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $a971ebfca53ecae7$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $a971ebfca53ecae7$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $a971ebfca53ecae7$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$a971ebfca53ecae7$var$callCallback(callbacks[updateQueue], context);
}
var $a971ebfca53ecae7$var$currentTreeHiddenStackCursor = $a971ebfca53ecae7$var$createCursor(null), $a971ebfca53ecae7$var$prevEntangledRenderLanesCursor = $a971ebfca53ecae7$var$createCursor(0);
function $a971ebfca53ecae7$var$pushHiddenContext(fiber, context) {
    fiber = $a971ebfca53ecae7$var$entangledRenderLanes;
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$prevEntangledRenderLanesCursor, fiber);
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$currentTreeHiddenStackCursor, context);
    $a971ebfca53ecae7$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $a971ebfca53ecae7$var$reuseHiddenContextOnStack() {
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$prevEntangledRenderLanesCursor, $a971ebfca53ecae7$var$entangledRenderLanes);
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$currentTreeHiddenStackCursor, $a971ebfca53ecae7$var$currentTreeHiddenStackCursor.current);
}
function $a971ebfca53ecae7$var$popHiddenContext() {
    $a971ebfca53ecae7$var$entangledRenderLanes = $a971ebfca53ecae7$var$prevEntangledRenderLanesCursor.current;
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$currentTreeHiddenStackCursor);
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$prevEntangledRenderLanesCursor);
}
var $a971ebfca53ecae7$var$renderLanes = 0, $a971ebfca53ecae7$var$currentlyRenderingFiber = null, $a971ebfca53ecae7$var$currentHook = null, $a971ebfca53ecae7$var$workInProgressHook = null, $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdate = !1, $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $a971ebfca53ecae7$var$localIdCounter = 0, $a971ebfca53ecae7$var$thenableIndexCounter$1 = 0, $a971ebfca53ecae7$var$thenableState$1 = null, $a971ebfca53ecae7$var$globalClientIdCounter = 0;
function $a971ebfca53ecae7$var$throwInvalidHookError() {
    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(321));
}
function $a971ebfca53ecae7$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$a971ebfca53ecae7$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $a971ebfca53ecae7$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $a971ebfca53ecae7$var$renderLanes = nextRenderLanes;
    $a971ebfca53ecae7$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $a971ebfca53ecae7$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $a971ebfca53ecae7$var$HooksDispatcherOnMount : $a971ebfca53ecae7$var$HooksDispatcherOnUpdate;
    $a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $a971ebfca53ecae7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $a971ebfca53ecae7$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $a971ebfca53ecae7$var$finishRenderingHooks(current) {
    $a971ebfca53ecae7$var$ReactSharedInternals.H = $a971ebfca53ecae7$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $a971ebfca53ecae7$var$currentHook && null !== $a971ebfca53ecae7$var$currentHook.next;
    $a971ebfca53ecae7$var$renderLanes = 0;
    $a971ebfca53ecae7$var$workInProgressHook = $a971ebfca53ecae7$var$currentHook = $a971ebfca53ecae7$var$currentlyRenderingFiber = null;
    $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdate = !1;
    $a971ebfca53ecae7$var$thenableIndexCounter$1 = 0;
    $a971ebfca53ecae7$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(300));
    null === current || $a971ebfca53ecae7$var$didReceiveUpdate || (current = current.dependencies, null !== current && $a971ebfca53ecae7$var$checkIfContextChanged(current) && ($a971ebfca53ecae7$var$didReceiveUpdate = !0));
}
function $a971ebfca53ecae7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $a971ebfca53ecae7$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdateDuringThisPass && ($a971ebfca53ecae7$var$thenableState$1 = null);
        $a971ebfca53ecae7$var$thenableIndexCounter$1 = 0;
        $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $a971ebfca53ecae7$var$workInProgressHook = $a971ebfca53ecae7$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $a971ebfca53ecae7$var$ReactSharedInternals.H = $a971ebfca53ecae7$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($a971ebfca53ecae7$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $a971ebfca53ecae7$var$TransitionAwareHostComponent() {
    var dispatcher = $a971ebfca53ecae7$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $a971ebfca53ecae7$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $a971ebfca53ecae7$var$currentHook ? $a971ebfca53ecae7$var$currentHook.memoizedState : null) !== dispatcher && ($a971ebfca53ecae7$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $a971ebfca53ecae7$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $a971ebfca53ecae7$var$localIdCounter;
    $a971ebfca53ecae7$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $a971ebfca53ecae7$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $a971ebfca53ecae7$var$resetHooksOnUnwind(workInProgress) {
    if ($a971ebfca53ecae7$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdate = !1;
    }
    $a971ebfca53ecae7$var$renderLanes = 0;
    $a971ebfca53ecae7$var$workInProgressHook = $a971ebfca53ecae7$var$currentHook = $a971ebfca53ecae7$var$currentlyRenderingFiber = null;
    $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $a971ebfca53ecae7$var$thenableIndexCounter$1 = $a971ebfca53ecae7$var$localIdCounter = 0;
    $a971ebfca53ecae7$var$thenableState$1 = null;
}
function $a971ebfca53ecae7$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a971ebfca53ecae7$var$workInProgressHook ? $a971ebfca53ecae7$var$currentlyRenderingFiber.memoizedState = $a971ebfca53ecae7$var$workInProgressHook = hook : $a971ebfca53ecae7$var$workInProgressHook = $a971ebfca53ecae7$var$workInProgressHook.next = hook;
    return $a971ebfca53ecae7$var$workInProgressHook;
}
function $a971ebfca53ecae7$var$updateWorkInProgressHook() {
    if (null === $a971ebfca53ecae7$var$currentHook) {
        var nextCurrentHook = $a971ebfca53ecae7$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $a971ebfca53ecae7$var$currentHook.next;
    var nextWorkInProgressHook = null === $a971ebfca53ecae7$var$workInProgressHook ? $a971ebfca53ecae7$var$currentlyRenderingFiber.memoizedState : $a971ebfca53ecae7$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $a971ebfca53ecae7$var$workInProgressHook = nextWorkInProgressHook, $a971ebfca53ecae7$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $a971ebfca53ecae7$var$currentlyRenderingFiber.alternate) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(467));
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(310));
        }
        $a971ebfca53ecae7$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $a971ebfca53ecae7$var$currentHook.memoizedState,
            baseState: $a971ebfca53ecae7$var$currentHook.baseState,
            baseQueue: $a971ebfca53ecae7$var$currentHook.baseQueue,
            queue: $a971ebfca53ecae7$var$currentHook.queue,
            next: null
        };
        null === $a971ebfca53ecae7$var$workInProgressHook ? $a971ebfca53ecae7$var$currentlyRenderingFiber.memoizedState = $a971ebfca53ecae7$var$workInProgressHook = nextCurrentHook : $a971ebfca53ecae7$var$workInProgressHook = $a971ebfca53ecae7$var$workInProgressHook.next = nextCurrentHook;
    }
    return $a971ebfca53ecae7$var$workInProgressHook;
}
function $a971ebfca53ecae7$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $a971ebfca53ecae7$var$useThenable(thenable) {
    var index = $a971ebfca53ecae7$var$thenableIndexCounter$1;
    $a971ebfca53ecae7$var$thenableIndexCounter$1 += 1;
    null === $a971ebfca53ecae7$var$thenableState$1 && ($a971ebfca53ecae7$var$thenableState$1 = []);
    thenable = $a971ebfca53ecae7$var$trackUsedThenable($a971ebfca53ecae7$var$thenableState$1, thenable, index);
    index = $a971ebfca53ecae7$var$currentlyRenderingFiber;
    null === (null === $a971ebfca53ecae7$var$workInProgressHook ? index.memoizedState : $a971ebfca53ecae7$var$workInProgressHook.next) && (index = index.alternate, $a971ebfca53ecae7$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $a971ebfca53ecae7$var$HooksDispatcherOnMount : $a971ebfca53ecae7$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $a971ebfca53ecae7$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $a971ebfca53ecae7$var$useThenable(usable);
        if (usable.$$typeof === $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE) return $a971ebfca53ecae7$var$readContext(usable);
    }
    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(438, String(usable)));
}
function $a971ebfca53ecae7$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $a971ebfca53ecae7$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $a971ebfca53ecae7$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $a971ebfca53ecae7$var$createFunctionComponentUpdateQueue(), $a971ebfca53ecae7$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $a971ebfca53ecae7$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $a971ebfca53ecae7$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $a971ebfca53ecae7$var$updateReducer(reducer) {
    var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
    return $a971ebfca53ecae7$var$updateReducerImpl(hook, $a971ebfca53ecae7$var$currentHook, reducer);
}
function $a971ebfca53ecae7$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($a971ebfca53ecae7$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $a971ebfca53ecae7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($a971ebfca53ecae7$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $a971ebfca53ecae7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $a971ebfca53ecae7$var$currentlyRenderingFiber.lanes |= revertLane, $a971ebfca53ecae7$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $a971ebfca53ecae7$var$currentlyRenderingFiber.lanes |= updateLane, $a971ebfca53ecae7$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$a971ebfca53ecae7$var$objectIs(pendingQueue, hook.memoizedState) && ($a971ebfca53ecae7$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $a971ebfca53ecae7$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $a971ebfca53ecae7$var$rerenderReducer(reducer) {
    var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $a971ebfca53ecae7$var$objectIs(newState, hook.memoizedState) || ($a971ebfca53ecae7$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $a971ebfca53ecae7$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $a971ebfca53ecae7$var$currentlyRenderingFiber, hook = $a971ebfca53ecae7$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $a971ebfca53ecae7$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$a971ebfca53ecae7$var$objectIs(($a971ebfca53ecae7$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $a971ebfca53ecae7$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $a971ebfca53ecae7$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $a971ebfca53ecae7$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $a971ebfca53ecae7$var$workInProgressHook && $a971ebfca53ecae7$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $a971ebfca53ecae7$var$pushSimpleEffect(9, $a971ebfca53ecae7$var$createEffectInstance(), $a971ebfca53ecae7$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $a971ebfca53ecae7$var$workInProgressRoot) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($a971ebfca53ecae7$var$renderLanes & 124) || $a971ebfca53ecae7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $a971ebfca53ecae7$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $a971ebfca53ecae7$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $a971ebfca53ecae7$var$createFunctionComponentUpdateQueue(), $a971ebfca53ecae7$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $a971ebfca53ecae7$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $a971ebfca53ecae7$var$checkIfSnapshotChanged(inst) && $a971ebfca53ecae7$var$forceStoreRerender(fiber);
}
function $a971ebfca53ecae7$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $a971ebfca53ecae7$var$checkIfSnapshotChanged(inst) && $a971ebfca53ecae7$var$forceStoreRerender(fiber);
    });
}
function $a971ebfca53ecae7$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$a971ebfca53ecae7$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $a971ebfca53ecae7$var$forceStoreRerender(fiber) {
    var root = $a971ebfca53ecae7$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $a971ebfca53ecae7$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $a971ebfca53ecae7$var$mountStateImpl(initialState) {
    var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a971ebfca53ecae7$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $a971ebfca53ecae7$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $a971ebfca53ecae7$var$updateReducerImpl(hook, $a971ebfca53ecae7$var$currentHook, "function" === typeof reducer ? reducer : $a971ebfca53ecae7$var$basicStateReducer);
}
function $a971ebfca53ecae7$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($a971ebfca53ecae7$var$isRenderPhaseUpdate(fiber)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $a971ebfca53ecae7$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $a971ebfca53ecae7$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $a971ebfca53ecae7$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $a971ebfca53ecae7$var$ReactSharedInternals.T, currentTransition = {};
        $a971ebfca53ecae7$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $a971ebfca53ecae7$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $a971ebfca53ecae7$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $a971ebfca53ecae7$var$onActionError(actionQueue, node, error);
        } finally{
            $a971ebfca53ecae7$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $a971ebfca53ecae7$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $a971ebfca53ecae7$var$onActionError(actionQueue, node, error$38);
    }
}
function $a971ebfca53ecae7$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $a971ebfca53ecae7$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $a971ebfca53ecae7$var$onActionError(actionQueue, node, error);
    }) : $a971ebfca53ecae7$var$onActionSuccess(actionQueue, node, returnValue);
}
function $a971ebfca53ecae7$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $a971ebfca53ecae7$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $a971ebfca53ecae7$var$runActionStateAction(actionQueue, nextState)));
}
function $a971ebfca53ecae7$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $a971ebfca53ecae7$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $a971ebfca53ecae7$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $a971ebfca53ecae7$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $a971ebfca53ecae7$var$mountActionState(action, initialStateProp) {
    if ($a971ebfca53ecae7$var$isHydrating) {
        var ssrFormState = $a971ebfca53ecae7$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $a971ebfca53ecae7$var$currentlyRenderingFiber;
                if ($a971ebfca53ecae7$var$isHydrating) {
                    if ($a971ebfca53ecae7$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $a971ebfca53ecae7$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $a971ebfca53ecae7$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $a971ebfca53ecae7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $a971ebfca53ecae7$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $a971ebfca53ecae7$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a971ebfca53ecae7$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $a971ebfca53ecae7$var$dispatchSetState.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $a971ebfca53ecae7$var$mountStateImpl(!1);
    inRootOrSingleton = $a971ebfca53ecae7$var$dispatchOptimisticSetState.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $a971ebfca53ecae7$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $a971ebfca53ecae7$var$dispatchActionState.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $a971ebfca53ecae7$var$updateActionState(action) {
    var stateHook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
    return $a971ebfca53ecae7$var$updateActionStateImpl(stateHook, $a971ebfca53ecae7$var$currentHook, action);
}
function $a971ebfca53ecae7$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $a971ebfca53ecae7$var$updateReducerImpl(stateHook, currentStateHook, $a971ebfca53ecae7$var$actionStateReducer)[0];
    stateHook = $a971ebfca53ecae7$var$updateReducer($a971ebfca53ecae7$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $a971ebfca53ecae7$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $a971ebfca53ecae7$var$SuspenseException) throw $a971ebfca53ecae7$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($a971ebfca53ecae7$var$currentlyRenderingFiber.flags |= 2048, $a971ebfca53ecae7$var$pushSimpleEffect(9, $a971ebfca53ecae7$var$createEffectInstance(), $a971ebfca53ecae7$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $a971ebfca53ecae7$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $a971ebfca53ecae7$var$rerenderActionState(action) {
    var stateHook = $a971ebfca53ecae7$var$updateWorkInProgressHook(), currentStateHook = $a971ebfca53ecae7$var$currentHook;
    if (null !== currentStateHook) return $a971ebfca53ecae7$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $a971ebfca53ecae7$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $a971ebfca53ecae7$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $a971ebfca53ecae7$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $a971ebfca53ecae7$var$createFunctionComponentUpdateQueue(), $a971ebfca53ecae7$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $a971ebfca53ecae7$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $a971ebfca53ecae7$var$updateRef() {
    return $a971ebfca53ecae7$var$updateWorkInProgressHook().memoizedState;
}
function $a971ebfca53ecae7$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $a971ebfca53ecae7$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $a971ebfca53ecae7$var$pushSimpleEffect(1 | hookFlags, $a971ebfca53ecae7$var$createEffectInstance(), create, createDeps);
}
function $a971ebfca53ecae7$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $a971ebfca53ecae7$var$currentHook && null !== deps && $a971ebfca53ecae7$var$areHookInputsEqual(deps, $a971ebfca53ecae7$var$currentHook.memoizedState.deps) ? hook.memoizedState = $a971ebfca53ecae7$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($a971ebfca53ecae7$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $a971ebfca53ecae7$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $a971ebfca53ecae7$var$mountEffect(create, createDeps) {
    $a971ebfca53ecae7$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $a971ebfca53ecae7$var$updateEffect(create, createDeps) {
    $a971ebfca53ecae7$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $a971ebfca53ecae7$var$updateInsertionEffect(create, deps) {
    return $a971ebfca53ecae7$var$updateEffectImpl(4, 2, create, deps);
}
function $a971ebfca53ecae7$var$updateLayoutEffect(create, deps) {
    return $a971ebfca53ecae7$var$updateEffectImpl(4, 4, create, deps);
}
function $a971ebfca53ecae7$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $a971ebfca53ecae7$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $a971ebfca53ecae7$var$updateEffectImpl(4, 4, $a971ebfca53ecae7$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $a971ebfca53ecae7$var$mountDebugValue() {}
function $a971ebfca53ecae7$var$updateCallback(callback, deps) {
    var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $a971ebfca53ecae7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $a971ebfca53ecae7$var$updateMemo(nextCreate, deps) {
    var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $a971ebfca53ecae7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $a971ebfca53ecae7$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($a971ebfca53ecae7$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $a971ebfca53ecae7$var$requestDeferredLane();
    $a971ebfca53ecae7$var$currentlyRenderingFiber.lanes |= hook;
    $a971ebfca53ecae7$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $a971ebfca53ecae7$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($a971ebfca53ecae7$var$objectIs(value, prevValue)) return value;
    if (null !== $a971ebfca53ecae7$var$currentTreeHiddenStackCursor.current) return hook = $a971ebfca53ecae7$var$mountDeferredValueImpl(hook, value, initialValue), $a971ebfca53ecae7$var$objectIs(hook, prevValue) || ($a971ebfca53ecae7$var$didReceiveUpdate = !0), hook;
    if (0 === ($a971ebfca53ecae7$var$renderLanes & 42)) return $a971ebfca53ecae7$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $a971ebfca53ecae7$var$requestDeferredLane();
    $a971ebfca53ecae7$var$currentlyRenderingFiber.lanes |= hook;
    $a971ebfca53ecae7$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $a971ebfca53ecae7$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
    $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $a971ebfca53ecae7$var$ReactSharedInternals.T, currentTransition = {};
    $a971ebfca53ecae7$var$ReactSharedInternals.T = currentTransition;
    $a971ebfca53ecae7$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $a971ebfca53ecae7$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $a971ebfca53ecae7$var$chainThenableValue(returnValue, finishedState);
            $a971ebfca53ecae7$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $a971ebfca53ecae7$var$requestUpdateLane(fiber));
        } else $a971ebfca53ecae7$var$dispatchSetStateInternal(fiber, queue, finishedState, $a971ebfca53ecae7$var$requestUpdateLane(fiber));
    } catch (error) {
        $a971ebfca53ecae7$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $a971ebfca53ecae7$var$requestUpdateLane());
    } finally{
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = previousPriority, $a971ebfca53ecae7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a971ebfca53ecae7$var$noop$2() {}
function $a971ebfca53ecae7$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(476));
    var queue = $a971ebfca53ecae7$var$ensureFormComponentIsStateful(formFiber).queue;
    $a971ebfca53ecae7$var$startTransition(formFiber, queue, pendingState, $a971ebfca53ecae7$var$sharedNotPendingObject, null === action ? $a971ebfca53ecae7$var$noop$2 : function() {
        $a971ebfca53ecae7$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $a971ebfca53ecae7$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $a971ebfca53ecae7$var$sharedNotPendingObject,
        baseState: $a971ebfca53ecae7$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $a971ebfca53ecae7$var$basicStateReducer,
            lastRenderedState: $a971ebfca53ecae7$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $a971ebfca53ecae7$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $a971ebfca53ecae7$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $a971ebfca53ecae7$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $a971ebfca53ecae7$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $a971ebfca53ecae7$var$requestUpdateLane());
}
function $a971ebfca53ecae7$var$useHostTransitionStatus() {
    return $a971ebfca53ecae7$var$readContext($a971ebfca53ecae7$var$HostTransitionContext);
}
function $a971ebfca53ecae7$var$updateId() {
    return $a971ebfca53ecae7$var$updateWorkInProgressHook().memoizedState;
}
function $a971ebfca53ecae7$var$updateRefresh() {
    return $a971ebfca53ecae7$var$updateWorkInProgressHook().memoizedState;
}
function $a971ebfca53ecae7$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $a971ebfca53ecae7$var$requestUpdateLane();
                fiber = $a971ebfca53ecae7$var$createUpdate(lane);
                var root$41 = $a971ebfca53ecae7$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($a971ebfca53ecae7$var$scheduleUpdateOnFiber(root$41, provider, lane), $a971ebfca53ecae7$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $a971ebfca53ecae7$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $a971ebfca53ecae7$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $a971ebfca53ecae7$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $a971ebfca53ecae7$var$isRenderPhaseUpdate(fiber) ? $a971ebfca53ecae7$var$enqueueRenderPhaseUpdate(queue, action) : (action = $a971ebfca53ecae7$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($a971ebfca53ecae7$var$scheduleUpdateOnFiber(action, fiber, lane), $a971ebfca53ecae7$var$entangleTransitionUpdate(action, queue, lane)));
}
function $a971ebfca53ecae7$var$dispatchSetState(fiber, queue, action) {
    var lane = $a971ebfca53ecae7$var$requestUpdateLane();
    $a971ebfca53ecae7$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $a971ebfca53ecae7$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a971ebfca53ecae7$var$isRenderPhaseUpdate(fiber)) $a971ebfca53ecae7$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($a971ebfca53ecae7$var$objectIs(eagerState, currentState)) return $a971ebfca53ecae7$var$enqueueUpdate$1(fiber, queue, update, 0), null === $a971ebfca53ecae7$var$workInProgressRoot && $a971ebfca53ecae7$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $a971ebfca53ecae7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $a971ebfca53ecae7$var$scheduleUpdateOnFiber(action, fiber, lane), $a971ebfca53ecae7$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $a971ebfca53ecae7$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $a971ebfca53ecae7$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a971ebfca53ecae7$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $a971ebfca53ecae7$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $a971ebfca53ecae7$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $a971ebfca53ecae7$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $a971ebfca53ecae7$var$currentlyRenderingFiber || null !== alternate && alternate === $a971ebfca53ecae7$var$currentlyRenderingFiber;
}
function $a971ebfca53ecae7$var$enqueueRenderPhaseUpdate(queue, update) {
    $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdateDuringThisPass = $a971ebfca53ecae7$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $a971ebfca53ecae7$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $a971ebfca53ecae7$var$markRootEntangled(root, lane);
    }
}
var $a971ebfca53ecae7$var$ContextOnlyDispatcher = {
    readContext: $a971ebfca53ecae7$var$readContext,
    use: $a971ebfca53ecae7$var$use,
    useCallback: $a971ebfca53ecae7$var$throwInvalidHookError,
    useContext: $a971ebfca53ecae7$var$throwInvalidHookError,
    useEffect: $a971ebfca53ecae7$var$throwInvalidHookError,
    useImperativeHandle: $a971ebfca53ecae7$var$throwInvalidHookError,
    useLayoutEffect: $a971ebfca53ecae7$var$throwInvalidHookError,
    useInsertionEffect: $a971ebfca53ecae7$var$throwInvalidHookError,
    useMemo: $a971ebfca53ecae7$var$throwInvalidHookError,
    useReducer: $a971ebfca53ecae7$var$throwInvalidHookError,
    useRef: $a971ebfca53ecae7$var$throwInvalidHookError,
    useState: $a971ebfca53ecae7$var$throwInvalidHookError,
    useDebugValue: $a971ebfca53ecae7$var$throwInvalidHookError,
    useDeferredValue: $a971ebfca53ecae7$var$throwInvalidHookError,
    useTransition: $a971ebfca53ecae7$var$throwInvalidHookError,
    useSyncExternalStore: $a971ebfca53ecae7$var$throwInvalidHookError,
    useId: $a971ebfca53ecae7$var$throwInvalidHookError,
    useHostTransitionStatus: $a971ebfca53ecae7$var$throwInvalidHookError,
    useFormState: $a971ebfca53ecae7$var$throwInvalidHookError,
    useActionState: $a971ebfca53ecae7$var$throwInvalidHookError,
    useOptimistic: $a971ebfca53ecae7$var$throwInvalidHookError,
    useMemoCache: $a971ebfca53ecae7$var$throwInvalidHookError,
    useCacheRefresh: $a971ebfca53ecae7$var$throwInvalidHookError
}, $a971ebfca53ecae7$var$HooksDispatcherOnMount = {
    readContext: $a971ebfca53ecae7$var$readContext,
    use: $a971ebfca53ecae7$var$use,
    useCallback: function(callback, deps) {
        $a971ebfca53ecae7$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $a971ebfca53ecae7$var$readContext,
    useEffect: $a971ebfca53ecae7$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $a971ebfca53ecae7$var$mountEffectImpl(4194308, 4, $a971ebfca53ecae7$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $a971ebfca53ecae7$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $a971ebfca53ecae7$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($a971ebfca53ecae7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $a971ebfca53ecae7$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $a971ebfca53ecae7$var$dispatchReducerAction.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $a971ebfca53ecae7$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $a971ebfca53ecae7$var$dispatchSetState.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $a971ebfca53ecae7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
        return $a971ebfca53ecae7$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $a971ebfca53ecae7$var$mountStateImpl(!1);
        stateHook = $a971ebfca53ecae7$var$startTransition.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $a971ebfca53ecae7$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $a971ebfca53ecae7$var$currentlyRenderingFiber, hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
        if ($a971ebfca53ecae7$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $a971ebfca53ecae7$var$workInProgressRoot) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(349));
            0 !== ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 124) || $a971ebfca53ecae7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $a971ebfca53ecae7$var$mountEffect($a971ebfca53ecae7$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $a971ebfca53ecae7$var$pushSimpleEffect(9, $a971ebfca53ecae7$var$createEffectInstance(), $a971ebfca53ecae7$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook(), identifierPrefix = $a971ebfca53ecae7$var$workInProgressRoot.identifierPrefix;
        if ($a971ebfca53ecae7$var$isHydrating) {
            var JSCompiler_inline_result = $a971ebfca53ecae7$var$treeContextOverflow;
            var idWithLeadingBit = $a971ebfca53ecae7$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $a971ebfca53ecae7$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $a971ebfca53ecae7$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $a971ebfca53ecae7$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $a971ebfca53ecae7$var$useHostTransitionStatus,
    useFormState: $a971ebfca53ecae7$var$mountActionState,
    useActionState: $a971ebfca53ecae7$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $a971ebfca53ecae7$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $a971ebfca53ecae7$var$dispatchOptimisticSetState.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $a971ebfca53ecae7$var$useMemoCache,
    useCacheRefresh: function() {
        return $a971ebfca53ecae7$var$mountWorkInProgressHook().memoizedState = $a971ebfca53ecae7$var$refreshCache.bind(null, $a971ebfca53ecae7$var$currentlyRenderingFiber);
    }
}, $a971ebfca53ecae7$var$HooksDispatcherOnUpdate = {
    readContext: $a971ebfca53ecae7$var$readContext,
    use: $a971ebfca53ecae7$var$use,
    useCallback: $a971ebfca53ecae7$var$updateCallback,
    useContext: $a971ebfca53ecae7$var$readContext,
    useEffect: $a971ebfca53ecae7$var$updateEffect,
    useImperativeHandle: $a971ebfca53ecae7$var$updateImperativeHandle,
    useInsertionEffect: $a971ebfca53ecae7$var$updateInsertionEffect,
    useLayoutEffect: $a971ebfca53ecae7$var$updateLayoutEffect,
    useMemo: $a971ebfca53ecae7$var$updateMemo,
    useReducer: $a971ebfca53ecae7$var$updateReducer,
    useRef: $a971ebfca53ecae7$var$updateRef,
    useState: function() {
        return $a971ebfca53ecae7$var$updateReducer($a971ebfca53ecae7$var$basicStateReducer);
    },
    useDebugValue: $a971ebfca53ecae7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
        return $a971ebfca53ecae7$var$updateDeferredValueImpl(hook, $a971ebfca53ecae7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $a971ebfca53ecae7$var$updateReducer($a971ebfca53ecae7$var$basicStateReducer)[0], start = $a971ebfca53ecae7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $a971ebfca53ecae7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $a971ebfca53ecae7$var$updateSyncExternalStore,
    useId: $a971ebfca53ecae7$var$updateId,
    useHostTransitionStatus: $a971ebfca53ecae7$var$useHostTransitionStatus,
    useFormState: $a971ebfca53ecae7$var$updateActionState,
    useActionState: $a971ebfca53ecae7$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
        return $a971ebfca53ecae7$var$updateOptimisticImpl(hook, $a971ebfca53ecae7$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $a971ebfca53ecae7$var$useMemoCache,
    useCacheRefresh: $a971ebfca53ecae7$var$updateRefresh
}, $a971ebfca53ecae7$var$HooksDispatcherOnRerender = {
    readContext: $a971ebfca53ecae7$var$readContext,
    use: $a971ebfca53ecae7$var$use,
    useCallback: $a971ebfca53ecae7$var$updateCallback,
    useContext: $a971ebfca53ecae7$var$readContext,
    useEffect: $a971ebfca53ecae7$var$updateEffect,
    useImperativeHandle: $a971ebfca53ecae7$var$updateImperativeHandle,
    useInsertionEffect: $a971ebfca53ecae7$var$updateInsertionEffect,
    useLayoutEffect: $a971ebfca53ecae7$var$updateLayoutEffect,
    useMemo: $a971ebfca53ecae7$var$updateMemo,
    useReducer: $a971ebfca53ecae7$var$rerenderReducer,
    useRef: $a971ebfca53ecae7$var$updateRef,
    useState: function() {
        return $a971ebfca53ecae7$var$rerenderReducer($a971ebfca53ecae7$var$basicStateReducer);
    },
    useDebugValue: $a971ebfca53ecae7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
        return null === $a971ebfca53ecae7$var$currentHook ? $a971ebfca53ecae7$var$mountDeferredValueImpl(hook, value, initialValue) : $a971ebfca53ecae7$var$updateDeferredValueImpl(hook, $a971ebfca53ecae7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $a971ebfca53ecae7$var$rerenderReducer($a971ebfca53ecae7$var$basicStateReducer)[0], start = $a971ebfca53ecae7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $a971ebfca53ecae7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $a971ebfca53ecae7$var$updateSyncExternalStore,
    useId: $a971ebfca53ecae7$var$updateId,
    useHostTransitionStatus: $a971ebfca53ecae7$var$useHostTransitionStatus,
    useFormState: $a971ebfca53ecae7$var$rerenderActionState,
    useActionState: $a971ebfca53ecae7$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $a971ebfca53ecae7$var$updateWorkInProgressHook();
        if (null !== $a971ebfca53ecae7$var$currentHook) return $a971ebfca53ecae7$var$updateOptimisticImpl(hook, $a971ebfca53ecae7$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $a971ebfca53ecae7$var$useMemoCache,
    useCacheRefresh: $a971ebfca53ecae7$var$updateRefresh
}, $a971ebfca53ecae7$var$thenableState = null, $a971ebfca53ecae7$var$thenableIndexCounter = 0;
function $a971ebfca53ecae7$var$unwrapThenable(thenable) {
    var index = $a971ebfca53ecae7$var$thenableIndexCounter;
    $a971ebfca53ecae7$var$thenableIndexCounter += 1;
    null === $a971ebfca53ecae7$var$thenableState && ($a971ebfca53ecae7$var$thenableState = []);
    return $a971ebfca53ecae7$var$trackUsedThenable($a971ebfca53ecae7$var$thenableState, thenable, index);
}
function $a971ebfca53ecae7$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $a971ebfca53ecae7$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $a971ebfca53ecae7$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $a971ebfca53ecae7$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $a971ebfca53ecae7$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $a971ebfca53ecae7$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $a971ebfca53ecae7$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $a971ebfca53ecae7$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $a971ebfca53ecae7$var$REACT_LAZY_TYPE && $a971ebfca53ecae7$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $a971ebfca53ecae7$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $a971ebfca53ecae7$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $a971ebfca53ecae7$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $a971ebfca53ecae7$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $a971ebfca53ecae7$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $a971ebfca53ecae7$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a971ebfca53ecae7$var$REACT_ELEMENT_TYPE:
                    return lanes = $a971ebfca53ecae7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $a971ebfca53ecae7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $a971ebfca53ecae7$var$REACT_PORTAL_TYPE:
                    return newChild = $a971ebfca53ecae7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $a971ebfca53ecae7$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($a971ebfca53ecae7$var$isArrayImpl(newChild) || $a971ebfca53ecae7$var$getIteratorFn(newChild)) return newChild = $a971ebfca53ecae7$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $a971ebfca53ecae7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $a971ebfca53ecae7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a971ebfca53ecae7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a971ebfca53ecae7$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $a971ebfca53ecae7$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $a971ebfca53ecae7$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($a971ebfca53ecae7$var$isArrayImpl(newChild) || $a971ebfca53ecae7$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $a971ebfca53ecae7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $a971ebfca53ecae7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a971ebfca53ecae7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a971ebfca53ecae7$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $a971ebfca53ecae7$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $a971ebfca53ecae7$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($a971ebfca53ecae7$var$isArrayImpl(newChild) || $a971ebfca53ecae7$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $a971ebfca53ecae7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $a971ebfca53ecae7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a971ebfca53ecae7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $a971ebfca53ecae7$var$isHydrating && $a971ebfca53ecae7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $a971ebfca53ecae7$var$isHydrating && $a971ebfca53ecae7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $a971ebfca53ecae7$var$isHydrating && $a971ebfca53ecae7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $a971ebfca53ecae7$var$isHydrating && $a971ebfca53ecae7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $a971ebfca53ecae7$var$isHydrating && $a971ebfca53ecae7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $a971ebfca53ecae7$var$isHydrating && $a971ebfca53ecae7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $a971ebfca53ecae7$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $a971ebfca53ecae7$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $a971ebfca53ecae7$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $a971ebfca53ecae7$var$REACT_LAZY_TYPE && $a971ebfca53ecae7$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $a971ebfca53ecae7$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $a971ebfca53ecae7$var$REACT_FRAGMENT_TYPE ? (lanes = $a971ebfca53ecae7$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $a971ebfca53ecae7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $a971ebfca53ecae7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $a971ebfca53ecae7$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $a971ebfca53ecae7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $a971ebfca53ecae7$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($a971ebfca53ecae7$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($a971ebfca53ecae7$var$getIteratorFn(newChild)) {
                key = $a971ebfca53ecae7$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $a971ebfca53ecae7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $a971ebfca53ecae7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a971ebfca53ecae7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $a971ebfca53ecae7$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $a971ebfca53ecae7$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $a971ebfca53ecae7$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $a971ebfca53ecae7$var$SuspenseException || x === $a971ebfca53ecae7$var$SuspenseActionException) throw x;
            var fiber = $a971ebfca53ecae7$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $a971ebfca53ecae7$var$reconcileChildFibers = $a971ebfca53ecae7$var$createChildReconciler(!0), $a971ebfca53ecae7$var$mountChildFibers = $a971ebfca53ecae7$var$createChildReconciler(!1), $a971ebfca53ecae7$var$suspenseHandlerStackCursor = $a971ebfca53ecae7$var$createCursor(null), $a971ebfca53ecae7$var$shellBoundary = null;
function $a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseStackCursor, $a971ebfca53ecae7$var$suspenseStackCursor.current & 1);
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseHandlerStackCursor, handler);
    null === $a971ebfca53ecae7$var$shellBoundary && (null === current || null !== $a971ebfca53ecae7$var$currentTreeHiddenStackCursor.current ? $a971ebfca53ecae7$var$shellBoundary = handler : null !== current.memoizedState && ($a971ebfca53ecae7$var$shellBoundary = handler));
}
function $a971ebfca53ecae7$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseStackCursor, $a971ebfca53ecae7$var$suspenseStackCursor.current), $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseHandlerStackCursor, fiber), null === $a971ebfca53ecae7$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($a971ebfca53ecae7$var$shellBoundary = fiber);
        }
    } else $a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(fiber);
}
function $a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack() {
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseStackCursor, $a971ebfca53ecae7$var$suspenseStackCursor.current);
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseHandlerStackCursor, $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current);
}
function $a971ebfca53ecae7$var$popSuspenseHandler(fiber) {
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$suspenseHandlerStackCursor);
    $a971ebfca53ecae7$var$shellBoundary === fiber && ($a971ebfca53ecae7$var$shellBoundary = null);
    $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$suspenseStackCursor);
}
var $a971ebfca53ecae7$var$suspenseStackCursor = $a971ebfca53ecae7$var$createCursor(0);
function $a971ebfca53ecae7$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $a971ebfca53ecae7$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $a971ebfca53ecae7$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $a971ebfca53ecae7$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $a971ebfca53ecae7$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $a971ebfca53ecae7$var$requestUpdateLane(), update = $a971ebfca53ecae7$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $a971ebfca53ecae7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($a971ebfca53ecae7$var$scheduleUpdateOnFiber(payload, inst, lane), $a971ebfca53ecae7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $a971ebfca53ecae7$var$requestUpdateLane(), update = $a971ebfca53ecae7$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $a971ebfca53ecae7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($a971ebfca53ecae7$var$scheduleUpdateOnFiber(payload, inst, lane), $a971ebfca53ecae7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $a971ebfca53ecae7$var$requestUpdateLane(), update = $a971ebfca53ecae7$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $a971ebfca53ecae7$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($a971ebfca53ecae7$var$scheduleUpdateOnFiber(callback, inst, lane), $a971ebfca53ecae7$var$entangleTransitions(callback, inst, lane));
    }
};
function $a971ebfca53ecae7$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$a971ebfca53ecae7$var$shallowEqual(oldProps, newProps) || !$a971ebfca53ecae7$var$shallowEqual(oldState, newState) : !0;
}
function $a971ebfca53ecae7$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $a971ebfca53ecae7$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $a971ebfca53ecae7$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $a971ebfca53ecae7$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $a971ebfca53ecae7$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $a971ebfca53ecae7$var$defaultOnUncaughtError(error) {
    $a971ebfca53ecae7$var$reportGlobalError(error);
}
function $a971ebfca53ecae7$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $a971ebfca53ecae7$var$defaultOnRecoverableError(error) {
    $a971ebfca53ecae7$var$reportGlobalError(error);
}
function $a971ebfca53ecae7$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $a971ebfca53ecae7$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $a971ebfca53ecae7$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $a971ebfca53ecae7$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $a971ebfca53ecae7$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $a971ebfca53ecae7$var$createClassErrorUpdate(lane) {
    lane = $a971ebfca53ecae7$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $a971ebfca53ecae7$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $a971ebfca53ecae7$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $a971ebfca53ecae7$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed ? $a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $a971ebfca53ecae7$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $a971ebfca53ecae7$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $a971ebfca53ecae7$var$shellBoundary ? $a971ebfca53ecae7$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $a971ebfca53ecae7$var$workInProgressRootExitStatus && ($a971ebfca53ecae7$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $a971ebfca53ecae7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $a971ebfca53ecae7$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $a971ebfca53ecae7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $a971ebfca53ecae7$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $a971ebfca53ecae7$var$attachPingListener(root, value, rootRenderLanes);
        $a971ebfca53ecae7$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($a971ebfca53ecae7$var$isHydrating) return returnFiber = $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $a971ebfca53ecae7$var$HydrationMismatchException && (root = Error($a971ebfca53ecae7$var$formatProdErrorMessage(422), {
        cause: value
    }), $a971ebfca53ecae7$var$queueHydrationError($a971ebfca53ecae7$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $a971ebfca53ecae7$var$HydrationMismatchException && (returnFiber = Error($a971ebfca53ecae7$var$formatProdErrorMessage(423), {
        cause: value
    }), $a971ebfca53ecae7$var$queueHydrationError($a971ebfca53ecae7$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $a971ebfca53ecae7$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $a971ebfca53ecae7$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $a971ebfca53ecae7$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $a971ebfca53ecae7$var$workInProgressRootExitStatus && ($a971ebfca53ecae7$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($a971ebfca53ecae7$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $a971ebfca53ecae7$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $a971ebfca53ecae7$var$workInProgressRootConcurrentErrors ? $a971ebfca53ecae7$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $a971ebfca53ecae7$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $a971ebfca53ecae7$var$workInProgressRootExitStatus && ($a971ebfca53ecae7$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $a971ebfca53ecae7$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $a971ebfca53ecae7$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $a971ebfca53ecae7$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed || !$a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $a971ebfca53ecae7$var$createClassErrorUpdate(rootRenderLanes), $a971ebfca53ecae7$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $a971ebfca53ecae7$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $a971ebfca53ecae7$var$SelectiveHydrationException = Error($a971ebfca53ecae7$var$formatProdErrorMessage(461)), $a971ebfca53ecae7$var$didReceiveUpdate = !1;
function $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $a971ebfca53ecae7$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $a971ebfca53ecae7$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $a971ebfca53ecae7$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $a971ebfca53ecae7$var$prepareToReadContext(workInProgress);
    nextProps = $a971ebfca53ecae7$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $a971ebfca53ecae7$var$checkDidRenderIdHook();
    if (null !== current && !$a971ebfca53ecae7$var$didReceiveUpdate) return $a971ebfca53ecae7$var$bailoutHooks(current, workInProgress, renderLanes), $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a971ebfca53ecae7$var$isHydrating && key && $a971ebfca53ecae7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $a971ebfca53ecae7$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$a971ebfca53ecae7$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $a971ebfca53ecae7$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $a971ebfca53ecae7$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$a971ebfca53ecae7$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $a971ebfca53ecae7$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $a971ebfca53ecae7$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $a971ebfca53ecae7$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($a971ebfca53ecae7$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($a971ebfca53ecae7$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $a971ebfca53ecae7$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($a971ebfca53ecae7$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $a971ebfca53ecae7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $a971ebfca53ecae7$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $a971ebfca53ecae7$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $a971ebfca53ecae7$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $a971ebfca53ecae7$var$pushHiddenContext(workInProgress, prevState) : $a971ebfca53ecae7$var$reuseHiddenContextOnStack(), $a971ebfca53ecae7$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $a971ebfca53ecae7$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($a971ebfca53ecae7$var$pushTransition(workInProgress, prevState.cachePool), $a971ebfca53ecae7$var$pushHiddenContext(workInProgress, prevState), $a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $a971ebfca53ecae7$var$pushTransition(workInProgress, null), $a971ebfca53ecae7$var$reuseHiddenContextOnStack(), $a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(workInProgress));
    $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $a971ebfca53ecae7$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $a971ebfca53ecae7$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $a971ebfca53ecae7$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $a971ebfca53ecae7$var$pushTransition(workInProgress, null);
    $a971ebfca53ecae7$var$reuseHiddenContextOnStack();
    $a971ebfca53ecae7$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $a971ebfca53ecae7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $a971ebfca53ecae7$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $a971ebfca53ecae7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $a971ebfca53ecae7$var$prepareToReadContext(workInProgress);
    Component = $a971ebfca53ecae7$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $a971ebfca53ecae7$var$checkDidRenderIdHook();
    if (null !== current && !$a971ebfca53ecae7$var$didReceiveUpdate) return $a971ebfca53ecae7$var$bailoutHooks(current, workInProgress, renderLanes), $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a971ebfca53ecae7$var$isHydrating && nextProps && $a971ebfca53ecae7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $a971ebfca53ecae7$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $a971ebfca53ecae7$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $a971ebfca53ecae7$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $a971ebfca53ecae7$var$finishRenderingHooks(current);
    Component = $a971ebfca53ecae7$var$checkDidRenderIdHook();
    if (null !== current && !$a971ebfca53ecae7$var$didReceiveUpdate) return $a971ebfca53ecae7$var$bailoutHooks(current, workInProgress, renderLanes), $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a971ebfca53ecae7$var$isHydrating && Component && $a971ebfca53ecae7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $a971ebfca53ecae7$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $a971ebfca53ecae7$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $a971ebfca53ecae7$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $a971ebfca53ecae7$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $a971ebfca53ecae7$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $a971ebfca53ecae7$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $a971ebfca53ecae7$var$readContext(contextType) : $a971ebfca53ecae7$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($a971ebfca53ecae7$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $a971ebfca53ecae7$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $a971ebfca53ecae7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $a971ebfca53ecae7$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $a971ebfca53ecae7$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $a971ebfca53ecae7$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $a971ebfca53ecae7$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $a971ebfca53ecae7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $a971ebfca53ecae7$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $a971ebfca53ecae7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $a971ebfca53ecae7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $a971ebfca53ecae7$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($a971ebfca53ecae7$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $a971ebfca53ecae7$var$hasForceUpdate || $a971ebfca53ecae7$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $a971ebfca53ecae7$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $a971ebfca53ecae7$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $a971ebfca53ecae7$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $a971ebfca53ecae7$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $a971ebfca53ecae7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $a971ebfca53ecae7$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $a971ebfca53ecae7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $a971ebfca53ecae7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $a971ebfca53ecae7$var$hasForceUpdate || null !== current && null !== current.dependencies && $a971ebfca53ecae7$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($a971ebfca53ecae7$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $a971ebfca53ecae7$var$hasForceUpdate || $a971ebfca53ecae7$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $a971ebfca53ecae7$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $a971ebfca53ecae7$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $a971ebfca53ecae7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $a971ebfca53ecae7$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $a971ebfca53ecae7$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $a971ebfca53ecae7$var$resetHydrationState();
    workInProgress.flags |= 256;
    $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $a971ebfca53ecae7$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $a971ebfca53ecae7$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $a971ebfca53ecae7$var$getSuspendedCache()
    };
}
function $a971ebfca53ecae7$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $a971ebfca53ecae7$var$workInProgressDeferredLane);
    return current;
}
function $a971ebfca53ecae7$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($a971ebfca53ecae7$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($a971ebfca53ecae7$var$isHydrating) {
            showFallback ? $a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($a971ebfca53ecae7$var$isHydrating) {
                var nextInstance = $a971ebfca53ecae7$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $a971ebfca53ecae7$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $a971ebfca53ecae7$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $a971ebfca53ecae7$var$treeContextProvider ? {
                            id: $a971ebfca53ecae7$var$treeContextId,
                            overflow: $a971ebfca53ecae7$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $a971ebfca53ecae7$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $a971ebfca53ecae7$var$hydrationParentFiber = workInProgress, $a971ebfca53ecae7$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $a971ebfca53ecae7$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $a971ebfca53ecae7$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $a971ebfca53ecae7$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $a971ebfca53ecae7$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $a971ebfca53ecae7$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $a971ebfca53ecae7$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $a971ebfca53ecae7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a971ebfca53ecae7$var$SUSPENDED_MARKER, nextProps;
        $a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $a971ebfca53ecae7$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $a971ebfca53ecae7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $a971ebfca53ecae7$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $a971ebfca53ecae7$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $a971ebfca53ecae7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $a971ebfca53ecae7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $a971ebfca53ecae7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a971ebfca53ecae7$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress), $a971ebfca53ecae7$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($a971ebfca53ecae7$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $a971ebfca53ecae7$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $a971ebfca53ecae7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($a971ebfca53ecae7$var$didReceiveUpdate || $a971ebfca53ecae7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $a971ebfca53ecae7$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $a971ebfca53ecae7$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $a971ebfca53ecae7$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $a971ebfca53ecae7$var$enqueueConcurrentRenderForLane(current, nextProps), $a971ebfca53ecae7$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $a971ebfca53ecae7$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $a971ebfca53ecae7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $a971ebfca53ecae7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$getNextHydratable(nextInstance.nextSibling), $a971ebfca53ecae7$var$hydrationParentFiber = workInProgress, $a971ebfca53ecae7$var$isHydrating = !0, $a971ebfca53ecae7$var$hydrationErrors = null, $a971ebfca53ecae7$var$rootOrSingletonContext = !1, null !== current && ($a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex++] = $a971ebfca53ecae7$var$treeContextId, $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex++] = $a971ebfca53ecae7$var$treeContextOverflow, $a971ebfca53ecae7$var$idStack[$a971ebfca53ecae7$var$idStackIndex++] = $a971ebfca53ecae7$var$treeContextProvider, $a971ebfca53ecae7$var$treeContextId = current.id, $a971ebfca53ecae7$var$treeContextOverflow = current.overflow, $a971ebfca53ecae7$var$treeContextProvider = workInProgress), workInProgress = $a971ebfca53ecae7$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $a971ebfca53ecae7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $a971ebfca53ecae7$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $a971ebfca53ecae7$var$createWorkInProgress(digest, showFallback) : (showFallback = $a971ebfca53ecae7$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $a971ebfca53ecae7$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $a971ebfca53ecae7$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $a971ebfca53ecae7$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $a971ebfca53ecae7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a971ebfca53ecae7$var$SUSPENDED_MARKER, nextProps;
    $a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $a971ebfca53ecae7$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $a971ebfca53ecae7$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $a971ebfca53ecae7$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $a971ebfca53ecae7$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $a971ebfca53ecae7$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $a971ebfca53ecae7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $a971ebfca53ecae7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $a971ebfca53ecae7$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $a971ebfca53ecae7$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $a971ebfca53ecae7$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $a971ebfca53ecae7$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $a971ebfca53ecae7$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $a971ebfca53ecae7$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $a971ebfca53ecae7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $a971ebfca53ecae7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $a971ebfca53ecae7$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $a971ebfca53ecae7$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $a971ebfca53ecae7$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $a971ebfca53ecae7$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $a971ebfca53ecae7$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $a971ebfca53ecae7$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($a971ebfca53ecae7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $a971ebfca53ecae7$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $a971ebfca53ecae7$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $a971ebfca53ecae7$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $a971ebfca53ecae7$var$checkIfContextChanged(current) ? !0 : !1;
}
function $a971ebfca53ecae7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $a971ebfca53ecae7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $a971ebfca53ecae7$var$pushProvider(workInProgress, $a971ebfca53ecae7$var$CacheContext, current.memoizedState.cache);
            $a971ebfca53ecae7$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $a971ebfca53ecae7$var$pushHostContext(workInProgress);
            break;
        case 4:
            $a971ebfca53ecae7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $a971ebfca53ecae7$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $a971ebfca53ecae7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $a971ebfca53ecae7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($a971ebfca53ecae7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $a971ebfca53ecae7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseStackCursor, $a971ebfca53ecae7$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $a971ebfca53ecae7$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $a971ebfca53ecae7$var$pushProvider(workInProgress, $a971ebfca53ecae7$var$CacheContext, current.memoizedState.cache);
    }
    return $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $a971ebfca53ecae7$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $a971ebfca53ecae7$var$didReceiveUpdate = !0;
        else {
            if (!$a971ebfca53ecae7$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $a971ebfca53ecae7$var$didReceiveUpdate = !1, $a971ebfca53ecae7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $a971ebfca53ecae7$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $a971ebfca53ecae7$var$didReceiveUpdate = !1, $a971ebfca53ecae7$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $a971ebfca53ecae7$var$pushTreeId(workInProgress, $a971ebfca53ecae7$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $a971ebfca53ecae7$var$shouldConstruct(lazyComponent) ? (current = $a971ebfca53ecae7$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $a971ebfca53ecae7$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $a971ebfca53ecae7$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $a971ebfca53ecae7$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $a971ebfca53ecae7$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $a971ebfca53ecae7$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $a971ebfca53ecae7$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $a971ebfca53ecae7$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $a971ebfca53ecae7$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $a971ebfca53ecae7$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $a971ebfca53ecae7$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $a971ebfca53ecae7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $a971ebfca53ecae7$var$cloneUpdateQueue(current, workInProgress);
                $a971ebfca53ecae7$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $a971ebfca53ecae7$var$pushProvider(workInProgress, $a971ebfca53ecae7$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $a971ebfca53ecae7$var$propagateContextChanges(workInProgress, [
                    $a971ebfca53ecae7$var$CacheContext
                ], renderLanes, !0);
                $a971ebfca53ecae7$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $a971ebfca53ecae7$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $a971ebfca53ecae7$var$createCapturedValueAtFiber(Error($a971ebfca53ecae7$var$formatProdErrorMessage(424)), workInProgress);
                        $a971ebfca53ecae7$var$queueHydrationError(init);
                        workInProgress = $a971ebfca53ecae7$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$getNextHydratable(current.firstChild);
                        $a971ebfca53ecae7$var$hydrationParentFiber = workInProgress;
                        $a971ebfca53ecae7$var$isHydrating = !0;
                        $a971ebfca53ecae7$var$hydrationErrors = null;
                        $a971ebfca53ecae7$var$rootOrSingletonContext = !0;
                        renderLanes = $a971ebfca53ecae7$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $a971ebfca53ecae7$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $a971ebfca53ecae7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $a971ebfca53ecae7$var$markRef(current, workInProgress), null === current ? (renderLanes = $a971ebfca53ecae7$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $a971ebfca53ecae7$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $a971ebfca53ecae7$var$getOwnerDocumentFromRootContainer($a971ebfca53ecae7$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$a971ebfca53ecae7$var$internalInstanceKey] = workInProgress, lazyComponent[$a971ebfca53ecae7$var$internalPropsKey] = current, $a971ebfca53ecae7$var$setInitialProperties(lazyComponent, renderLanes, current), $a971ebfca53ecae7$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $a971ebfca53ecae7$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $a971ebfca53ecae7$var$pushHostContext(workInProgress), null === current && $a971ebfca53ecae7$var$isHydrating && (lazyComponent = workInProgress.stateNode = $a971ebfca53ecae7$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $a971ebfca53ecae7$var$rootInstanceStackCursor.current), $a971ebfca53ecae7$var$hydrationParentFiber = workInProgress, $a971ebfca53ecae7$var$rootOrSingletonContext = !0, init = $a971ebfca53ecae7$var$nextHydratableInstance, $a971ebfca53ecae7$var$isSingletonScope(workInProgress.type) ? ($a971ebfca53ecae7$var$previousHydratableOnEnteringScopedSingleton = init, $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$getNextHydratable(lazyComponent.firstChild)) : $a971ebfca53ecae7$var$nextHydratableInstance = init), $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $a971ebfca53ecae7$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $a971ebfca53ecae7$var$isHydrating) {
                if (init = lazyComponent = $a971ebfca53ecae7$var$nextHydratableInstance) lazyComponent = $a971ebfca53ecae7$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $a971ebfca53ecae7$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $a971ebfca53ecae7$var$hydrationParentFiber = workInProgress, $a971ebfca53ecae7$var$nextHydratableInstance = $a971ebfca53ecae7$var$getNextHydratable(lazyComponent.firstChild), $a971ebfca53ecae7$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $a971ebfca53ecae7$var$throwOnHydrationMismatch(workInProgress);
            }
            $a971ebfca53ecae7$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $a971ebfca53ecae7$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $a971ebfca53ecae7$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $a971ebfca53ecae7$var$renderWithHooks(current, workInProgress, $a971ebfca53ecae7$var$TransitionAwareHostComponent, null, null, renderLanes), $a971ebfca53ecae7$var$HostTransitionContext._currentValue = init);
            $a971ebfca53ecae7$var$markRef(current, workInProgress);
            $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $a971ebfca53ecae7$var$isHydrating) {
                if (current = renderLanes = $a971ebfca53ecae7$var$nextHydratableInstance) renderLanes = $a971ebfca53ecae7$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $a971ebfca53ecae7$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $a971ebfca53ecae7$var$hydrationParentFiber = workInProgress, $a971ebfca53ecae7$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $a971ebfca53ecae7$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $a971ebfca53ecae7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $a971ebfca53ecae7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $a971ebfca53ecae7$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $a971ebfca53ecae7$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $a971ebfca53ecae7$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $a971ebfca53ecae7$var$prepareToReadContext(workInProgress), init = $a971ebfca53ecae7$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $a971ebfca53ecae7$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $a971ebfca53ecae7$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $a971ebfca53ecae7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $a971ebfca53ecae7$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $a971ebfca53ecae7$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $a971ebfca53ecae7$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $a971ebfca53ecae7$var$prepareToReadContext(workInProgress), lazyComponent = $a971ebfca53ecae7$var$readContext($a971ebfca53ecae7$var$CacheContext), null === current ? (init = $a971ebfca53ecae7$var$peekCacheFromPool(), null === init && (init = $a971ebfca53ecae7$var$workInProgressRoot, prevState = $a971ebfca53ecae7$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $a971ebfca53ecae7$var$initializeUpdateQueue(workInProgress), $a971ebfca53ecae7$var$pushProvider(workInProgress, $a971ebfca53ecae7$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($a971ebfca53ecae7$var$cloneUpdateQueue(current, workInProgress), $a971ebfca53ecae7$var$processUpdateQueue(workInProgress, null, null, renderLanes), $a971ebfca53ecae7$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $a971ebfca53ecae7$var$pushProvider(workInProgress, $a971ebfca53ecae7$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $a971ebfca53ecae7$var$pushProvider(workInProgress, $a971ebfca53ecae7$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $a971ebfca53ecae7$var$propagateContextChanges(workInProgress, [
                $a971ebfca53ecae7$var$CacheContext
            ], renderLanes, !0))), $a971ebfca53ecae7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $a971ebfca53ecae7$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $a971ebfca53ecae7$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$a971ebfca53ecae7$var$preloadResource(resource)) {
        resource = $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 4194048) === $a971ebfca53ecae7$var$workInProgressRootRenderLanes ? null !== $a971ebfca53ecae7$var$shellBoundary : ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 62914560) !== $a971ebfca53ecae7$var$workInProgressRootRenderLanes && 0 === ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 536870912) || resource !== $a971ebfca53ecae7$var$shellBoundary)) throw $a971ebfca53ecae7$var$suspendedThenable = $a971ebfca53ecae7$var$noopSuspenseyCommitThenable, $a971ebfca53ecae7$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $a971ebfca53ecae7$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $a971ebfca53ecae7$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $a971ebfca53ecae7$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $a971ebfca53ecae7$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$a971ebfca53ecae7$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $a971ebfca53ecae7$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $a971ebfca53ecae7$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $a971ebfca53ecae7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a971ebfca53ecae7$var$bubbleProperties(workInProgress), null;
        case 1:
            return $a971ebfca53ecae7$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $a971ebfca53ecae7$var$popProvider($a971ebfca53ecae7$var$CacheContext);
            $a971ebfca53ecae7$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $a971ebfca53ecae7$var$popHydrationState(workInProgress) ? $a971ebfca53ecae7$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $a971ebfca53ecae7$var$upgradeHydrationErrorsToRecoverable());
            $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($a971ebfca53ecae7$var$markUpdate(workInProgress), null !== renderLanes ? ($a971ebfca53ecae7$var$bubbleProperties(workInProgress), $a971ebfca53ecae7$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($a971ebfca53ecae7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($a971ebfca53ecae7$var$markUpdate(workInProgress), $a971ebfca53ecae7$var$bubbleProperties(workInProgress), $a971ebfca53ecae7$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($a971ebfca53ecae7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $a971ebfca53ecae7$var$markUpdate(workInProgress), $a971ebfca53ecae7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $a971ebfca53ecae7$var$popHostContext(workInProgress);
            renderLanes = $a971ebfca53ecae7$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a971ebfca53ecae7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(166));
                    $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $a971ebfca53ecae7$var$contextStackCursor.current;
                $a971ebfca53ecae7$var$popHydrationState(workInProgress) ? $a971ebfca53ecae7$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $a971ebfca53ecae7$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $a971ebfca53ecae7$var$markUpdate(workInProgress));
            }
            $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $a971ebfca53ecae7$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a971ebfca53ecae7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(166));
                    $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $a971ebfca53ecae7$var$contextStackCursor.current;
                if ($a971ebfca53ecae7$var$popHydrationState(workInProgress)) $a971ebfca53ecae7$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $a971ebfca53ecae7$var$getOwnerDocumentFromRootContainer($a971ebfca53ecae7$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$a971ebfca53ecae7$var$internalInstanceKey] = workInProgress;
                    current[$a971ebfca53ecae7$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($a971ebfca53ecae7$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $a971ebfca53ecae7$var$markUpdate(workInProgress);
                }
            }
            $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a971ebfca53ecae7$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(166));
                current = $a971ebfca53ecae7$var$rootInstanceStackCursor.current;
                if ($a971ebfca53ecae7$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $a971ebfca53ecae7$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$a971ebfca53ecae7$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $a971ebfca53ecae7$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $a971ebfca53ecae7$var$throwOnHydrationMismatch(workInProgress);
                } else current = $a971ebfca53ecae7$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$a971ebfca53ecae7$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $a971ebfca53ecae7$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(317));
                        type[$a971ebfca53ecae7$var$internalInstanceKey] = workInProgress;
                    } else $a971ebfca53ecae7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $a971ebfca53ecae7$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $a971ebfca53ecae7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $a971ebfca53ecae7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $a971ebfca53ecae7$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $a971ebfca53ecae7$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $a971ebfca53ecae7$var$popHostContainer(), null === current && $a971ebfca53ecae7$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $a971ebfca53ecae7$var$bubbleProperties(workInProgress), null;
        case 10:
            return $a971ebfca53ecae7$var$popProvider(workInProgress.type), $a971ebfca53ecae7$var$bubbleProperties(workInProgress), null;
        case 19:
            $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $a971ebfca53ecae7$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $a971ebfca53ecae7$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $a971ebfca53ecae7$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $a971ebfca53ecae7$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $a971ebfca53ecae7$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $a971ebfca53ecae7$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$a971ebfca53ecae7$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseStackCursor, $a971ebfca53ecae7$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $a971ebfca53ecae7$var$now() > $a971ebfca53ecae7$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $a971ebfca53ecae7$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $a971ebfca53ecae7$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $a971ebfca53ecae7$var$scheduleRetryEffect(workInProgress, current), $a971ebfca53ecae7$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$a971ebfca53ecae7$var$isHydrating) return $a971ebfca53ecae7$var$bubbleProperties(workInProgress), null;
                    } else 2 * $a971ebfca53ecae7$var$now() - type.renderingStartTime > $a971ebfca53ecae7$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $a971ebfca53ecae7$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $a971ebfca53ecae7$var$now(), workInProgress.sibling = null, current = $a971ebfca53ecae7$var$suspenseStackCursor.current, $a971ebfca53ecae7$var$push($a971ebfca53ecae7$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $a971ebfca53ecae7$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $a971ebfca53ecae7$var$popSuspenseHandler(workInProgress), $a971ebfca53ecae7$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($a971ebfca53ecae7$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $a971ebfca53ecae7$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $a971ebfca53ecae7$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $a971ebfca53ecae7$var$popProvider($a971ebfca53ecae7$var$CacheContext), $a971ebfca53ecae7$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $a971ebfca53ecae7$var$unwindWork(current, workInProgress) {
    $a971ebfca53ecae7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $a971ebfca53ecae7$var$popProvider($a971ebfca53ecae7$var$CacheContext), $a971ebfca53ecae7$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $a971ebfca53ecae7$var$popHostContext(workInProgress), null;
        case 13:
            $a971ebfca53ecae7$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(340));
                $a971ebfca53ecae7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$suspenseStackCursor), null;
        case 4:
            return $a971ebfca53ecae7$var$popHostContainer(), null;
        case 10:
            return $a971ebfca53ecae7$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $a971ebfca53ecae7$var$popSuspenseHandler(workInProgress), $a971ebfca53ecae7$var$popHiddenContext(), null !== current && $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $a971ebfca53ecae7$var$popProvider($a971ebfca53ecae7$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $a971ebfca53ecae7$var$unwindInterruptedWork(current, interruptedWork) {
    $a971ebfca53ecae7$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $a971ebfca53ecae7$var$popProvider($a971ebfca53ecae7$var$CacheContext);
            $a971ebfca53ecae7$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $a971ebfca53ecae7$var$popHostContext(interruptedWork);
            break;
        case 4:
            $a971ebfca53ecae7$var$popHostContainer();
            break;
        case 13:
            $a971ebfca53ecae7$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$suspenseStackCursor);
            break;
        case 10:
            $a971ebfca53ecae7$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $a971ebfca53ecae7$var$popSuspenseHandler(interruptedWork);
            $a971ebfca53ecae7$var$popHiddenContext();
            null !== current && $a971ebfca53ecae7$var$pop($a971ebfca53ecae7$var$resumedCache);
            break;
        case 24:
            $a971ebfca53ecae7$var$popProvider($a971ebfca53ecae7$var$CacheContext);
    }
}
function $a971ebfca53ecae7$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a971ebfca53ecae7$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $a971ebfca53ecae7$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a971ebfca53ecae7$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $a971ebfca53ecae7$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $a971ebfca53ecae7$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $a971ebfca53ecae7$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $a971ebfca53ecae7$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $a971ebfca53ecae7$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $a971ebfca53ecae7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $a971ebfca53ecae7$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $a971ebfca53ecae7$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a971ebfca53ecae7$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $a971ebfca53ecae7$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$a971ebfca53ecae7$var$internalPropsKey] = newProps;
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a971ebfca53ecae7$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $a971ebfca53ecae7$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $a971ebfca53ecae7$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $a971ebfca53ecae7$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $a971ebfca53ecae7$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $a971ebfca53ecae7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $a971ebfca53ecae7$var$noop$1));
    else if (4 !== tag && (27 === tag && $a971ebfca53ecae7$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($a971ebfca53ecae7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$a971ebfca53ecae7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $a971ebfca53ecae7$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $a971ebfca53ecae7$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($a971ebfca53ecae7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$a971ebfca53ecae7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $a971ebfca53ecae7$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $a971ebfca53ecae7$var$setInitialProperties(singleton, type, props);
        singleton[$a971ebfca53ecae7$var$internalInstanceKey] = finishedWork;
        singleton[$a971ebfca53ecae7$var$internalPropsKey] = props;
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $a971ebfca53ecae7$var$offscreenSubtreeIsHidden = !1, $a971ebfca53ecae7$var$offscreenSubtreeWasHidden = !1, $a971ebfca53ecae7$var$needsFormReset = !1, $a971ebfca53ecae7$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $a971ebfca53ecae7$var$nextEffect = null;
function $a971ebfca53ecae7$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $a971ebfca53ecae7$var$eventsEnabled = $a971ebfca53ecae7$var$_enabled;
    root = $a971ebfca53ecae7$var$getActiveElementDeep(root);
    if ($a971ebfca53ecae7$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $a971ebfca53ecae7$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $a971ebfca53ecae7$var$_enabled = !1;
    for($a971ebfca53ecae7$var$nextEffect = firstChild; null !== $a971ebfca53ecae7$var$nextEffect;)if (firstChild = $a971ebfca53ecae7$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $a971ebfca53ecae7$var$nextEffect = root;
    else for(; null !== $a971ebfca53ecae7$var$nextEffect;){
        firstChild = $a971ebfca53ecae7$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $a971ebfca53ecae7$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $a971ebfca53ecae7$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $a971ebfca53ecae7$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $a971ebfca53ecae7$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $a971ebfca53ecae7$var$nextEffect = root;
            break;
        }
        $a971ebfca53ecae7$var$nextEffect = firstChild.return;
    }
}
function $a971ebfca53ecae7$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a971ebfca53ecae7$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $a971ebfca53ecae7$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $a971ebfca53ecae7$var$commitClassCallbacks(finishedWork);
            flags & 512 && $a971ebfca53ecae7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $a971ebfca53ecae7$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $a971ebfca53ecae7$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $a971ebfca53ecae7$var$commitHostMount(finishedWork);
            flags & 512 && $a971ebfca53ecae7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a971ebfca53ecae7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $a971ebfca53ecae7$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $a971ebfca53ecae7$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $a971ebfca53ecae7$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $a971ebfca53ecae7$var$offscreenSubtreeWasHidden;
                prevProps = $a971ebfca53ecae7$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $a971ebfca53ecae7$var$offscreenSubtreeWasHidden;
                $a971ebfca53ecae7$var$offscreenSubtreeIsHidden = flags;
                ($a971ebfca53ecae7$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $a971ebfca53ecae7$var$offscreenSubtreeIsHidden = prevProps;
                $a971ebfca53ecae7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $a971ebfca53ecae7$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $a971ebfca53ecae7$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $a971ebfca53ecae7$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $a971ebfca53ecae7$var$hostParent = null, $a971ebfca53ecae7$var$hostParentIsContainer = !1;
function $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$a971ebfca53ecae7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $a971ebfca53ecae7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($a971ebfca53ecae7$var$injectedHook && "function" === typeof $a971ebfca53ecae7$var$injectedHook.onCommitFiberUnmount) try {
        $a971ebfca53ecae7$var$injectedHook.onCommitFiberUnmount($a971ebfca53ecae7$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden || $a971ebfca53ecae7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden || $a971ebfca53ecae7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $a971ebfca53ecae7$var$hostParent, prevHostParentIsContainer = $a971ebfca53ecae7$var$hostParentIsContainer;
            $a971ebfca53ecae7$var$isSingletonScope(deletedFiber.type) && ($a971ebfca53ecae7$var$hostParent = deletedFiber.stateNode, $a971ebfca53ecae7$var$hostParentIsContainer = !1);
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a971ebfca53ecae7$var$releaseSingletonInstance(deletedFiber.stateNode);
            $a971ebfca53ecae7$var$hostParent = prevHostParent;
            $a971ebfca53ecae7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden || $a971ebfca53ecae7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $a971ebfca53ecae7$var$hostParent;
            prevHostParentIsContainer = $a971ebfca53ecae7$var$hostParentIsContainer;
            $a971ebfca53ecae7$var$hostParent = null;
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a971ebfca53ecae7$var$hostParent = prevHostParent;
            $a971ebfca53ecae7$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $a971ebfca53ecae7$var$hostParent) {
                if ($a971ebfca53ecae7$var$hostParentIsContainer) try {
                    (9 === $a971ebfca53ecae7$var$hostParent.nodeType ? $a971ebfca53ecae7$var$hostParent.body : "HTML" === $a971ebfca53ecae7$var$hostParent.nodeName ? $a971ebfca53ecae7$var$hostParent.ownerDocument.body : $a971ebfca53ecae7$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $a971ebfca53ecae7$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $a971ebfca53ecae7$var$hostParent && ($a971ebfca53ecae7$var$hostParentIsContainer ? (finishedRoot = $a971ebfca53ecae7$var$hostParent, $a971ebfca53ecae7$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $a971ebfca53ecae7$var$retryIfBlockedOn(finishedRoot)) : $a971ebfca53ecae7$var$clearSuspenseBoundary($a971ebfca53ecae7$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $a971ebfca53ecae7$var$hostParent;
            prevHostParentIsContainer = $a971ebfca53ecae7$var$hostParentIsContainer;
            $a971ebfca53ecae7$var$hostParent = deletedFiber.stateNode.containerInfo;
            $a971ebfca53ecae7$var$hostParentIsContainer = !0;
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a971ebfca53ecae7$var$hostParent = prevHostParent;
            $a971ebfca53ecae7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden || $a971ebfca53ecae7$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden || $a971ebfca53ecae7$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden || ($a971ebfca53ecae7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $a971ebfca53ecae7$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden = (prevHostParent = $a971ebfca53ecae7$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $a971ebfca53ecae7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $a971ebfca53ecae7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $a971ebfca53ecae7$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a971ebfca53ecae7$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $a971ebfca53ecae7$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $a971ebfca53ecae7$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $a971ebfca53ecae7$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $a971ebfca53ecae7$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $a971ebfca53ecae7$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($a971ebfca53ecae7$var$isSingletonScope(parent.type)) {
                        $a971ebfca53ecae7$var$hostParent = parent.stateNode;
                        $a971ebfca53ecae7$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $a971ebfca53ecae7$var$hostParent = parent.stateNode;
                    $a971ebfca53ecae7$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $a971ebfca53ecae7$var$hostParent = parent.stateNode.containerInfo;
                    $a971ebfca53ecae7$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $a971ebfca53ecae7$var$hostParent) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(160));
        $a971ebfca53ecae7$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $a971ebfca53ecae7$var$hostParent = null;
        $a971ebfca53ecae7$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$a971ebfca53ecae7$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $a971ebfca53ecae7$var$currentHoistableRoot = null;
function $a971ebfca53ecae7$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($a971ebfca53ecae7$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $a971ebfca53ecae7$var$commitHookEffectListMount(3, finishedWork), $a971ebfca53ecae7$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a971ebfca53ecae7$var$offscreenSubtreeWasHidden || null === current || $a971ebfca53ecae7$var$safelyDetachRef(current, current.return));
            flags & 64 && $a971ebfca53ecae7$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $a971ebfca53ecae7$var$currentHoistableRoot;
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a971ebfca53ecae7$var$offscreenSubtreeWasHidden || null === current || $a971ebfca53ecae7$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$a971ebfca53ecae7$var$internalHoistableMarker] || currentResource[$a971ebfca53ecae7$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $a971ebfca53ecae7$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$a971ebfca53ecae7$var$internalInstanceKey] = finishedWork;
                                        $a971ebfca53ecae7$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $a971ebfca53ecae7$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $a971ebfca53ecae7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $a971ebfca53ecae7$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $a971ebfca53ecae7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$a971ebfca53ecae7$var$internalInstanceKey] = finishedWork;
                                $a971ebfca53ecae7$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $a971ebfca53ecae7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $a971ebfca53ecae7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $a971ebfca53ecae7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $a971ebfca53ecae7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $a971ebfca53ecae7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a971ebfca53ecae7$var$offscreenSubtreeWasHidden || null === current || $a971ebfca53ecae7$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $a971ebfca53ecae7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a971ebfca53ecae7$var$offscreenSubtreeWasHidden || null === current || $a971ebfca53ecae7$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $a971ebfca53ecae7$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $a971ebfca53ecae7$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($a971ebfca53ecae7$var$needsFormReset = !0);
            break;
        case 6:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $a971ebfca53ecae7$var$tagCaches = null;
            hoistableRoot = $a971ebfca53ecae7$var$currentHoistableRoot;
            $a971ebfca53ecae7$var$currentHoistableRoot = $a971ebfca53ecae7$var$getHoistableRoot(root.containerInfo);
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$currentHoistableRoot = hoistableRoot;
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $a971ebfca53ecae7$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $a971ebfca53ecae7$var$needsFormReset && ($a971ebfca53ecae7$var$needsFormReset = !1, $a971ebfca53ecae7$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $a971ebfca53ecae7$var$currentHoistableRoot;
            $a971ebfca53ecae7$var$currentHoistableRoot = $a971ebfca53ecae7$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            $a971ebfca53ecae7$var$currentHoistableRoot = flags;
            break;
        case 12:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($a971ebfca53ecae7$var$globalMostRecentFallbackTime = $a971ebfca53ecae7$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a971ebfca53ecae7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $a971ebfca53ecae7$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $a971ebfca53ecae7$var$offscreenSubtreeWasHidden;
            $a971ebfca53ecae7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $a971ebfca53ecae7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $a971ebfca53ecae7$var$offscreenSubtreeIsHidden || $a971ebfca53ecae7$var$offscreenSubtreeWasHidden || $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $a971ebfca53ecae7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $a971ebfca53ecae7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $a971ebfca53ecae7$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a971ebfca53ecae7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $a971ebfca53ecae7$var$recursivelyTraverseMutationEffects(root, finishedWork), $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork);
    }
}
function $a971ebfca53ecae7$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($a971ebfca53ecae7$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $a971ebfca53ecae7$var$getHostSibling(finishedWork);
                    $a971ebfca53ecae7$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($a971ebfca53ecae7$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $a971ebfca53ecae7$var$getHostSibling(finishedWork);
                    $a971ebfca53ecae7$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $a971ebfca53ecae7$var$getHostSibling(finishedWork);
                    $a971ebfca53ecae7$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $a971ebfca53ecae7$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $a971ebfca53ecae7$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $a971ebfca53ecae7$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$a971ebfca53ecae7$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $a971ebfca53ecae7$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $a971ebfca53ecae7$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $a971ebfca53ecae7$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $a971ebfca53ecae7$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $a971ebfca53ecae7$var$safelyDetachRef(finishedWork, finishedWork.return);
                $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $a971ebfca53ecae7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $a971ebfca53ecae7$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$a971ebfca53ecae7$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $a971ebfca53ecae7$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $a971ebfca53ecae7$var$commitClassCallbacks(finishedWork);
                $a971ebfca53ecae7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $a971ebfca53ecae7$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $a971ebfca53ecae7$var$commitHostMount(finishedWork);
                $a971ebfca53ecae7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $a971ebfca53ecae7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $a971ebfca53ecae7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $a971ebfca53ecae7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a971ebfca53ecae7$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $a971ebfca53ecae7$var$releaseCache(previousCache));
}
function $a971ebfca53ecae7$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $a971ebfca53ecae7$var$releaseCache(current));
}
function $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$a971ebfca53ecae7$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $a971ebfca53ecae7$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $a971ebfca53ecae7$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $a971ebfca53ecae7$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $a971ebfca53ecae7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $a971ebfca53ecae7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $a971ebfca53ecae7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $a971ebfca53ecae7$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $a971ebfca53ecae7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $a971ebfca53ecae7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $a971ebfca53ecae7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $a971ebfca53ecae7$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $a971ebfca53ecae7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $a971ebfca53ecae7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $a971ebfca53ecae7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $a971ebfca53ecae7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $a971ebfca53ecae7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $a971ebfca53ecae7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $a971ebfca53ecae7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a971ebfca53ecae7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $a971ebfca53ecae7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $a971ebfca53ecae7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $a971ebfca53ecae7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $a971ebfca53ecae7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $a971ebfca53ecae7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $a971ebfca53ecae7$var$suspenseyCommitFlag = 8192;
function $a971ebfca53ecae7$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $a971ebfca53ecae7$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$a971ebfca53ecae7$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $a971ebfca53ecae7$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $a971ebfca53ecae7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $a971ebfca53ecae7$var$suspenseyCommitFlag && null !== fiber.memoizedState && $a971ebfca53ecae7$var$suspendResource($a971ebfca53ecae7$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $a971ebfca53ecae7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $a971ebfca53ecae7$var$currentHoistableRoot;
            $a971ebfca53ecae7$var$currentHoistableRoot = $a971ebfca53ecae7$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $a971ebfca53ecae7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $a971ebfca53ecae7$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $a971ebfca53ecae7$var$suspenseyCommitFlag, $a971ebfca53ecae7$var$suspenseyCommitFlag = 16777216, $a971ebfca53ecae7$var$recursivelyAccumulateSuspenseyCommit(fiber), $a971ebfca53ecae7$var$suspenseyCommitFlag = previousHoistableRoot) : $a971ebfca53ecae7$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $a971ebfca53ecae7$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $a971ebfca53ecae7$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $a971ebfca53ecae7$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $a971ebfca53ecae7$var$nextEffect = childToDelete;
            $a971ebfca53ecae7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $a971ebfca53ecae7$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$a971ebfca53ecae7$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $a971ebfca53ecae7$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $a971ebfca53ecae7$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $a971ebfca53ecae7$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $a971ebfca53ecae7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $a971ebfca53ecae7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $a971ebfca53ecae7$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $a971ebfca53ecae7$var$nextEffect = childToDelete;
            $a971ebfca53ecae7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $a971ebfca53ecae7$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $a971ebfca53ecae7$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $a971ebfca53ecae7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $a971ebfca53ecae7$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $a971ebfca53ecae7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a971ebfca53ecae7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $a971ebfca53ecae7$var$nextEffect;){
        var fiber = $a971ebfca53ecae7$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $a971ebfca53ecae7$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $a971ebfca53ecae7$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $a971ebfca53ecae7$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $a971ebfca53ecae7$var$nextEffect;){
            cache = $a971ebfca53ecae7$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $a971ebfca53ecae7$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $a971ebfca53ecae7$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $a971ebfca53ecae7$var$nextEffect = sibling;
                break a;
            }
            $a971ebfca53ecae7$var$nextEffect = returnFiber;
        }
    }
}
var $a971ebfca53ecae7$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $a971ebfca53ecae7$var$readContext($a971ebfca53ecae7$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $a971ebfca53ecae7$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $a971ebfca53ecae7$var$executionContext = 0, $a971ebfca53ecae7$var$workInProgressRoot = null, $a971ebfca53ecae7$var$workInProgress = null, $a971ebfca53ecae7$var$workInProgressRootRenderLanes = 0, $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0, $a971ebfca53ecae7$var$workInProgressThrownValue = null, $a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings = !1, $a971ebfca53ecae7$var$workInProgressRootIsPrerendering = !1, $a971ebfca53ecae7$var$workInProgressRootDidAttachPingListener = !1, $a971ebfca53ecae7$var$entangledRenderLanes = 0, $a971ebfca53ecae7$var$workInProgressRootExitStatus = 0, $a971ebfca53ecae7$var$workInProgressRootSkippedLanes = 0, $a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes = 0, $a971ebfca53ecae7$var$workInProgressRootPingedLanes = 0, $a971ebfca53ecae7$var$workInProgressDeferredLane = 0, $a971ebfca53ecae7$var$workInProgressSuspendedRetryLanes = 0, $a971ebfca53ecae7$var$workInProgressRootConcurrentErrors = null, $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors = null, $a971ebfca53ecae7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $a971ebfca53ecae7$var$globalMostRecentFallbackTime = 0, $a971ebfca53ecae7$var$workInProgressRootRenderTargetTime = Infinity, $a971ebfca53ecae7$var$workInProgressTransitions = null, $a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed = null, $a971ebfca53ecae7$var$pendingEffectsStatus = 0, $a971ebfca53ecae7$var$pendingEffectsRoot = null, $a971ebfca53ecae7$var$pendingFinishedWork = null, $a971ebfca53ecae7$var$pendingEffectsLanes = 0, $a971ebfca53ecae7$var$pendingEffectsRemainingLanes = 0, $a971ebfca53ecae7$var$pendingPassiveTransitions = null, $a971ebfca53ecae7$var$pendingRecoverableErrors = null, $a971ebfca53ecae7$var$nestedUpdateCount = 0, $a971ebfca53ecae7$var$rootWithNestedUpdates = null;
function $a971ebfca53ecae7$var$requestUpdateLane() {
    if (0 !== ($a971ebfca53ecae7$var$executionContext & 2) && 0 !== $a971ebfca53ecae7$var$workInProgressRootRenderLanes) return $a971ebfca53ecae7$var$workInProgressRootRenderLanes & -$a971ebfca53ecae7$var$workInProgressRootRenderLanes;
    if (null !== $a971ebfca53ecae7$var$ReactSharedInternals.T) {
        var actionScopeLane = $a971ebfca53ecae7$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $a971ebfca53ecae7$var$requestTransitionLane();
    }
    return $a971ebfca53ecae7$var$resolveUpdatePriority();
}
function $a971ebfca53ecae7$var$requestDeferredLane() {
    0 === $a971ebfca53ecae7$var$workInProgressDeferredLane && ($a971ebfca53ecae7$var$workInProgressDeferredLane = 0 === ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 536870912) || $a971ebfca53ecae7$var$isHydrating ? $a971ebfca53ecae7$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $a971ebfca53ecae7$var$workInProgressDeferredLane;
}
function $a971ebfca53ecae7$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $a971ebfca53ecae7$var$workInProgressRoot && (2 === $a971ebfca53ecae7$var$workInProgressSuspendedReason || 9 === $a971ebfca53ecae7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $a971ebfca53ecae7$var$prepareFreshStack(root, 0), $a971ebfca53ecae7$var$markRootSuspended(root, $a971ebfca53ecae7$var$workInProgressRootRenderLanes, $a971ebfca53ecae7$var$workInProgressDeferredLane, !1);
    $a971ebfca53ecae7$var$markRootUpdated$1(root, lane);
    if (0 === ($a971ebfca53ecae7$var$executionContext & 2) || root !== $a971ebfca53ecae7$var$workInProgressRoot) root === $a971ebfca53ecae7$var$workInProgressRoot && (0 === ($a971ebfca53ecae7$var$executionContext & 2) && ($a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $a971ebfca53ecae7$var$workInProgressRootExitStatus && $a971ebfca53ecae7$var$markRootSuspended(root, $a971ebfca53ecae7$var$workInProgressRootRenderLanes, $a971ebfca53ecae7$var$workInProgressDeferredLane, !1)), $a971ebfca53ecae7$var$ensureRootIsScheduled(root);
}
function $a971ebfca53ecae7$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($a971ebfca53ecae7$var$executionContext & 6)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $a971ebfca53ecae7$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $a971ebfca53ecae7$var$renderRootConcurrent(root$jscomp$0, lanes) : $a971ebfca53ecae7$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $a971ebfca53ecae7$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $a971ebfca53ecae7$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$a971ebfca53ecae7$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $a971ebfca53ecae7$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $a971ebfca53ecae7$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($a971ebfca53ecae7$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $a971ebfca53ecae7$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($a971ebfca53ecae7$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors;
                            $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors ? $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors.push.apply($a971ebfca53ecae7$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $a971ebfca53ecae7$var$prepareFreshStack(root$jscomp$0, 0);
                $a971ebfca53ecae7$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $a971ebfca53ecae7$var$markRootSuspended(shouldTimeSlice, lanes, $a971ebfca53ecae7$var$workInProgressDeferredLane, !$a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $a971ebfca53ecae7$var$globalMostRecentFallbackTime + 300 - $a971ebfca53ecae7$var$now(), 10 < exitStatus)) {
                    $a971ebfca53ecae7$var$markRootSuspended(shouldTimeSlice, lanes, $a971ebfca53ecae7$var$workInProgressDeferredLane, !$a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $a971ebfca53ecae7$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $a971ebfca53ecae7$var$scheduleTimeout($a971ebfca53ecae7$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors, $a971ebfca53ecae7$var$workInProgressTransitions, $a971ebfca53ecae7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $a971ebfca53ecae7$var$workInProgressDeferredLane, $a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes, $a971ebfca53ecae7$var$workInProgressSuspendedRetryLanes, $a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $a971ebfca53ecae7$var$commitRootWhenReady(shouldTimeSlice, forceSync, $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors, $a971ebfca53ecae7$var$workInProgressTransitions, $a971ebfca53ecae7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $a971ebfca53ecae7$var$workInProgressDeferredLane, $a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes, $a971ebfca53ecae7$var$workInProgressSuspendedRetryLanes, $a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $a971ebfca53ecae7$var$ensureRootIsScheduled(root$jscomp$0);
}
function $a971ebfca53ecae7$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($a971ebfca53ecae7$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $a971ebfca53ecae7$var$noop
        }, $a971ebfca53ecae7$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $a971ebfca53ecae7$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($a971ebfca53ecae7$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $a971ebfca53ecae7$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $a971ebfca53ecae7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $a971ebfca53ecae7$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$a971ebfca53ecae7$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $a971ebfca53ecae7$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$a971ebfca53ecae7$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $a971ebfca53ecae7$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $a971ebfca53ecae7$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $a971ebfca53ecae7$var$flushSyncWork$1() {
    return 0 === ($a971ebfca53ecae7$var$executionContext & 6) ? ($a971ebfca53ecae7$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $a971ebfca53ecae7$var$resetWorkInProgressStack() {
    if (null !== $a971ebfca53ecae7$var$workInProgress) {
        if (0 === $a971ebfca53ecae7$var$workInProgressSuspendedReason) var interruptedWork = $a971ebfca53ecae7$var$workInProgress.return;
        else interruptedWork = $a971ebfca53ecae7$var$workInProgress, $a971ebfca53ecae7$var$lastContextDependency = $a971ebfca53ecae7$var$currentlyRenderingFiber$1 = null, $a971ebfca53ecae7$var$resetHooksOnUnwind(interruptedWork), $a971ebfca53ecae7$var$thenableState = null, $a971ebfca53ecae7$var$thenableIndexCounter = 0, interruptedWork = $a971ebfca53ecae7$var$workInProgress;
        for(; null !== interruptedWork;)$a971ebfca53ecae7$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $a971ebfca53ecae7$var$workInProgress = null;
    }
}
function $a971ebfca53ecae7$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $a971ebfca53ecae7$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $a971ebfca53ecae7$var$resetWorkInProgressStack();
    $a971ebfca53ecae7$var$workInProgressRoot = root;
    $a971ebfca53ecae7$var$workInProgress = timeoutHandle = $a971ebfca53ecae7$var$createWorkInProgress(root.current, null);
    $a971ebfca53ecae7$var$workInProgressRootRenderLanes = lanes;
    $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0;
    $a971ebfca53ecae7$var$workInProgressThrownValue = null;
    $a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $a971ebfca53ecae7$var$workInProgressRootIsPrerendering = $a971ebfca53ecae7$var$checkIfRootIsPrerendering(root, lanes);
    $a971ebfca53ecae7$var$workInProgressRootDidAttachPingListener = !1;
    $a971ebfca53ecae7$var$workInProgressSuspendedRetryLanes = $a971ebfca53ecae7$var$workInProgressDeferredLane = $a971ebfca53ecae7$var$workInProgressRootPingedLanes = $a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes = $a971ebfca53ecae7$var$workInProgressRootSkippedLanes = $a971ebfca53ecae7$var$workInProgressRootExitStatus = 0;
    $a971ebfca53ecae7$var$workInProgressRootRecoverableErrors = $a971ebfca53ecae7$var$workInProgressRootConcurrentErrors = null;
    $a971ebfca53ecae7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $a971ebfca53ecae7$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $a971ebfca53ecae7$var$entangledRenderLanes = lanes;
    $a971ebfca53ecae7$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $a971ebfca53ecae7$var$handleThrow(root, thrownValue) {
    $a971ebfca53ecae7$var$currentlyRenderingFiber = null;
    $a971ebfca53ecae7$var$ReactSharedInternals.H = $a971ebfca53ecae7$var$ContextOnlyDispatcher;
    thrownValue === $a971ebfca53ecae7$var$SuspenseException || thrownValue === $a971ebfca53ecae7$var$SuspenseActionException ? (thrownValue = $a971ebfca53ecae7$var$getSuspendedThenable(), $a971ebfca53ecae7$var$workInProgressSuspendedReason = 3) : thrownValue === $a971ebfca53ecae7$var$SuspenseyCommitException ? (thrownValue = $a971ebfca53ecae7$var$getSuspendedThenable(), $a971ebfca53ecae7$var$workInProgressSuspendedReason = 4) : $a971ebfca53ecae7$var$workInProgressSuspendedReason = thrownValue === $a971ebfca53ecae7$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $a971ebfca53ecae7$var$workInProgressThrownValue = thrownValue;
    null === $a971ebfca53ecae7$var$workInProgress && ($a971ebfca53ecae7$var$workInProgressRootExitStatus = 1, $a971ebfca53ecae7$var$logUncaughtError(root, $a971ebfca53ecae7$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $a971ebfca53ecae7$var$pushDispatcher() {
    var prevDispatcher = $a971ebfca53ecae7$var$ReactSharedInternals.H;
    $a971ebfca53ecae7$var$ReactSharedInternals.H = $a971ebfca53ecae7$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $a971ebfca53ecae7$var$ContextOnlyDispatcher : prevDispatcher;
}
function $a971ebfca53ecae7$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $a971ebfca53ecae7$var$ReactSharedInternals.A;
    $a971ebfca53ecae7$var$ReactSharedInternals.A = $a971ebfca53ecae7$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $a971ebfca53ecae7$var$renderDidSuspendDelayIfPossible() {
    $a971ebfca53ecae7$var$workInProgressRootExitStatus = 4;
    $a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings || ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 4194048) !== $a971ebfca53ecae7$var$workInProgressRootRenderLanes && null !== $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current || ($a971ebfca53ecae7$var$workInProgressRootIsPrerendering = !0);
    0 === ($a971ebfca53ecae7$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($a971ebfca53ecae7$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $a971ebfca53ecae7$var$workInProgressRoot || $a971ebfca53ecae7$var$markRootSuspended($a971ebfca53ecae7$var$workInProgressRoot, $a971ebfca53ecae7$var$workInProgressRootRenderLanes, $a971ebfca53ecae7$var$workInProgressDeferredLane, !1);
}
function $a971ebfca53ecae7$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $a971ebfca53ecae7$var$executionContext;
    $a971ebfca53ecae7$var$executionContext |= 2;
    var prevDispatcher = $a971ebfca53ecae7$var$pushDispatcher(), prevAsyncDispatcher = $a971ebfca53ecae7$var$pushAsyncDispatcher();
    if ($a971ebfca53ecae7$var$workInProgressRoot !== root || $a971ebfca53ecae7$var$workInProgressRootRenderLanes !== lanes) $a971ebfca53ecae7$var$workInProgressTransitions = null, $a971ebfca53ecae7$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $a971ebfca53ecae7$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $a971ebfca53ecae7$var$workInProgressSuspendedReason && null !== $a971ebfca53ecae7$var$workInProgress) {
            var unitOfWork = $a971ebfca53ecae7$var$workInProgress, thrownValue = $a971ebfca53ecae7$var$workInProgressThrownValue;
            switch($a971ebfca53ecae7$var$workInProgressSuspendedReason){
                case 8:
                    $a971ebfca53ecae7$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $a971ebfca53ecae7$var$workInProgressSuspendedReason;
                    $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0;
                    $a971ebfca53ecae7$var$workInProgressThrownValue = null;
                    $a971ebfca53ecae7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $a971ebfca53ecae7$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $a971ebfca53ecae7$var$workInProgressSuspendedReason, $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0, $a971ebfca53ecae7$var$workInProgressThrownValue = null, $a971ebfca53ecae7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $a971ebfca53ecae7$var$workLoopSync();
        exitStatus = $a971ebfca53ecae7$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $a971ebfca53ecae7$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $a971ebfca53ecae7$var$lastContextDependency = $a971ebfca53ecae7$var$currentlyRenderingFiber$1 = null;
    $a971ebfca53ecae7$var$executionContext = prevExecutionContext;
    $a971ebfca53ecae7$var$ReactSharedInternals.H = prevDispatcher;
    $a971ebfca53ecae7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $a971ebfca53ecae7$var$workInProgress && ($a971ebfca53ecae7$var$workInProgressRoot = null, $a971ebfca53ecae7$var$workInProgressRootRenderLanes = 0, $a971ebfca53ecae7$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $a971ebfca53ecae7$var$workLoopSync() {
    for(; null !== $a971ebfca53ecae7$var$workInProgress;)$a971ebfca53ecae7$var$performUnitOfWork($a971ebfca53ecae7$var$workInProgress);
}
function $a971ebfca53ecae7$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $a971ebfca53ecae7$var$executionContext;
    $a971ebfca53ecae7$var$executionContext |= 2;
    var prevDispatcher = $a971ebfca53ecae7$var$pushDispatcher(), prevAsyncDispatcher = $a971ebfca53ecae7$var$pushAsyncDispatcher();
    $a971ebfca53ecae7$var$workInProgressRoot !== root || $a971ebfca53ecae7$var$workInProgressRootRenderLanes !== lanes ? ($a971ebfca53ecae7$var$workInProgressTransitions = null, $a971ebfca53ecae7$var$workInProgressRootRenderTargetTime = $a971ebfca53ecae7$var$now() + 500, $a971ebfca53ecae7$var$prepareFreshStack(root, lanes)) : $a971ebfca53ecae7$var$workInProgressRootIsPrerendering = $a971ebfca53ecae7$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $a971ebfca53ecae7$var$workInProgressSuspendedReason && null !== $a971ebfca53ecae7$var$workInProgress) {
            lanes = $a971ebfca53ecae7$var$workInProgress;
            var thrownValue = $a971ebfca53ecae7$var$workInProgressThrownValue;
            b: switch($a971ebfca53ecae7$var$workInProgressSuspendedReason){
                case 1:
                    $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0;
                    $a971ebfca53ecae7$var$workInProgressThrownValue = null;
                    $a971ebfca53ecae7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($a971ebfca53ecae7$var$isThenableResolved(thrownValue)) {
                        $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0;
                        $a971ebfca53ecae7$var$workInProgressThrownValue = null;
                        $a971ebfca53ecae7$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $a971ebfca53ecae7$var$workInProgressSuspendedReason && 9 !== $a971ebfca53ecae7$var$workInProgressSuspendedReason || $a971ebfca53ecae7$var$workInProgressRoot !== root || ($a971ebfca53ecae7$var$workInProgressSuspendedReason = 7);
                        $a971ebfca53ecae7$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $a971ebfca53ecae7$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $a971ebfca53ecae7$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $a971ebfca53ecae7$var$isThenableResolved(thrownValue) ? ($a971ebfca53ecae7$var$workInProgressSuspendedReason = 0, $a971ebfca53ecae7$var$workInProgressThrownValue = null, $a971ebfca53ecae7$var$replaySuspendedUnitOfWork(lanes)) : ($a971ebfca53ecae7$var$workInProgressSuspendedReason = 0, $a971ebfca53ecae7$var$workInProgressThrownValue = null, $a971ebfca53ecae7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($a971ebfca53ecae7$var$workInProgress.tag){
                        case 26:
                            resource = $a971ebfca53ecae7$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $a971ebfca53ecae7$var$workInProgress;
                            if (resource ? $a971ebfca53ecae7$var$preloadResource(resource) : 1) {
                                $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0;
                                $a971ebfca53ecae7$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $a971ebfca53ecae7$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($a971ebfca53ecae7$var$workInProgress = returnFiber, $a971ebfca53ecae7$var$completeUnitOfWork(returnFiber)) : $a971ebfca53ecae7$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0;
                    $a971ebfca53ecae7$var$workInProgressThrownValue = null;
                    $a971ebfca53ecae7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $a971ebfca53ecae7$var$workInProgressSuspendedReason = 0;
                    $a971ebfca53ecae7$var$workInProgressThrownValue = null;
                    $a971ebfca53ecae7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $a971ebfca53ecae7$var$resetWorkInProgressStack();
                    $a971ebfca53ecae7$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(462));
            }
        }
        $a971ebfca53ecae7$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $a971ebfca53ecae7$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $a971ebfca53ecae7$var$lastContextDependency = $a971ebfca53ecae7$var$currentlyRenderingFiber$1 = null;
    $a971ebfca53ecae7$var$ReactSharedInternals.H = prevDispatcher;
    $a971ebfca53ecae7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $a971ebfca53ecae7$var$executionContext = prevExecutionContext;
    if (null !== $a971ebfca53ecae7$var$workInProgress) return 0;
    $a971ebfca53ecae7$var$workInProgressRoot = null;
    $a971ebfca53ecae7$var$workInProgressRootRenderLanes = 0;
    $a971ebfca53ecae7$var$finishQueueingConcurrentUpdates();
    return $a971ebfca53ecae7$var$workInProgressRootExitStatus;
}
function $a971ebfca53ecae7$var$workLoopConcurrentByScheduler() {
    for(; null !== $a971ebfca53ecae7$var$workInProgress && !$a971ebfca53ecae7$var$shouldYield();)$a971ebfca53ecae7$var$performUnitOfWork($a971ebfca53ecae7$var$workInProgress);
}
function $a971ebfca53ecae7$var$performUnitOfWork(unitOfWork) {
    var next = $a971ebfca53ecae7$var$beginWork(unitOfWork.alternate, unitOfWork, $a971ebfca53ecae7$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $a971ebfca53ecae7$var$completeUnitOfWork(unitOfWork) : $a971ebfca53ecae7$var$workInProgress = next;
}
function $a971ebfca53ecae7$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $a971ebfca53ecae7$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $a971ebfca53ecae7$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $a971ebfca53ecae7$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $a971ebfca53ecae7$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $a971ebfca53ecae7$var$resetHooksOnUnwind(next);
        default:
            $a971ebfca53ecae7$var$unwindInterruptedWork(current, next), next = $a971ebfca53ecae7$var$workInProgress = $a971ebfca53ecae7$var$resetWorkInProgress(next, $a971ebfca53ecae7$var$entangledRenderLanes), next = $a971ebfca53ecae7$var$beginWork(current, next, $a971ebfca53ecae7$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $a971ebfca53ecae7$var$completeUnitOfWork(unitOfWork) : $a971ebfca53ecae7$var$workInProgress = next;
}
function $a971ebfca53ecae7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $a971ebfca53ecae7$var$lastContextDependency = $a971ebfca53ecae7$var$currentlyRenderingFiber$1 = null;
    $a971ebfca53ecae7$var$resetHooksOnUnwind(unitOfWork);
    $a971ebfca53ecae7$var$thenableState = null;
    $a971ebfca53ecae7$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($a971ebfca53ecae7$var$throwException(root, returnFiber, unitOfWork, thrownValue, $a971ebfca53ecae7$var$workInProgressRootRenderLanes)) {
            $a971ebfca53ecae7$var$workInProgressRootExitStatus = 1;
            $a971ebfca53ecae7$var$logUncaughtError(root, $a971ebfca53ecae7$var$createCapturedValueAtFiber(thrownValue, root.current));
            $a971ebfca53ecae7$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $a971ebfca53ecae7$var$workInProgress = returnFiber, error;
        $a971ebfca53ecae7$var$workInProgressRootExitStatus = 1;
        $a971ebfca53ecae7$var$logUncaughtError(root, $a971ebfca53ecae7$var$createCapturedValueAtFiber(thrownValue, root.current));
        $a971ebfca53ecae7$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($a971ebfca53ecae7$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($a971ebfca53ecae7$var$workInProgressRootIsPrerendering || 0 !== ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $a971ebfca53ecae7$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $a971ebfca53ecae7$var$unwindUnitOfWork(unitOfWork, root);
    } else $a971ebfca53ecae7$var$completeUnitOfWork(unitOfWork);
}
function $a971ebfca53ecae7$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $a971ebfca53ecae7$var$unwindUnitOfWork(completedWork, $a971ebfca53ecae7$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $a971ebfca53ecae7$var$completeWork(completedWork.alternate, completedWork, $a971ebfca53ecae7$var$entangledRenderLanes);
        if (null !== next) {
            $a971ebfca53ecae7$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $a971ebfca53ecae7$var$workInProgress = completedWork;
            return;
        }
        $a971ebfca53ecae7$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $a971ebfca53ecae7$var$workInProgressRootExitStatus && ($a971ebfca53ecae7$var$workInProgressRootExitStatus = 5);
}
function $a971ebfca53ecae7$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $a971ebfca53ecae7$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $a971ebfca53ecae7$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $a971ebfca53ecae7$var$workInProgress = unitOfWork;
            return;
        }
        $a971ebfca53ecae7$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $a971ebfca53ecae7$var$workInProgressRootExitStatus = 6;
    $a971ebfca53ecae7$var$workInProgress = null;
}
function $a971ebfca53ecae7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $a971ebfca53ecae7$var$flushPendingEffects();
    while (0 !== $a971ebfca53ecae7$var$pendingEffectsStatus);
    if (0 !== ($a971ebfca53ecae7$var$executionContext & 6)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $a971ebfca53ecae7$var$concurrentlyUpdatedLanes;
        $a971ebfca53ecae7$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $a971ebfca53ecae7$var$workInProgressRoot && ($a971ebfca53ecae7$var$workInProgress = $a971ebfca53ecae7$var$workInProgressRoot = null, $a971ebfca53ecae7$var$workInProgressRootRenderLanes = 0);
        $a971ebfca53ecae7$var$pendingFinishedWork = finishedWork;
        $a971ebfca53ecae7$var$pendingEffectsRoot = root;
        $a971ebfca53ecae7$var$pendingEffectsLanes = lanes;
        $a971ebfca53ecae7$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $a971ebfca53ecae7$var$pendingPassiveTransitions = transitions;
        $a971ebfca53ecae7$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $a971ebfca53ecae7$var$scheduleCallback$1($a971ebfca53ecae7$var$NormalPriority$1, function() {
            $a971ebfca53ecae7$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $a971ebfca53ecae7$var$ReactSharedInternals.T;
            $a971ebfca53ecae7$var$ReactSharedInternals.T = null;
            transitions = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
            $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $a971ebfca53ecae7$var$executionContext;
            $a971ebfca53ecae7$var$executionContext |= 4;
            try {
                $a971ebfca53ecae7$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $a971ebfca53ecae7$var$executionContext = spawnedLane, $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = transitions, $a971ebfca53ecae7$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $a971ebfca53ecae7$var$pendingEffectsStatus = 1;
        $a971ebfca53ecae7$var$flushMutationEffects();
        $a971ebfca53ecae7$var$flushLayoutEffects();
        $a971ebfca53ecae7$var$flushSpawnedWork();
    }
}
function $a971ebfca53ecae7$var$flushMutationEffects() {
    if (1 === $a971ebfca53ecae7$var$pendingEffectsStatus) {
        $a971ebfca53ecae7$var$pendingEffectsStatus = 0;
        var root = $a971ebfca53ecae7$var$pendingEffectsRoot, finishedWork = $a971ebfca53ecae7$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $a971ebfca53ecae7$var$ReactSharedInternals.T;
            $a971ebfca53ecae7$var$ReactSharedInternals.T = null;
            var previousPriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
            $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $a971ebfca53ecae7$var$executionContext;
            $a971ebfca53ecae7$var$executionContext |= 4;
            try {
                $a971ebfca53ecae7$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $a971ebfca53ecae7$var$selectionInformation, curFocusedElem = $a971ebfca53ecae7$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $a971ebfca53ecae7$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $a971ebfca53ecae7$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $a971ebfca53ecae7$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $a971ebfca53ecae7$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $a971ebfca53ecae7$var$_enabled = !!$a971ebfca53ecae7$var$eventsEnabled;
                $a971ebfca53ecae7$var$selectionInformation = $a971ebfca53ecae7$var$eventsEnabled = null;
            } finally{
                $a971ebfca53ecae7$var$executionContext = prevExecutionContext, $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = previousPriority, $a971ebfca53ecae7$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $a971ebfca53ecae7$var$pendingEffectsStatus = 2;
    }
}
function $a971ebfca53ecae7$var$flushLayoutEffects() {
    if (2 === $a971ebfca53ecae7$var$pendingEffectsStatus) {
        $a971ebfca53ecae7$var$pendingEffectsStatus = 0;
        var root = $a971ebfca53ecae7$var$pendingEffectsRoot, finishedWork = $a971ebfca53ecae7$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $a971ebfca53ecae7$var$ReactSharedInternals.T;
            $a971ebfca53ecae7$var$ReactSharedInternals.T = null;
            var previousPriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
            $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $a971ebfca53ecae7$var$executionContext;
            $a971ebfca53ecae7$var$executionContext |= 4;
            try {
                $a971ebfca53ecae7$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $a971ebfca53ecae7$var$executionContext = prevExecutionContext, $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = previousPriority, $a971ebfca53ecae7$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $a971ebfca53ecae7$var$pendingEffectsStatus = 3;
    }
}
function $a971ebfca53ecae7$var$flushSpawnedWork() {
    if (4 === $a971ebfca53ecae7$var$pendingEffectsStatus || 3 === $a971ebfca53ecae7$var$pendingEffectsStatus) {
        $a971ebfca53ecae7$var$pendingEffectsStatus = 0;
        $a971ebfca53ecae7$var$requestPaint();
        var root = $a971ebfca53ecae7$var$pendingEffectsRoot, finishedWork = $a971ebfca53ecae7$var$pendingFinishedWork, lanes = $a971ebfca53ecae7$var$pendingEffectsLanes, recoverableErrors = $a971ebfca53ecae7$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $a971ebfca53ecae7$var$pendingEffectsStatus = 5 : ($a971ebfca53ecae7$var$pendingEffectsStatus = 0, $a971ebfca53ecae7$var$pendingFinishedWork = $a971ebfca53ecae7$var$pendingEffectsRoot = null, $a971ebfca53ecae7$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $a971ebfca53ecae7$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($a971ebfca53ecae7$var$injectedHook && "function" === typeof $a971ebfca53ecae7$var$injectedHook.onCommitFiberRoot) try {
            $a971ebfca53ecae7$var$injectedHook.onCommitFiberRoot($a971ebfca53ecae7$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $a971ebfca53ecae7$var$ReactSharedInternals.T;
            remainingLanes = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
            $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 2;
            $a971ebfca53ecae7$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $a971ebfca53ecae7$var$ReactSharedInternals.T = finishedWork, $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($a971ebfca53ecae7$var$pendingEffectsLanes & 3) && $a971ebfca53ecae7$var$flushPendingEffects();
        $a971ebfca53ecae7$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $a971ebfca53ecae7$var$rootWithNestedUpdates ? $a971ebfca53ecae7$var$nestedUpdateCount++ : ($a971ebfca53ecae7$var$nestedUpdateCount = 0, $a971ebfca53ecae7$var$rootWithNestedUpdates = root) : $a971ebfca53ecae7$var$nestedUpdateCount = 0;
        $a971ebfca53ecae7$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $a971ebfca53ecae7$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $a971ebfca53ecae7$var$releaseCache(remainingLanes)));
}
function $a971ebfca53ecae7$var$flushPendingEffects(wasDelayedCommit) {
    $a971ebfca53ecae7$var$flushMutationEffects();
    $a971ebfca53ecae7$var$flushLayoutEffects();
    $a971ebfca53ecae7$var$flushSpawnedWork();
    return $a971ebfca53ecae7$var$flushPassiveEffects(wasDelayedCommit);
}
function $a971ebfca53ecae7$var$flushPassiveEffects() {
    if (5 !== $a971ebfca53ecae7$var$pendingEffectsStatus) return !1;
    var root = $a971ebfca53ecae7$var$pendingEffectsRoot, remainingLanes = $a971ebfca53ecae7$var$pendingEffectsRemainingLanes;
    $a971ebfca53ecae7$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $a971ebfca53ecae7$var$lanesToEventPriority($a971ebfca53ecae7$var$pendingEffectsLanes), prevTransition = $a971ebfca53ecae7$var$ReactSharedInternals.T, previousPriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
    try {
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $a971ebfca53ecae7$var$ReactSharedInternals.T = null;
        renderPriority = $a971ebfca53ecae7$var$pendingPassiveTransitions;
        $a971ebfca53ecae7$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $a971ebfca53ecae7$var$pendingEffectsRoot, lanes = $a971ebfca53ecae7$var$pendingEffectsLanes;
        $a971ebfca53ecae7$var$pendingEffectsStatus = 0;
        $a971ebfca53ecae7$var$pendingFinishedWork = $a971ebfca53ecae7$var$pendingEffectsRoot = null;
        $a971ebfca53ecae7$var$pendingEffectsLanes = 0;
        if (0 !== ($a971ebfca53ecae7$var$executionContext & 6)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(331));
        var prevExecutionContext = $a971ebfca53ecae7$var$executionContext;
        $a971ebfca53ecae7$var$executionContext |= 4;
        $a971ebfca53ecae7$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $a971ebfca53ecae7$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $a971ebfca53ecae7$var$executionContext = prevExecutionContext;
        $a971ebfca53ecae7$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($a971ebfca53ecae7$var$injectedHook && "function" === typeof $a971ebfca53ecae7$var$injectedHook.onPostCommitFiberRoot) try {
            $a971ebfca53ecae7$var$injectedHook.onPostCommitFiberRoot($a971ebfca53ecae7$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = previousPriority, $a971ebfca53ecae7$var$ReactSharedInternals.T = prevTransition, $a971ebfca53ecae7$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $a971ebfca53ecae7$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $a971ebfca53ecae7$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $a971ebfca53ecae7$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $a971ebfca53ecae7$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($a971ebfca53ecae7$var$markRootUpdated$1(rootFiber, 2), $a971ebfca53ecae7$var$ensureRootIsScheduled(rootFiber));
}
function $a971ebfca53ecae7$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $a971ebfca53ecae7$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $a971ebfca53ecae7$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed || !$a971ebfca53ecae7$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $a971ebfca53ecae7$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $a971ebfca53ecae7$var$createClassErrorUpdate(2);
                instance = $a971ebfca53ecae7$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($a971ebfca53ecae7$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $a971ebfca53ecae7$var$markRootUpdated$1(instance, 2), $a971ebfca53ecae7$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $a971ebfca53ecae7$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $a971ebfca53ecae7$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($a971ebfca53ecae7$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $a971ebfca53ecae7$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $a971ebfca53ecae7$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $a971ebfca53ecae7$var$workInProgressRoot === root && ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $a971ebfca53ecae7$var$workInProgressRootExitStatus || 3 === $a971ebfca53ecae7$var$workInProgressRootExitStatus && ($a971ebfca53ecae7$var$workInProgressRootRenderLanes & 62914560) === $a971ebfca53ecae7$var$workInProgressRootRenderLanes && 300 > $a971ebfca53ecae7$var$now() - $a971ebfca53ecae7$var$globalMostRecentFallbackTime ? 0 === ($a971ebfca53ecae7$var$executionContext & 2) && $a971ebfca53ecae7$var$prepareFreshStack(root, 0) : $a971ebfca53ecae7$var$workInProgressRootPingedLanes |= pingedLanes, $a971ebfca53ecae7$var$workInProgressSuspendedRetryLanes === $a971ebfca53ecae7$var$workInProgressRootRenderLanes && ($a971ebfca53ecae7$var$workInProgressSuspendedRetryLanes = 0));
    $a971ebfca53ecae7$var$ensureRootIsScheduled(root);
}
function $a971ebfca53ecae7$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $a971ebfca53ecae7$var$claimNextRetryLane());
    boundaryFiber = $a971ebfca53ecae7$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($a971ebfca53ecae7$var$markRootUpdated$1(boundaryFiber, retryLane), $a971ebfca53ecae7$var$ensureRootIsScheduled(boundaryFiber));
}
function $a971ebfca53ecae7$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $a971ebfca53ecae7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $a971ebfca53ecae7$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $a971ebfca53ecae7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $a971ebfca53ecae7$var$scheduleCallback$1(priorityLevel, callback) {
    return $a971ebfca53ecae7$var$scheduleCallback$3(priorityLevel, callback);
}
var $a971ebfca53ecae7$var$firstScheduledRoot = null, $a971ebfca53ecae7$var$lastScheduledRoot = null, $a971ebfca53ecae7$var$didScheduleMicrotask = !1, $a971ebfca53ecae7$var$mightHavePendingSyncWork = !1, $a971ebfca53ecae7$var$isFlushingWork = !1, $a971ebfca53ecae7$var$currentEventTransitionLane = 0;
function $a971ebfca53ecae7$var$ensureRootIsScheduled(root) {
    root !== $a971ebfca53ecae7$var$lastScheduledRoot && null === root.next && (null === $a971ebfca53ecae7$var$lastScheduledRoot ? $a971ebfca53ecae7$var$firstScheduledRoot = $a971ebfca53ecae7$var$lastScheduledRoot = root : $a971ebfca53ecae7$var$lastScheduledRoot = $a971ebfca53ecae7$var$lastScheduledRoot.next = root);
    $a971ebfca53ecae7$var$mightHavePendingSyncWork = !0;
    $a971ebfca53ecae7$var$didScheduleMicrotask || ($a971ebfca53ecae7$var$didScheduleMicrotask = !0, $a971ebfca53ecae7$var$scheduleImmediateRootScheduleTask());
}
function $a971ebfca53ecae7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$a971ebfca53ecae7$var$isFlushingWork && $a971ebfca53ecae7$var$mightHavePendingSyncWork) {
        $a971ebfca53ecae7$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $a971ebfca53ecae7$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $a971ebfca53ecae7$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $a971ebfca53ecae7$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $a971ebfca53ecae7$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $a971ebfca53ecae7$var$getNextLanes(root$174, root$174 === $a971ebfca53ecae7$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $a971ebfca53ecae7$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $a971ebfca53ecae7$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $a971ebfca53ecae7$var$isFlushingWork = !1;
    }
}
function $a971ebfca53ecae7$var$processRootScheduleInImmediateTask() {
    $a971ebfca53ecae7$var$processRootScheduleInMicrotask();
}
function $a971ebfca53ecae7$var$processRootScheduleInMicrotask() {
    $a971ebfca53ecae7$var$mightHavePendingSyncWork = $a971ebfca53ecae7$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $a971ebfca53ecae7$var$currentEventTransitionLane && ($a971ebfca53ecae7$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $a971ebfca53ecae7$var$currentEventTransitionLane), $a971ebfca53ecae7$var$currentEventTransitionLane = 0);
    for(var currentTime = $a971ebfca53ecae7$var$now(), prev = null, root = $a971ebfca53ecae7$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $a971ebfca53ecae7$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $a971ebfca53ecae7$var$firstScheduledRoot = next : prev.next = next, null === next && ($a971ebfca53ecae7$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $a971ebfca53ecae7$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $a971ebfca53ecae7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $a971ebfca53ecae7$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $a971ebfca53ecae7$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $a971ebfca53ecae7$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $a971ebfca53ecae7$var$workInProgressRoot;
    suspendedLanes = $a971ebfca53ecae7$var$workInProgressRootRenderLanes;
    suspendedLanes = $a971ebfca53ecae7$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $a971ebfca53ecae7$var$workInProgressSuspendedReason || 9 === $a971ebfca53ecae7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $a971ebfca53ecae7$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $a971ebfca53ecae7$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $a971ebfca53ecae7$var$cancelCallback$1(pingedLanes);
        switch($a971ebfca53ecae7$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $a971ebfca53ecae7$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $a971ebfca53ecae7$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $a971ebfca53ecae7$var$IdlePriority;
                break;
            default:
                suspendedLanes = $a971ebfca53ecae7$var$NormalPriority$1;
        }
        pingedLanes = $a971ebfca53ecae7$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $a971ebfca53ecae7$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $a971ebfca53ecae7$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $a971ebfca53ecae7$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $a971ebfca53ecae7$var$pendingEffectsStatus && 5 !== $a971ebfca53ecae7$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($a971ebfca53ecae7$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $a971ebfca53ecae7$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $a971ebfca53ecae7$var$getNextLanes(root, root === $a971ebfca53ecae7$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $a971ebfca53ecae7$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $a971ebfca53ecae7$var$scheduleTaskForRootDuringMicrotask(root, $a971ebfca53ecae7$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $a971ebfca53ecae7$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $a971ebfca53ecae7$var$performSyncWorkOnRoot(root, lanes) {
    if ($a971ebfca53ecae7$var$flushPendingEffects()) return null;
    $a971ebfca53ecae7$var$performWorkOnRoot(root, lanes, !0);
}
function $a971ebfca53ecae7$var$scheduleImmediateRootScheduleTask() {
    $a971ebfca53ecae7$var$scheduleMicrotask(function() {
        0 !== ($a971ebfca53ecae7$var$executionContext & 6) ? $a971ebfca53ecae7$var$scheduleCallback$3($a971ebfca53ecae7$var$ImmediatePriority, $a971ebfca53ecae7$var$processRootScheduleInImmediateTask) : $a971ebfca53ecae7$var$processRootScheduleInMicrotask();
    });
}
function $a971ebfca53ecae7$var$requestTransitionLane() {
    0 === $a971ebfca53ecae7$var$currentEventTransitionLane && ($a971ebfca53ecae7$var$currentEventTransitionLane = $a971ebfca53ecae7$var$claimNextTransitionLane());
    return $a971ebfca53ecae7$var$currentEventTransitionLane;
}
function $a971ebfca53ecae7$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $a971ebfca53ecae7$var$sanitizeURL("" + actionProp);
}
function $a971ebfca53ecae7$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $a971ebfca53ecae7$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $a971ebfca53ecae7$var$coerceFormActionProp((nativeEventTarget[$a971ebfca53ecae7$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$a971ebfca53ecae7$var$internalPropsKey] || null) ? $a971ebfca53ecae7$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $a971ebfca53ecae7$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $a971ebfca53ecae7$var$currentEventTransitionLane) {
                                var formData = submitter ? $a971ebfca53ecae7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $a971ebfca53ecae7$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $a971ebfca53ecae7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $a971ebfca53ecae7$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $a971ebfca53ecae7$var$i$jscomp$inline_1528 = 0; $a971ebfca53ecae7$var$i$jscomp$inline_1528 < $a971ebfca53ecae7$var$simpleEventPluginEvents.length; $a971ebfca53ecae7$var$i$jscomp$inline_1528++){
    var $a971ebfca53ecae7$var$eventName$jscomp$inline_1529 = $a971ebfca53ecae7$var$simpleEventPluginEvents[$a971ebfca53ecae7$var$i$jscomp$inline_1528], $a971ebfca53ecae7$var$domEventName$jscomp$inline_1530 = $a971ebfca53ecae7$var$eventName$jscomp$inline_1529.toLowerCase(), $a971ebfca53ecae7$var$capitalizedEvent$jscomp$inline_1531 = $a971ebfca53ecae7$var$eventName$jscomp$inline_1529[0].toUpperCase() + $a971ebfca53ecae7$var$eventName$jscomp$inline_1529.slice(1);
    $a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$domEventName$jscomp$inline_1530, "on" + $a971ebfca53ecae7$var$capitalizedEvent$jscomp$inline_1531);
}
$a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$ANIMATION_END, "onAnimationEnd");
$a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$ANIMATION_ITERATION, "onAnimationIteration");
$a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$ANIMATION_START, "onAnimationStart");
$a971ebfca53ecae7$var$registerSimpleEvent("dblclick", "onDoubleClick");
$a971ebfca53ecae7$var$registerSimpleEvent("focusin", "onFocus");
$a971ebfca53ecae7$var$registerSimpleEvent("focusout", "onBlur");
$a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$TRANSITION_RUN, "onTransitionRun");
$a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$TRANSITION_START, "onTransitionStart");
$a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$TRANSITION_CANCEL, "onTransitionCancel");
$a971ebfca53ecae7$var$registerSimpleEvent($a971ebfca53ecae7$var$TRANSITION_END, "onTransitionEnd");
$a971ebfca53ecae7$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a971ebfca53ecae7$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a971ebfca53ecae7$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a971ebfca53ecae7$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a971ebfca53ecae7$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a971ebfca53ecae7$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a971ebfca53ecae7$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a971ebfca53ecae7$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a971ebfca53ecae7$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a971ebfca53ecae7$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a971ebfca53ecae7$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a971ebfca53ecae7$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($a971ebfca53ecae7$var$mediaEventTypes));
function $a971ebfca53ecae7$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $a971ebfca53ecae7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $a971ebfca53ecae7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $a971ebfca53ecae7$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$a971ebfca53ecae7$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$a971ebfca53ecae7$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($a971ebfca53ecae7$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $a971ebfca53ecae7$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $a971ebfca53ecae7$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $a971ebfca53ecae7$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $a971ebfca53ecae7$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$a971ebfca53ecae7$var$listeningMarker]) {
        rootContainerElement[$a971ebfca53ecae7$var$listeningMarker] = !0;
        $a971ebfca53ecae7$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($a971ebfca53ecae7$var$nonDelegatedEvents.has(domEventName) || $a971ebfca53ecae7$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $a971ebfca53ecae7$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$a971ebfca53ecae7$var$listeningMarker] || (ownerDocument[$a971ebfca53ecae7$var$listeningMarker] = !0, $a971ebfca53ecae7$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $a971ebfca53ecae7$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($a971ebfca53ecae7$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $a971ebfca53ecae7$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $a971ebfca53ecae7$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $a971ebfca53ecae7$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$a971ebfca53ecae7$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $a971ebfca53ecae7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $a971ebfca53ecae7$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $a971ebfca53ecae7$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $a971ebfca53ecae7$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $a971ebfca53ecae7$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $a971ebfca53ecae7$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticTouchEvent;
                        break;
                    case $a971ebfca53ecae7$var$ANIMATION_END:
                    case $a971ebfca53ecae7$var$ANIMATION_ITERATION:
                    case $a971ebfca53ecae7$var$ANIMATION_START:
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticAnimationEvent;
                        break;
                    case $a971ebfca53ecae7$var$TRANSITION_END:
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $a971ebfca53ecae7$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $a971ebfca53ecae7$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($a971ebfca53ecae7$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $a971ebfca53ecae7$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($a971ebfca53ecae7$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$a971ebfca53ecae7$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $a971ebfca53ecae7$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $a971ebfca53ecae7$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $a971ebfca53ecae7$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $a971ebfca53ecae7$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $a971ebfca53ecae7$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $a971ebfca53ecae7$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $a971ebfca53ecae7$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $a971ebfca53ecae7$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $a971ebfca53ecae7$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $a971ebfca53ecae7$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $a971ebfca53ecae7$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $a971ebfca53ecae7$var$getParent(inCapturePhase);
                                reactEventName = $a971ebfca53ecae7$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $a971ebfca53ecae7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $a971ebfca53ecae7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $a971ebfca53ecae7$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $a971ebfca53ecae7$var$getTargetInstForChangeEvent;
                else if ($a971ebfca53ecae7$var$isTextInputElement(reactName)) {
                    if ($a971ebfca53ecae7$var$isInputEventSupported) getTargetInstFunc = $a971ebfca53ecae7$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $a971ebfca53ecae7$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $a971ebfca53ecae7$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $a971ebfca53ecae7$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $a971ebfca53ecae7$var$getTargetInstForChangeEvent) : getTargetInstFunc = $a971ebfca53ecae7$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $a971ebfca53ecae7$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $a971ebfca53ecae7$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $a971ebfca53ecae7$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($a971ebfca53ecae7$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $a971ebfca53ecae7$var$activeElement = handleEventFunc, $a971ebfca53ecae7$var$activeElementInst = targetInst, $a971ebfca53ecae7$var$lastSelection = null;
                    break;
                case "focusout":
                    $a971ebfca53ecae7$var$lastSelection = $a971ebfca53ecae7$var$activeElementInst = $a971ebfca53ecae7$var$activeElement = null;
                    break;
                case "mousedown":
                    $a971ebfca53ecae7$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a971ebfca53ecae7$var$mouseDown = !1;
                    $a971ebfca53ecae7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($a971ebfca53ecae7$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $a971ebfca53ecae7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($a971ebfca53ecae7$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $a971ebfca53ecae7$var$isComposing ? $a971ebfca53ecae7$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($a971ebfca53ecae7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($a971ebfca53ecae7$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $a971ebfca53ecae7$var$isComposing && (fallbackData = $a971ebfca53ecae7$var$getData()) : ($a971ebfca53ecae7$var$root = nativeEventTarget, $a971ebfca53ecae7$var$startText = "value" in $a971ebfca53ecae7$var$root ? $a971ebfca53ecae7$var$root.value : $a971ebfca53ecae7$var$root.textContent, $a971ebfca53ecae7$var$isComposing = !0)), handleEventFunc = $a971ebfca53ecae7$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $a971ebfca53ecae7$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $a971ebfca53ecae7$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $a971ebfca53ecae7$var$canUseTextInputEvent ? $a971ebfca53ecae7$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $a971ebfca53ecae7$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $a971ebfca53ecae7$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $a971ebfca53ecae7$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $a971ebfca53ecae7$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $a971ebfca53ecae7$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $a971ebfca53ecae7$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $a971ebfca53ecae7$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $a971ebfca53ecae7$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($a971ebfca53ecae7$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $a971ebfca53ecae7$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($a971ebfca53ecae7$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $a971ebfca53ecae7$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $a971ebfca53ecae7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $a971ebfca53ecae7$var$getListener(target, registrationName), null != stateNode && listeners.unshift($a971ebfca53ecae7$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $a971ebfca53ecae7$var$getListener(target, registrationName), null != stateNode && listeners.push($a971ebfca53ecae7$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $a971ebfca53ecae7$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $a971ebfca53ecae7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $a971ebfca53ecae7$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($a971ebfca53ecae7$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($a971ebfca53ecae7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $a971ebfca53ecae7$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $a971ebfca53ecae7$var$normalizeMarkupForTextOrAttribute(clientText);
    return $a971ebfca53ecae7$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $a971ebfca53ecae7$var$noop$1() {}
function $a971ebfca53ecae7$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $a971ebfca53ecae7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $a971ebfca53ecae7$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $a971ebfca53ecae7$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $a971ebfca53ecae7$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $a971ebfca53ecae7$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $a971ebfca53ecae7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $a971ebfca53ecae7$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $a971ebfca53ecae7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $a971ebfca53ecae7$var$setProp(domElement, tag, "name", props.name, props, null), $a971ebfca53ecae7$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $a971ebfca53ecae7$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $a971ebfca53ecae7$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($a971ebfca53ecae7$var$setProp(domElement, tag, "encType", props.encType, props, null), $a971ebfca53ecae7$var$setProp(domElement, tag, "method", props.method, props, null), $a971ebfca53ecae7$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $a971ebfca53ecae7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $a971ebfca53ecae7$var$noop$1);
            break;
        case "onScroll":
            null != value && $a971ebfca53ecae7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $a971ebfca53ecae7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $a971ebfca53ecae7$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("toggle", domElement);
            $a971ebfca53ecae7$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $a971ebfca53ecae7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $a971ebfca53ecae7$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $a971ebfca53ecae7$var$aliases.get(key) || key, $a971ebfca53ecae7$var$setValueForAttribute(domElement, key, value);
    }
}
function $a971ebfca53ecae7$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $a971ebfca53ecae7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $a971ebfca53ecae7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $a971ebfca53ecae7$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $a971ebfca53ecae7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $a971ebfca53ecae7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $a971ebfca53ecae7$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$a971ebfca53ecae7$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$a971ebfca53ecae7$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $a971ebfca53ecae7$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $a971ebfca53ecae7$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("error", domElement);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(137, tag));
                    default:
                        $a971ebfca53ecae7$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $a971ebfca53ecae7$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $a971ebfca53ecae7$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $a971ebfca53ecae7$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $a971ebfca53ecae7$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $a971ebfca53ecae7$var$track(domElement);
            return;
        case "select":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $a971ebfca53ecae7$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $a971ebfca53ecae7$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(91));
                    break;
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $a971ebfca53ecae7$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $a971ebfca53ecae7$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("toggle", domElement);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("cancel", domElement);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $a971ebfca53ecae7$var$mediaEventTypes.length; hasSrc++)$a971ebfca53ecae7$var$listenToNonDelegatedEvent($a971ebfca53ecae7$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("error", domElement);
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $a971ebfca53ecae7$var$listenToNonDelegatedEvent("error", domElement), $a971ebfca53ecae7$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(137, tag));
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($a971ebfca53ecae7$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $a971ebfca53ecae7$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $a971ebfca53ecae7$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $a971ebfca53ecae7$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $a971ebfca53ecae7$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $a971ebfca53ecae7$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $a971ebfca53ecae7$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $a971ebfca53ecae7$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $a971ebfca53ecae7$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $a971ebfca53ecae7$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $a971ebfca53ecae7$var$updateOptions(domElement, !!lastProps, tag, !0) : $a971ebfca53ecae7$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $a971ebfca53ecae7$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $a971ebfca53ecae7$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $a971ebfca53ecae7$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $a971ebfca53ecae7$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($a971ebfca53ecae7$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $a971ebfca53ecae7$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $a971ebfca53ecae7$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $a971ebfca53ecae7$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $a971ebfca53ecae7$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $a971ebfca53ecae7$var$eventsEnabled = null, $a971ebfca53ecae7$var$selectionInformation = null;
function $a971ebfca53ecae7$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $a971ebfca53ecae7$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $a971ebfca53ecae7$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $a971ebfca53ecae7$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $a971ebfca53ecae7$var$currentPopstateTransitionEvent = null;
function $a971ebfca53ecae7$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $a971ebfca53ecae7$var$currentPopstateTransitionEvent) return !1;
        $a971ebfca53ecae7$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $a971ebfca53ecae7$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $a971ebfca53ecae7$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $a971ebfca53ecae7$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $a971ebfca53ecae7$var$localPromise = "function" === typeof Promise ? Promise : void 0, $a971ebfca53ecae7$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a971ebfca53ecae7$var$localPromise ? function(callback) {
    return $a971ebfca53ecae7$var$localPromise.resolve(null).then(callback).catch($a971ebfca53ecae7$var$handleErrorInNextTick);
} : $a971ebfca53ecae7$var$scheduleTimeout;
function $a971ebfca53ecae7$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $a971ebfca53ecae7$var$isSingletonScope(type) {
    return "head" === type;
}
function $a971ebfca53ecae7$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $a971ebfca53ecae7$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $a971ebfca53ecae7$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $a971ebfca53ecae7$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$a971ebfca53ecae7$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $a971ebfca53ecae7$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $a971ebfca53ecae7$var$retryIfBlockedOn(suspenseInstance);
}
function $a971ebfca53ecae7$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $a971ebfca53ecae7$var$clearContainerSparingly(node);
                $a971ebfca53ecae7$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $a971ebfca53ecae7$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$a971ebfca53ecae7$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $a971ebfca53ecae7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $a971ebfca53ecae7$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $a971ebfca53ecae7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $a971ebfca53ecae7$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $a971ebfca53ecae7$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $a971ebfca53ecae7$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $a971ebfca53ecae7$var$previousHydratableOnEnteringScopedSingleton = null;
function $a971ebfca53ecae7$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $a971ebfca53ecae7$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $a971ebfca53ecae7$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(451));
    }
}
function $a971ebfca53ecae7$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $a971ebfca53ecae7$var$detachDeletedInstance(instance);
}
var $a971ebfca53ecae7$var$preloadPropsMap = new Map(), $a971ebfca53ecae7$var$preconnectsSet = new Set();
function $a971ebfca53ecae7$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $a971ebfca53ecae7$var$previousDispatcher = $a971ebfca53ecae7$var$ReactDOMSharedInternals.d;
$a971ebfca53ecae7$var$ReactDOMSharedInternals.d = {
    f: $a971ebfca53ecae7$var$flushSyncWork,
    r: $a971ebfca53ecae7$var$requestFormReset,
    D: $a971ebfca53ecae7$var$prefetchDNS,
    C: $a971ebfca53ecae7$var$preconnect,
    L: $a971ebfca53ecae7$var$preload,
    m: $a971ebfca53ecae7$var$preloadModule,
    X: $a971ebfca53ecae7$var$preinitScript,
    S: $a971ebfca53ecae7$var$preinitStyle,
    M: $a971ebfca53ecae7$var$preinitModuleScript
};
function $a971ebfca53ecae7$var$flushSyncWork() {
    var previousWasRendering = $a971ebfca53ecae7$var$previousDispatcher.f(), wasRendering = $a971ebfca53ecae7$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $a971ebfca53ecae7$var$requestFormReset(form) {
    var formInst = $a971ebfca53ecae7$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $a971ebfca53ecae7$var$requestFormReset$1(formInst) : $a971ebfca53ecae7$var$previousDispatcher.r(form);
}
var $a971ebfca53ecae7$var$globalDocument = "undefined" === typeof document ? null : document;
function $a971ebfca53ecae7$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $a971ebfca53ecae7$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $a971ebfca53ecae7$var$preconnectsSet.has(limitedEscapedHref) || ($a971ebfca53ecae7$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $a971ebfca53ecae7$var$setInitialProperties(href, "link", rel), $a971ebfca53ecae7$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $a971ebfca53ecae7$var$prefetchDNS(href) {
    $a971ebfca53ecae7$var$previousDispatcher.D(href);
    $a971ebfca53ecae7$var$preconnectAs("dns-prefetch", href, null);
}
function $a971ebfca53ecae7$var$preconnect(href, crossOrigin) {
    $a971ebfca53ecae7$var$previousDispatcher.C(href, crossOrigin);
    $a971ebfca53ecae7$var$preconnectAs("preconnect", href, crossOrigin);
}
function $a971ebfca53ecae7$var$preload(href, as, options) {
    $a971ebfca53ecae7$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $a971ebfca53ecae7$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $a971ebfca53ecae7$var$getStyleKey(href);
                break;
            case "script":
                key = $a971ebfca53ecae7$var$getScriptKey(href);
        }
        $a971ebfca53ecae7$var$preloadPropsMap.has(key) || (href = $a971ebfca53ecae7$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $a971ebfca53ecae7$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($a971ebfca53ecae7$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($a971ebfca53ecae7$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $a971ebfca53ecae7$var$setInitialProperties(as, "link", href), $a971ebfca53ecae7$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $a971ebfca53ecae7$var$preloadModule(href, options) {
    $a971ebfca53ecae7$var$previousDispatcher.m(href, options);
    var ownerDocument = $a971ebfca53ecae7$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $a971ebfca53ecae7$var$getScriptKey(href);
        }
        if (!$a971ebfca53ecae7$var$preloadPropsMap.has(key) && (href = $a971ebfca53ecae7$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $a971ebfca53ecae7$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($a971ebfca53ecae7$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $a971ebfca53ecae7$var$setInitialProperties(as, "link", href);
            $a971ebfca53ecae7$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $a971ebfca53ecae7$var$preinitStyle(href, precedence, options) {
    $a971ebfca53ecae7$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $a971ebfca53ecae7$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $a971ebfca53ecae7$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $a971ebfca53ecae7$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($a971ebfca53ecae7$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $a971ebfca53ecae7$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $a971ebfca53ecae7$var$preloadPropsMap.get(key)) && $a971ebfca53ecae7$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $a971ebfca53ecae7$var$markNodeAsHoistable(link);
                $a971ebfca53ecae7$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $a971ebfca53ecae7$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $a971ebfca53ecae7$var$preinitScript(src, options) {
    $a971ebfca53ecae7$var$previousDispatcher.X(src, options);
    var ownerDocument = $a971ebfca53ecae7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $a971ebfca53ecae7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $a971ebfca53ecae7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($a971ebfca53ecae7$var$getScriptSelectorFromKey(key)), resource || (src = $a971ebfca53ecae7$var$assign({
            src: src,
            async: !0
        }, options), (options = $a971ebfca53ecae7$var$preloadPropsMap.get(key)) && $a971ebfca53ecae7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $a971ebfca53ecae7$var$markNodeAsHoistable(resource), $a971ebfca53ecae7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $a971ebfca53ecae7$var$preinitModuleScript(src, options) {
    $a971ebfca53ecae7$var$previousDispatcher.M(src, options);
    var ownerDocument = $a971ebfca53ecae7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $a971ebfca53ecae7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $a971ebfca53ecae7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($a971ebfca53ecae7$var$getScriptSelectorFromKey(key)), resource || (src = $a971ebfca53ecae7$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $a971ebfca53ecae7$var$preloadPropsMap.get(key)) && $a971ebfca53ecae7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $a971ebfca53ecae7$var$markNodeAsHoistable(resource), $a971ebfca53ecae7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $a971ebfca53ecae7$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $a971ebfca53ecae7$var$rootInstanceStackCursor.current) ? $a971ebfca53ecae7$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $a971ebfca53ecae7$var$getStyleKey(pendingProps.href), pendingProps = $a971ebfca53ecae7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $a971ebfca53ecae7$var$getStyleKey(pendingProps.href);
                var styles$244 = $a971ebfca53ecae7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($a971ebfca53ecae7$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $a971ebfca53ecae7$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $a971ebfca53ecae7$var$preloadPropsMap.set(type, pendingProps), styles$244 || $a971ebfca53ecae7$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $a971ebfca53ecae7$var$getScriptKey(pendingProps), pendingProps = $a971ebfca53ecae7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(444, type));
    }
}
function $a971ebfca53ecae7$var$getStyleKey(href) {
    return 'href="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $a971ebfca53ecae7$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $a971ebfca53ecae7$var$stylesheetPropsFromRawProps(rawProps) {
    return $a971ebfca53ecae7$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $a971ebfca53ecae7$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $a971ebfca53ecae7$var$setInitialProperties(key, "link", preloadProps), $a971ebfca53ecae7$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $a971ebfca53ecae7$var$getScriptKey(src) {
    return '[src="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $a971ebfca53ecae7$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $a971ebfca53ecae7$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $a971ebfca53ecae7$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $a971ebfca53ecae7$var$markNodeAsHoistable(instance), instance;
            var styleProps = $a971ebfca53ecae7$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $a971ebfca53ecae7$var$markNodeAsHoistable(instance);
            $a971ebfca53ecae7$var$setInitialProperties(instance, "style", styleProps);
            $a971ebfca53ecae7$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $a971ebfca53ecae7$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($a971ebfca53ecae7$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $a971ebfca53ecae7$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $a971ebfca53ecae7$var$stylesheetPropsFromRawProps(props);
            (styleProps = $a971ebfca53ecae7$var$preloadPropsMap.get(styleProps)) && $a971ebfca53ecae7$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $a971ebfca53ecae7$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $a971ebfca53ecae7$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $a971ebfca53ecae7$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $a971ebfca53ecae7$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($a971ebfca53ecae7$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $a971ebfca53ecae7$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $a971ebfca53ecae7$var$preloadPropsMap.get(instance$250)) instance = $a971ebfca53ecae7$var$assign({}, props), $a971ebfca53ecae7$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $a971ebfca53ecae7$var$markNodeAsHoistable(styleProps);
            $a971ebfca53ecae7$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $a971ebfca53ecae7$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $a971ebfca53ecae7$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $a971ebfca53ecae7$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $a971ebfca53ecae7$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $a971ebfca53ecae7$var$tagCaches = null;
function $a971ebfca53ecae7$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $a971ebfca53ecae7$var$tagCaches) {
        var cache = new Map();
        var caches = $a971ebfca53ecae7$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $a971ebfca53ecae7$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$a971ebfca53ecae7$var$internalHoistableMarker] || node[$a971ebfca53ecae7$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $a971ebfca53ecae7$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $a971ebfca53ecae7$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $a971ebfca53ecae7$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $a971ebfca53ecae7$var$suspendedState = null;
function $a971ebfca53ecae7$var$noop() {}
function $a971ebfca53ecae7$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $a971ebfca53ecae7$var$suspendedState) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(475));
    var state = $a971ebfca53ecae7$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $a971ebfca53ecae7$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($a971ebfca53ecae7$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $a971ebfca53ecae7$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $a971ebfca53ecae7$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $a971ebfca53ecae7$var$stylesheetPropsFromRawProps(props);
            (key = $a971ebfca53ecae7$var$preloadPropsMap.get(key)) && $a971ebfca53ecae7$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $a971ebfca53ecae7$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $a971ebfca53ecae7$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $a971ebfca53ecae7$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $a971ebfca53ecae7$var$waitForCommitToBeReady() {
    if (null === $a971ebfca53ecae7$var$suspendedState) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(475));
    var state = $a971ebfca53ecae7$var$suspendedState;
    state.stylesheets && 0 === state.count && $a971ebfca53ecae7$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $a971ebfca53ecae7$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $a971ebfca53ecae7$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $a971ebfca53ecae7$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $a971ebfca53ecae7$var$precedencesByRoot = null;
function $a971ebfca53ecae7$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $a971ebfca53ecae7$var$precedencesByRoot = new Map(), resources.forEach($a971ebfca53ecae7$var$insertStylesheetIntoRoot, state), $a971ebfca53ecae7$var$precedencesByRoot = null, $a971ebfca53ecae7$var$onUnsuspend.call(state));
}
function $a971ebfca53ecae7$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $a971ebfca53ecae7$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $a971ebfca53ecae7$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $a971ebfca53ecae7$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $a971ebfca53ecae7$var$HostTransitionContext = {
    $$typeof: $a971ebfca53ecae7$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $a971ebfca53ecae7$var$sharedNotPendingObject,
    _currentValue2: $a971ebfca53ecae7$var$sharedNotPendingObject,
    _threadCount: 0
};
function $a971ebfca53ecae7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $a971ebfca53ecae7$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a971ebfca53ecae7$var$createLaneMap(0);
    this.hiddenUpdates = $a971ebfca53ecae7$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $a971ebfca53ecae7$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $a971ebfca53ecae7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $a971ebfca53ecae7$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $a971ebfca53ecae7$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $a971ebfca53ecae7$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $a971ebfca53ecae7$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $a971ebfca53ecae7$var$emptyContextObject;
    parentComponent = $a971ebfca53ecae7$var$emptyContextObject;
    return parentComponent;
}
function $a971ebfca53ecae7$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $a971ebfca53ecae7$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $a971ebfca53ecae7$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $a971ebfca53ecae7$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($a971ebfca53ecae7$var$scheduleUpdateOnFiber(element, rootFiber, lane), $a971ebfca53ecae7$var$entangleTransitions(element, rootFiber, lane));
}
function $a971ebfca53ecae7$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $a971ebfca53ecae7$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $a971ebfca53ecae7$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $a971ebfca53ecae7$var$markRetryLaneImpl(fiber, retryLane);
}
function $a971ebfca53ecae7$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $a971ebfca53ecae7$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $a971ebfca53ecae7$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $a971ebfca53ecae7$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $a971ebfca53ecae7$var$_enabled = !0;
function $a971ebfca53ecae7$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $a971ebfca53ecae7$var$ReactSharedInternals.T;
    $a971ebfca53ecae7$var$ReactSharedInternals.T = null;
    var previousPriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
    try {
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 2, $a971ebfca53ecae7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = previousPriority, $a971ebfca53ecae7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a971ebfca53ecae7$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $a971ebfca53ecae7$var$ReactSharedInternals.T;
    $a971ebfca53ecae7$var$ReactSharedInternals.T = null;
    var previousPriority = $a971ebfca53ecae7$var$ReactDOMSharedInternals.p;
    try {
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = 8, $a971ebfca53ecae7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $a971ebfca53ecae7$var$ReactDOMSharedInternals.p = previousPriority, $a971ebfca53ecae7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a971ebfca53ecae7$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($a971ebfca53ecae7$var$_enabled) {
        var blockedOn = $a971ebfca53ecae7$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $a971ebfca53ecae7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $a971ebfca53ecae7$var$return_targetInst, targetContainer), $a971ebfca53ecae7$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($a971ebfca53ecae7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($a971ebfca53ecae7$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $a971ebfca53ecae7$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $a971ebfca53ecae7$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $a971ebfca53ecae7$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $a971ebfca53ecae7$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $a971ebfca53ecae7$var$ensureRootIsScheduled(fiber);
                                0 === ($a971ebfca53ecae7$var$executionContext & 6) && ($a971ebfca53ecae7$var$workInProgressRootRenderTargetTime = $a971ebfca53ecae7$var$now() + 500, $a971ebfca53ecae7$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $a971ebfca53ecae7$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $a971ebfca53ecae7$var$scheduleUpdateOnFiber(root, fiber, 2), $a971ebfca53ecae7$var$flushSyncWork$1(), $a971ebfca53ecae7$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $a971ebfca53ecae7$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $a971ebfca53ecae7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $a971ebfca53ecae7$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $a971ebfca53ecae7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $a971ebfca53ecae7$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $a971ebfca53ecae7$var$getEventTarget(nativeEvent);
    return $a971ebfca53ecae7$var$findInstanceBlockingTarget(nativeEvent);
}
var $a971ebfca53ecae7$var$return_targetInst = null;
function $a971ebfca53ecae7$var$findInstanceBlockingTarget(targetNode) {
    $a971ebfca53ecae7$var$return_targetInst = null;
    targetNode = $a971ebfca53ecae7$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $a971ebfca53ecae7$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $a971ebfca53ecae7$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $a971ebfca53ecae7$var$return_targetInst = targetNode;
    return null;
}
function $a971ebfca53ecae7$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($a971ebfca53ecae7$var$getCurrentPriorityLevel()){
                case $a971ebfca53ecae7$var$ImmediatePriority:
                    return 2;
                case $a971ebfca53ecae7$var$UserBlockingPriority:
                    return 8;
                case $a971ebfca53ecae7$var$NormalPriority$1:
                case $a971ebfca53ecae7$var$LowPriority:
                    return 32;
                case $a971ebfca53ecae7$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $a971ebfca53ecae7$var$hasScheduledReplayAttempt = !1, $a971ebfca53ecae7$var$queuedFocus = null, $a971ebfca53ecae7$var$queuedDrag = null, $a971ebfca53ecae7$var$queuedMouse = null, $a971ebfca53ecae7$var$queuedPointers = new Map(), $a971ebfca53ecae7$var$queuedPointerCaptures = new Map(), $a971ebfca53ecae7$var$queuedExplicitHydrationTargets = [], $a971ebfca53ecae7$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $a971ebfca53ecae7$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $a971ebfca53ecae7$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $a971ebfca53ecae7$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $a971ebfca53ecae7$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $a971ebfca53ecae7$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a971ebfca53ecae7$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $a971ebfca53ecae7$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $a971ebfca53ecae7$var$getInstanceFromNode(blockedOn), null !== blockedOn && $a971ebfca53ecae7$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $a971ebfca53ecae7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $a971ebfca53ecae7$var$queuedFocus = $a971ebfca53ecae7$var$accumulateOrCreateContinuousQueuedReplayableEvent($a971ebfca53ecae7$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $a971ebfca53ecae7$var$queuedDrag = $a971ebfca53ecae7$var$accumulateOrCreateContinuousQueuedReplayableEvent($a971ebfca53ecae7$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $a971ebfca53ecae7$var$queuedMouse = $a971ebfca53ecae7$var$accumulateOrCreateContinuousQueuedReplayableEvent($a971ebfca53ecae7$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $a971ebfca53ecae7$var$queuedPointers.set(pointerId, $a971ebfca53ecae7$var$accumulateOrCreateContinuousQueuedReplayableEvent($a971ebfca53ecae7$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $a971ebfca53ecae7$var$queuedPointerCaptures.set(pointerId, $a971ebfca53ecae7$var$accumulateOrCreateContinuousQueuedReplayableEvent($a971ebfca53ecae7$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $a971ebfca53ecae7$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $a971ebfca53ecae7$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $a971ebfca53ecae7$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $a971ebfca53ecae7$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $a971ebfca53ecae7$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $a971ebfca53ecae7$var$requestUpdateLane();
                            lane = $a971ebfca53ecae7$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $a971ebfca53ecae7$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $a971ebfca53ecae7$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $a971ebfca53ecae7$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $a971ebfca53ecae7$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $a971ebfca53ecae7$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $a971ebfca53ecae7$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $a971ebfca53ecae7$var$currentReplayingEvent = null;
        } else return targetContainers = $a971ebfca53ecae7$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $a971ebfca53ecae7$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $a971ebfca53ecae7$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $a971ebfca53ecae7$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $a971ebfca53ecae7$var$replayUnblockedEvents() {
    $a971ebfca53ecae7$var$hasScheduledReplayAttempt = !1;
    null !== $a971ebfca53ecae7$var$queuedFocus && $a971ebfca53ecae7$var$attemptReplayContinuousQueuedEvent($a971ebfca53ecae7$var$queuedFocus) && ($a971ebfca53ecae7$var$queuedFocus = null);
    null !== $a971ebfca53ecae7$var$queuedDrag && $a971ebfca53ecae7$var$attemptReplayContinuousQueuedEvent($a971ebfca53ecae7$var$queuedDrag) && ($a971ebfca53ecae7$var$queuedDrag = null);
    null !== $a971ebfca53ecae7$var$queuedMouse && $a971ebfca53ecae7$var$attemptReplayContinuousQueuedEvent($a971ebfca53ecae7$var$queuedMouse) && ($a971ebfca53ecae7$var$queuedMouse = null);
    $a971ebfca53ecae7$var$queuedPointers.forEach($a971ebfca53ecae7$var$attemptReplayContinuousQueuedEventInMap);
    $a971ebfca53ecae7$var$queuedPointerCaptures.forEach($a971ebfca53ecae7$var$attemptReplayContinuousQueuedEventInMap);
}
function $a971ebfca53ecae7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $a971ebfca53ecae7$var$hasScheduledReplayAttempt || ($a971ebfca53ecae7$var$hasScheduledReplayAttempt = !0, $d0NqH.unstable_scheduleCallback($d0NqH.unstable_NormalPriority, $a971ebfca53ecae7$var$replayUnblockedEvents)));
}
var $a971ebfca53ecae7$var$lastScheduledReplayQueue = null;
function $a971ebfca53ecae7$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $a971ebfca53ecae7$var$lastScheduledReplayQueue !== formReplayingQueue && ($a971ebfca53ecae7$var$lastScheduledReplayQueue = formReplayingQueue, $d0NqH.unstable_scheduleCallback($d0NqH.unstable_NormalPriority, function() {
        $a971ebfca53ecae7$var$lastScheduledReplayQueue === formReplayingQueue && ($a971ebfca53ecae7$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $a971ebfca53ecae7$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $a971ebfca53ecae7$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $a971ebfca53ecae7$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $a971ebfca53ecae7$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $a971ebfca53ecae7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $a971ebfca53ecae7$var$queuedFocus && $a971ebfca53ecae7$var$scheduleCallbackIfUnblocked($a971ebfca53ecae7$var$queuedFocus, unblocked);
    null !== $a971ebfca53ecae7$var$queuedDrag && $a971ebfca53ecae7$var$scheduleCallbackIfUnblocked($a971ebfca53ecae7$var$queuedDrag, unblocked);
    null !== $a971ebfca53ecae7$var$queuedMouse && $a971ebfca53ecae7$var$scheduleCallbackIfUnblocked($a971ebfca53ecae7$var$queuedMouse, unblocked);
    $a971ebfca53ecae7$var$queuedPointers.forEach(unblock);
    $a971ebfca53ecae7$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $a971ebfca53ecae7$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $a971ebfca53ecae7$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $a971ebfca53ecae7$var$queuedExplicitHydrationTargets.length && (i = $a971ebfca53ecae7$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$a971ebfca53ecae7$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $a971ebfca53ecae7$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$a971ebfca53ecae7$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $a971ebfca53ecae7$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$a971ebfca53ecae7$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $a971ebfca53ecae7$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $a971ebfca53ecae7$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $a971ebfca53ecae7$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$a971ebfca53ecae7$var$ReactDOMHydrationRoot.prototype.render = $a971ebfca53ecae7$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(409));
    var current = root.current, lane = $a971ebfca53ecae7$var$requestUpdateLane();
    $a971ebfca53ecae7$var$updateContainerImpl(current, lane, children, root, null, null);
};
$a971ebfca53ecae7$var$ReactDOMHydrationRoot.prototype.unmount = $a971ebfca53ecae7$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $a971ebfca53ecae7$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $a971ebfca53ecae7$var$flushSyncWork$1();
        container[$a971ebfca53ecae7$var$internalContainerInstanceKey] = null;
    }
};
function $a971ebfca53ecae7$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$a971ebfca53ecae7$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $a971ebfca53ecae7$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $a971ebfca53ecae7$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $a971ebfca53ecae7$var$queuedExplicitHydrationTargets[i].priority; i++);
        $a971ebfca53ecae7$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $a971ebfca53ecae7$var$attemptExplicitHydrationTarget(target);
    }
};
var $a971ebfca53ecae7$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $cvMSo.version;
if ("19.1.0" !== $a971ebfca53ecae7$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(527, $a971ebfca53ecae7$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$a971ebfca53ecae7$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $a971ebfca53ecae7$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $a971ebfca53ecae7$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $a971ebfca53ecae7$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $a971ebfca53ecae7$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a971ebfca53ecae7$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a971ebfca53ecae7$var$hook$jscomp$inline_2257.isDisabled && $a971ebfca53ecae7$var$hook$jscomp$inline_2257.supportsFiber) try {
        $a971ebfca53ecae7$var$rendererID = $a971ebfca53ecae7$var$hook$jscomp$inline_2257.inject($a971ebfca53ecae7$var$internals$jscomp$inline_2256), $a971ebfca53ecae7$var$injectedHook = $a971ebfca53ecae7$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$a971ebfca53ecae7$export$882461b6382ed46c = function(container, options) {
    if (!$a971ebfca53ecae7$var$isValidContainer(container)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $a971ebfca53ecae7$var$defaultOnUncaughtError, onCaughtError = $a971ebfca53ecae7$var$defaultOnCaughtError, onRecoverableError = $a971ebfca53ecae7$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $a971ebfca53ecae7$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$a971ebfca53ecae7$var$internalContainerInstanceKey] = options.current;
    $a971ebfca53ecae7$var$listenToAllSupportedEvents(container);
    return new $a971ebfca53ecae7$var$ReactDOMRoot(options);
};
$a971ebfca53ecae7$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$a971ebfca53ecae7$var$isValidContainer(container)) throw Error($a971ebfca53ecae7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $a971ebfca53ecae7$var$defaultOnUncaughtError, onCaughtError = $a971ebfca53ecae7$var$defaultOnCaughtError, onRecoverableError = $a971ebfca53ecae7$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $a971ebfca53ecae7$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $a971ebfca53ecae7$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $a971ebfca53ecae7$var$requestUpdateLane();
    isStrictMode = $a971ebfca53ecae7$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $a971ebfca53ecae7$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $a971ebfca53ecae7$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $a971ebfca53ecae7$var$markRootUpdated$1(initialChildren, options);
    $a971ebfca53ecae7$var$ensureRootIsScheduled(initialChildren);
    container[$a971ebfca53ecae7$var$internalContainerInstanceKey] = initialChildren.current;
    $a971ebfca53ecae7$var$listenToAllSupportedEvents(container);
    return new $a971ebfca53ecae7$var$ReactDOMHydrationRoot(initialChildren);
};
$a971ebfca53ecae7$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("d0NqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bZJ6H"));

});
parcelRegister("bZJ6H", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $8bb86185b1d7205b$export$c4744153514ff05d; }, function (v) { return $8bb86185b1d7205b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $8bb86185b1d7205b$export$3e506c1ccc9cc1a7; }, function (v) { return $8bb86185b1d7205b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $8bb86185b1d7205b$export$e26fe2ed2fa76875; }, function (v) { return $8bb86185b1d7205b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $8bb86185b1d7205b$export$502329bbf4b505b1; }, function (v) { return $8bb86185b1d7205b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $8bb86185b1d7205b$export$6e3807111c4874c4; }, function (v) { return $8bb86185b1d7205b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $8bb86185b1d7205b$export$c27134553091fb3a; }, function (v) { return $8bb86185b1d7205b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $8bb86185b1d7205b$export$33ee1acdc04fd2a2; }, function (v) { return $8bb86185b1d7205b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $8bb86185b1d7205b$export$b00a404bbd5edef2; }, function (v) { return $8bb86185b1d7205b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $8bb86185b1d7205b$export$d66a1c1c77bd778b; }, function (v) { return $8bb86185b1d7205b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $8bb86185b1d7205b$export$d3dfb8e4810cb555; }, function (v) { return $8bb86185b1d7205b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $8bb86185b1d7205b$export$72fdf0e06517287b; }, function (v) { return $8bb86185b1d7205b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $8bb86185b1d7205b$export$816d2913ae6b83b1; }, function (v) { return $8bb86185b1d7205b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $8bb86185b1d7205b$export$61bcfe829111a1d0; }, function (v) { return $8bb86185b1d7205b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $8bb86185b1d7205b$export$7ee8c9beb337bc3f; }, function (v) { return $8bb86185b1d7205b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $8bb86185b1d7205b$export$b5836b71941fa3ed; }, function (v) { return $8bb86185b1d7205b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $8bb86185b1d7205b$export$cf845f2c119da08a; }, function (v) { return $8bb86185b1d7205b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bb86185b1d7205b$export$c4744153514ff05d;
var $8bb86185b1d7205b$export$3e506c1ccc9cc1a7;
var $8bb86185b1d7205b$export$e26fe2ed2fa76875;
var $8bb86185b1d7205b$export$502329bbf4b505b1;
var $8bb86185b1d7205b$export$6e3807111c4874c4;
var $8bb86185b1d7205b$export$c27134553091fb3a;
var $8bb86185b1d7205b$export$33ee1acdc04fd2a2;
var $8bb86185b1d7205b$export$b00a404bbd5edef2;
var $8bb86185b1d7205b$export$d66a1c1c77bd778b;
var $8bb86185b1d7205b$export$d3dfb8e4810cb555;
var $8bb86185b1d7205b$export$72fdf0e06517287b;
var $8bb86185b1d7205b$export$816d2913ae6b83b1;
var $8bb86185b1d7205b$export$61bcfe829111a1d0;
var $8bb86185b1d7205b$export$7ee8c9beb337bc3f;
var $8bb86185b1d7205b$export$b5836b71941fa3ed;
var $8bb86185b1d7205b$export$cf845f2c119da08a;
"use strict";
function $8bb86185b1d7205b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $8bb86185b1d7205b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $8bb86185b1d7205b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $8bb86185b1d7205b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $8bb86185b1d7205b$var$compare(left, last)) rightIndex < length && 0 > $8bb86185b1d7205b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $8bb86185b1d7205b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $8bb86185b1d7205b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$8bb86185b1d7205b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $8bb86185b1d7205b$var$localPerformance = performance;
    $8bb86185b1d7205b$export$c4744153514ff05d = function() {
        return $8bb86185b1d7205b$var$localPerformance.now();
    };
} else {
    var $8bb86185b1d7205b$var$localDate = Date, $8bb86185b1d7205b$var$initialTime = $8bb86185b1d7205b$var$localDate.now();
    $8bb86185b1d7205b$export$c4744153514ff05d = function() {
        return $8bb86185b1d7205b$var$localDate.now() - $8bb86185b1d7205b$var$initialTime;
    };
}
var $8bb86185b1d7205b$var$taskQueue = [], $8bb86185b1d7205b$var$timerQueue = [], $8bb86185b1d7205b$var$taskIdCounter = 1, $8bb86185b1d7205b$var$currentTask = null, $8bb86185b1d7205b$var$currentPriorityLevel = 3, $8bb86185b1d7205b$var$isPerformingWork = !1, $8bb86185b1d7205b$var$isHostCallbackScheduled = !1, $8bb86185b1d7205b$var$isHostTimeoutScheduled = !1, $8bb86185b1d7205b$var$needsPaint = !1, $8bb86185b1d7205b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $8bb86185b1d7205b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $8bb86185b1d7205b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $8bb86185b1d7205b$var$advanceTimers(currentTime) {
    for(var timer = $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $8bb86185b1d7205b$var$pop($8bb86185b1d7205b$var$timerQueue);
        else if (timer.startTime <= currentTime) $8bb86185b1d7205b$var$pop($8bb86185b1d7205b$var$timerQueue), timer.sortIndex = timer.expirationTime, $8bb86185b1d7205b$var$push($8bb86185b1d7205b$var$taskQueue, timer);
        else break;
        timer = $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$timerQueue);
    }
}
function $8bb86185b1d7205b$var$handleTimeout(currentTime) {
    $8bb86185b1d7205b$var$isHostTimeoutScheduled = !1;
    $8bb86185b1d7205b$var$advanceTimers(currentTime);
    if (!$8bb86185b1d7205b$var$isHostCallbackScheduled) {
        if (null !== $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$taskQueue)) $8bb86185b1d7205b$var$isHostCallbackScheduled = !0, $8bb86185b1d7205b$var$isMessageLoopRunning || ($8bb86185b1d7205b$var$isMessageLoopRunning = !0, $8bb86185b1d7205b$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$timerQueue);
            null !== firstTimer && $8bb86185b1d7205b$var$requestHostTimeout($8bb86185b1d7205b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $8bb86185b1d7205b$var$isMessageLoopRunning = !1, $8bb86185b1d7205b$var$taskTimeoutID = -1, $8bb86185b1d7205b$var$frameInterval = 5, $8bb86185b1d7205b$var$startTime = -1;
function $8bb86185b1d7205b$var$shouldYieldToHost() {
    return $8bb86185b1d7205b$var$needsPaint ? !0 : $8bb86185b1d7205b$export$c4744153514ff05d() - $8bb86185b1d7205b$var$startTime < $8bb86185b1d7205b$var$frameInterval ? !1 : !0;
}
function $8bb86185b1d7205b$var$performWorkUntilDeadline() {
    $8bb86185b1d7205b$var$needsPaint = !1;
    if ($8bb86185b1d7205b$var$isMessageLoopRunning) {
        var currentTime = $8bb86185b1d7205b$export$c4744153514ff05d();
        $8bb86185b1d7205b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $8bb86185b1d7205b$var$isHostCallbackScheduled = !1;
                $8bb86185b1d7205b$var$isHostTimeoutScheduled && ($8bb86185b1d7205b$var$isHostTimeoutScheduled = !1, $8bb86185b1d7205b$var$localClearTimeout($8bb86185b1d7205b$var$taskTimeoutID), $8bb86185b1d7205b$var$taskTimeoutID = -1);
                $8bb86185b1d7205b$var$isPerformingWork = !0;
                var previousPriorityLevel = $8bb86185b1d7205b$var$currentPriorityLevel;
                try {
                    b: {
                        $8bb86185b1d7205b$var$advanceTimers(currentTime);
                        for($8bb86185b1d7205b$var$currentTask = $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$taskQueue); null !== $8bb86185b1d7205b$var$currentTask && !($8bb86185b1d7205b$var$currentTask.expirationTime > currentTime && $8bb86185b1d7205b$var$shouldYieldToHost());){
                            var callback = $8bb86185b1d7205b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $8bb86185b1d7205b$var$currentTask.callback = null;
                                $8bb86185b1d7205b$var$currentPriorityLevel = $8bb86185b1d7205b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($8bb86185b1d7205b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $8bb86185b1d7205b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $8bb86185b1d7205b$var$currentTask.callback = continuationCallback;
                                    $8bb86185b1d7205b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $8bb86185b1d7205b$var$currentTask === $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$taskQueue) && $8bb86185b1d7205b$var$pop($8bb86185b1d7205b$var$taskQueue);
                                $8bb86185b1d7205b$var$advanceTimers(currentTime);
                            } else $8bb86185b1d7205b$var$pop($8bb86185b1d7205b$var$taskQueue);
                            $8bb86185b1d7205b$var$currentTask = $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$taskQueue);
                        }
                        if (null !== $8bb86185b1d7205b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$timerQueue);
                            null !== firstTimer && $8bb86185b1d7205b$var$requestHostTimeout($8bb86185b1d7205b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $8bb86185b1d7205b$var$currentTask = null, $8bb86185b1d7205b$var$currentPriorityLevel = previousPriorityLevel, $8bb86185b1d7205b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $8bb86185b1d7205b$var$schedulePerformWorkUntilDeadline() : $8bb86185b1d7205b$var$isMessageLoopRunning = !1;
        }
    }
}
var $8bb86185b1d7205b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $8bb86185b1d7205b$var$localSetImmediate) $8bb86185b1d7205b$var$schedulePerformWorkUntilDeadline = function() {
    $8bb86185b1d7205b$var$localSetImmediate($8bb86185b1d7205b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $8bb86185b1d7205b$var$channel = new MessageChannel(), $8bb86185b1d7205b$var$port = $8bb86185b1d7205b$var$channel.port2;
    $8bb86185b1d7205b$var$channel.port1.onmessage = $8bb86185b1d7205b$var$performWorkUntilDeadline;
    $8bb86185b1d7205b$var$schedulePerformWorkUntilDeadline = function() {
        $8bb86185b1d7205b$var$port.postMessage(null);
    };
} else $8bb86185b1d7205b$var$schedulePerformWorkUntilDeadline = function() {
    $8bb86185b1d7205b$var$localSetTimeout($8bb86185b1d7205b$var$performWorkUntilDeadline, 0);
};
function $8bb86185b1d7205b$var$requestHostTimeout(callback, ms) {
    $8bb86185b1d7205b$var$taskTimeoutID = $8bb86185b1d7205b$var$localSetTimeout(function() {
        callback($8bb86185b1d7205b$export$c4744153514ff05d());
    }, ms);
}
$8bb86185b1d7205b$export$3e506c1ccc9cc1a7 = 5;
$8bb86185b1d7205b$export$e26fe2ed2fa76875 = 1;
$8bb86185b1d7205b$export$502329bbf4b505b1 = 4;
$8bb86185b1d7205b$export$6e3807111c4874c4 = 3;
$8bb86185b1d7205b$export$c27134553091fb3a = null;
$8bb86185b1d7205b$export$33ee1acdc04fd2a2 = 2;
$8bb86185b1d7205b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$8bb86185b1d7205b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $8bb86185b1d7205b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$8bb86185b1d7205b$export$d3dfb8e4810cb555 = function() {
    return $8bb86185b1d7205b$var$currentPriorityLevel;
};
$8bb86185b1d7205b$export$72fdf0e06517287b = function(eventHandler) {
    switch($8bb86185b1d7205b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $8bb86185b1d7205b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $8bb86185b1d7205b$var$currentPriorityLevel;
    $8bb86185b1d7205b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $8bb86185b1d7205b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$8bb86185b1d7205b$export$816d2913ae6b83b1 = function() {
    $8bb86185b1d7205b$var$needsPaint = !0;
};
$8bb86185b1d7205b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $8bb86185b1d7205b$var$currentPriorityLevel;
    $8bb86185b1d7205b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $8bb86185b1d7205b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$8bb86185b1d7205b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $8bb86185b1d7205b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $8bb86185b1d7205b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $8bb86185b1d7205b$var$push($8bb86185b1d7205b$var$timerQueue, priorityLevel), null === $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$taskQueue) && priorityLevel === $8bb86185b1d7205b$var$peek($8bb86185b1d7205b$var$timerQueue) && ($8bb86185b1d7205b$var$isHostTimeoutScheduled ? ($8bb86185b1d7205b$var$localClearTimeout($8bb86185b1d7205b$var$taskTimeoutID), $8bb86185b1d7205b$var$taskTimeoutID = -1) : $8bb86185b1d7205b$var$isHostTimeoutScheduled = !0, $8bb86185b1d7205b$var$requestHostTimeout($8bb86185b1d7205b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $8bb86185b1d7205b$var$push($8bb86185b1d7205b$var$taskQueue, priorityLevel), $8bb86185b1d7205b$var$isHostCallbackScheduled || $8bb86185b1d7205b$var$isPerformingWork || ($8bb86185b1d7205b$var$isHostCallbackScheduled = !0, $8bb86185b1d7205b$var$isMessageLoopRunning || ($8bb86185b1d7205b$var$isMessageLoopRunning = !0, $8bb86185b1d7205b$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$8bb86185b1d7205b$export$b5836b71941fa3ed = $8bb86185b1d7205b$var$shouldYieldToHost;
$8bb86185b1d7205b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $8bb86185b1d7205b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $8bb86185b1d7205b$var$currentPriorityLevel;
        $8bb86185b1d7205b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $8bb86185b1d7205b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("cvMSo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cObTn"));

});
parcelRegister("cObTn", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $9533611bd32aff8f$export$dca3b0875bd9a954; }, function (v) { return $9533611bd32aff8f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $9533611bd32aff8f$export$16fa2f45be04daa8; }, function (v) { return $9533611bd32aff8f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9533611bd32aff8f$export$ffb0004e005737fa; }, function (v) { return $9533611bd32aff8f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $9533611bd32aff8f$export$e2c29f18771995cb; }, function (v) { return $9533611bd32aff8f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $9533611bd32aff8f$export$221d75b3f55bb0bd; }, function (v) { return $9533611bd32aff8f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9533611bd32aff8f$export$5f8d39834fd61797; }, function (v) { return $9533611bd32aff8f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9533611bd32aff8f$export$74bf444e3cd11ea5; }, function (v) { return $9533611bd32aff8f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $9533611bd32aff8f$export$1ced07cd6b1985ce; }, function (v) { return $9533611bd32aff8f$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $9533611bd32aff8f$export$abd8e32b826d7ea7; }, function (v) { return $9533611bd32aff8f$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $9533611bd32aff8f$export$69a3209f1a06c04d; }, function (v) { return $9533611bd32aff8f$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $9533611bd32aff8f$export$e530037191fcd5d7; }, function (v) { return $9533611bd32aff8f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $9533611bd32aff8f$export$fd42f52fd3ae1109; }, function (v) { return $9533611bd32aff8f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $9533611bd32aff8f$export$c8a8987d4410bf2d; }, function (v) { return $9533611bd32aff8f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $9533611bd32aff8f$export$7d1e3a5e95ceca43; }, function (v) { return $9533611bd32aff8f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $9533611bd32aff8f$export$257a8862b851cb5b; }, function (v) { return $9533611bd32aff8f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $9533611bd32aff8f$export$a8257692ac88316c; }, function (v) { return $9533611bd32aff8f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $9533611bd32aff8f$export$488013bae63b21da; }, function (v) { return $9533611bd32aff8f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $9533611bd32aff8f$export$7c73462e0d25e514; }, function (v) { return $9533611bd32aff8f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $9533611bd32aff8f$export$7568632d0d33d16d; }, function (v) { return $9533611bd32aff8f$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $9533611bd32aff8f$export$f93f40ac0ca7e3a8; }, function (v) { return $9533611bd32aff8f$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $9533611bd32aff8f$export$1f96ae73734a86cc; }, function (v) { return $9533611bd32aff8f$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $9533611bd32aff8f$export$9a47ced3238df325; }, function (v) { return $9533611bd32aff8f$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $9533611bd32aff8f$export$35808ee640e87ca7; }, function (v) { return $9533611bd32aff8f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $9533611bd32aff8f$export$fae74005e78b1a27; }, function (v) { return $9533611bd32aff8f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $9533611bd32aff8f$export$dc8fbce3eb94dc1e; }, function (v) { return $9533611bd32aff8f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $9533611bd32aff8f$export$6a7bc4e911dc01cf; }, function (v) { return $9533611bd32aff8f$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $9533611bd32aff8f$export$6d9c69b0de29b591; }, function (v) { return $9533611bd32aff8f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $9533611bd32aff8f$export$f680877a34711e37; }, function (v) { return $9533611bd32aff8f$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $9533611bd32aff8f$export$d5a552a76deda3c2; }, function (v) { return $9533611bd32aff8f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $9533611bd32aff8f$export$aaabe4eda9ed9969; }, function (v) { return $9533611bd32aff8f$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $9533611bd32aff8f$export$e5c5a5f917a5871c; }, function (v) { return $9533611bd32aff8f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $9533611bd32aff8f$export$1538c33de8887b59; }, function (v) { return $9533611bd32aff8f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $9533611bd32aff8f$export$fca7f784ae7a249a; }, function (v) { return $9533611bd32aff8f$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $9533611bd32aff8f$export$13e3392192263954; }, function (v) { return $9533611bd32aff8f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $9533611bd32aff8f$export$b8f5890fc79d6aca; }, function (v) { return $9533611bd32aff8f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $9533611bd32aff8f$export$60241385465d0a34; }, function (v) { return $9533611bd32aff8f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $9533611bd32aff8f$export$306c0aa65ff9ec16; }, function (v) { return $9533611bd32aff8f$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $9533611bd32aff8f$export$7b286972b8d8ccbf; }, function (v) { return $9533611bd32aff8f$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $9533611bd32aff8f$export$83d89fbfd8236492; }, function (v) { return $9533611bd32aff8f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9533611bd32aff8f$export$dca3b0875bd9a954;
var $9533611bd32aff8f$export$16fa2f45be04daa8;
var $9533611bd32aff8f$export$ffb0004e005737fa;
var $9533611bd32aff8f$export$e2c29f18771995cb;
var $9533611bd32aff8f$export$221d75b3f55bb0bd;
var $9533611bd32aff8f$export$5f8d39834fd61797;
var $9533611bd32aff8f$export$74bf444e3cd11ea5;
var $9533611bd32aff8f$export$1ced07cd6b1985ce;
var $9533611bd32aff8f$export$abd8e32b826d7ea7;
var $9533611bd32aff8f$export$69a3209f1a06c04d;
var $9533611bd32aff8f$export$e530037191fcd5d7;
var $9533611bd32aff8f$export$fd42f52fd3ae1109;
var $9533611bd32aff8f$export$c8a8987d4410bf2d;
var $9533611bd32aff8f$export$7d1e3a5e95ceca43;
var $9533611bd32aff8f$export$257a8862b851cb5b;
var $9533611bd32aff8f$export$a8257692ac88316c;
var $9533611bd32aff8f$export$488013bae63b21da;
var $9533611bd32aff8f$export$7c73462e0d25e514;
var $9533611bd32aff8f$export$7568632d0d33d16d;
var $9533611bd32aff8f$export$f93f40ac0ca7e3a8;
var $9533611bd32aff8f$export$1f96ae73734a86cc;
var $9533611bd32aff8f$export$9a47ced3238df325;
var $9533611bd32aff8f$export$35808ee640e87ca7;
var $9533611bd32aff8f$export$fae74005e78b1a27;
var $9533611bd32aff8f$export$dc8fbce3eb94dc1e;
var $9533611bd32aff8f$export$6a7bc4e911dc01cf;
var $9533611bd32aff8f$export$6d9c69b0de29b591;
var $9533611bd32aff8f$export$f680877a34711e37;
var $9533611bd32aff8f$export$d5a552a76deda3c2;
var $9533611bd32aff8f$export$aaabe4eda9ed9969;
var $9533611bd32aff8f$export$e5c5a5f917a5871c;
var $9533611bd32aff8f$export$1538c33de8887b59;
var $9533611bd32aff8f$export$fca7f784ae7a249a;
var $9533611bd32aff8f$export$13e3392192263954;
var $9533611bd32aff8f$export$b8f5890fc79d6aca;
var $9533611bd32aff8f$export$60241385465d0a34;
var $9533611bd32aff8f$export$306c0aa65ff9ec16;
var $9533611bd32aff8f$export$7b286972b8d8ccbf;
var $9533611bd32aff8f$export$83d89fbfd8236492;
"use strict";
var $9533611bd32aff8f$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $9533611bd32aff8f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $9533611bd32aff8f$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $9533611bd32aff8f$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $9533611bd32aff8f$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $9533611bd32aff8f$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $9533611bd32aff8f$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $9533611bd32aff8f$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $9533611bd32aff8f$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $9533611bd32aff8f$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $9533611bd32aff8f$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $9533611bd32aff8f$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $9533611bd32aff8f$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $9533611bd32aff8f$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$9533611bd32aff8f$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $9533611bd32aff8f$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $9533611bd32aff8f$var$assign = Object.assign, $9533611bd32aff8f$var$emptyObject = {};
function $9533611bd32aff8f$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9533611bd32aff8f$var$emptyObject;
    this.updater = updater || $9533611bd32aff8f$var$ReactNoopUpdateQueue;
}
$9533611bd32aff8f$var$Component.prototype.isReactComponent = {};
$9533611bd32aff8f$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$9533611bd32aff8f$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $9533611bd32aff8f$var$ComponentDummy() {}
$9533611bd32aff8f$var$ComponentDummy.prototype = $9533611bd32aff8f$var$Component.prototype;
function $9533611bd32aff8f$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9533611bd32aff8f$var$emptyObject;
    this.updater = updater || $9533611bd32aff8f$var$ReactNoopUpdateQueue;
}
var $9533611bd32aff8f$var$pureComponentPrototype = $9533611bd32aff8f$var$PureComponent.prototype = new $9533611bd32aff8f$var$ComponentDummy();
$9533611bd32aff8f$var$pureComponentPrototype.constructor = $9533611bd32aff8f$var$PureComponent;
$9533611bd32aff8f$var$assign($9533611bd32aff8f$var$pureComponentPrototype, $9533611bd32aff8f$var$Component.prototype);
$9533611bd32aff8f$var$pureComponentPrototype.isPureReactComponent = !0;
var $9533611bd32aff8f$var$isArrayImpl = Array.isArray, $9533611bd32aff8f$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $9533611bd32aff8f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $9533611bd32aff8f$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $9533611bd32aff8f$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $9533611bd32aff8f$var$cloneAndReplaceKey(oldElement, newKey) {
    return $9533611bd32aff8f$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $9533611bd32aff8f$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $9533611bd32aff8f$var$REACT_ELEMENT_TYPE;
}
function $9533611bd32aff8f$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $9533611bd32aff8f$var$userProvidedKeyEscapeRegex = /\/+/g;
function $9533611bd32aff8f$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $9533611bd32aff8f$var$escape("" + element.key) : index.toString(36);
}
function $9533611bd32aff8f$var$noop$1() {}
function $9533611bd32aff8f$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($9533611bd32aff8f$var$noop$1, $9533611bd32aff8f$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $9533611bd32aff8f$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $9533611bd32aff8f$var$REACT_ELEMENT_TYPE:
                case $9533611bd32aff8f$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $9533611bd32aff8f$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $9533611bd32aff8f$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $9533611bd32aff8f$var$getElementKey(children, 0) : nameSoFar, $9533611bd32aff8f$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($9533611bd32aff8f$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $9533611bd32aff8f$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($9533611bd32aff8f$var$isValidElement(callback) && (callback = $9533611bd32aff8f$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($9533611bd32aff8f$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($9533611bd32aff8f$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $9533611bd32aff8f$var$getElementKey(nameSoFar, i), invokeCallback += $9533611bd32aff8f$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $9533611bd32aff8f$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $9533611bd32aff8f$var$getElementKey(nameSoFar, i++), invokeCallback += $9533611bd32aff8f$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $9533611bd32aff8f$var$mapIntoArray($9533611bd32aff8f$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $9533611bd32aff8f$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $9533611bd32aff8f$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $9533611bd32aff8f$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $9533611bd32aff8f$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $9533611bd32aff8f$var$noop() {}
$9533611bd32aff8f$export$dca3b0875bd9a954 = {
    map: $9533611bd32aff8f$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $9533611bd32aff8f$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $9533611bd32aff8f$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $9533611bd32aff8f$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$9533611bd32aff8f$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$9533611bd32aff8f$export$16fa2f45be04daa8 = $9533611bd32aff8f$var$Component;
$9533611bd32aff8f$export$ffb0004e005737fa = $9533611bd32aff8f$var$REACT_FRAGMENT_TYPE;
$9533611bd32aff8f$export$e2c29f18771995cb = $9533611bd32aff8f$var$REACT_PROFILER_TYPE;
$9533611bd32aff8f$export$221d75b3f55bb0bd = $9533611bd32aff8f$var$PureComponent;
$9533611bd32aff8f$export$5f8d39834fd61797 = $9533611bd32aff8f$var$REACT_STRICT_MODE_TYPE;
$9533611bd32aff8f$export$74bf444e3cd11ea5 = $9533611bd32aff8f$var$REACT_SUSPENSE_TYPE;
$9533611bd32aff8f$export$1ced07cd6b1985ce = $9533611bd32aff8f$var$ReactSharedInternals;
$9533611bd32aff8f$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $9533611bd32aff8f$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$9533611bd32aff8f$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$9533611bd32aff8f$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $9533611bd32aff8f$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$9533611bd32aff8f$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $9533611bd32aff8f$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$9533611bd32aff8f$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $9533611bd32aff8f$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $9533611bd32aff8f$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$9533611bd32aff8f$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$9533611bd32aff8f$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $9533611bd32aff8f$var$ReactElement(type, key, void 0, void 0, null, props);
};
$9533611bd32aff8f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$9533611bd32aff8f$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $9533611bd32aff8f$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$9533611bd32aff8f$export$a8257692ac88316c = $9533611bd32aff8f$var$isValidElement;
$9533611bd32aff8f$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $9533611bd32aff8f$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $9533611bd32aff8f$var$lazyInitializer
    };
};
$9533611bd32aff8f$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $9533611bd32aff8f$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$9533611bd32aff8f$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $9533611bd32aff8f$var$ReactSharedInternals.T, currentTransition = {};
    $9533611bd32aff8f$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $9533611bd32aff8f$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($9533611bd32aff8f$var$noop, $9533611bd32aff8f$var$reportGlobalError);
    } catch (error) {
        $9533611bd32aff8f$var$reportGlobalError(error);
    } finally{
        $9533611bd32aff8f$var$ReactSharedInternals.T = prevTransition;
    }
};
$9533611bd32aff8f$export$f93f40ac0ca7e3a8 = function() {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useCacheRefresh();
};
$9533611bd32aff8f$export$1f96ae73734a86cc = function(usable) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.use(usable);
};
$9533611bd32aff8f$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$9533611bd32aff8f$export$35808ee640e87ca7 = function(callback, deps) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$9533611bd32aff8f$export$fae74005e78b1a27 = function(Context) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useContext(Context);
};
$9533611bd32aff8f$export$dc8fbce3eb94dc1e = function() {};
$9533611bd32aff8f$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$9533611bd32aff8f$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $9533611bd32aff8f$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$9533611bd32aff8f$export$f680877a34711e37 = function() {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useId();
};
$9533611bd32aff8f$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$9533611bd32aff8f$export$aaabe4eda9ed9969 = function(create, deps) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$9533611bd32aff8f$export$e5c5a5f917a5871c = function(create, deps) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$9533611bd32aff8f$export$1538c33de8887b59 = function(create, deps) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useMemo(create, deps);
};
$9533611bd32aff8f$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$9533611bd32aff8f$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$9533611bd32aff8f$export$b8f5890fc79d6aca = function(initialValue) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useRef(initialValue);
};
$9533611bd32aff8f$export$60241385465d0a34 = function(initialState) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useState(initialState);
};
$9533611bd32aff8f$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$9533611bd32aff8f$export$7b286972b8d8ccbf = function() {
    return $9533611bd32aff8f$var$ReactSharedInternals.H.useTransition();
};
$9533611bd32aff8f$export$83d89fbfd8236492 = "19.1.0";

});


parcelRegister("hVGez", function(module, exports) {
'use strict';
function $d0d88550aaa5507c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d0d88550aaa5507c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d0d88550aaa5507c$var$checkDCE();

module.exports = (parcelRequire("8M2Cc"));

});
parcelRegister("8M2Cc", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $6634d5bdd042c8b4$export$69ce8ef3fe5cead0; }, function (v) { return $6634d5bdd042c8b4$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $6634d5bdd042c8b4$export$d39a5bbd09211389; }, function (v) { return $6634d5bdd042c8b4$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $6634d5bdd042c8b4$export$cd75ccfd720a3cd4; }, function (v) { return $6634d5bdd042c8b4$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $6634d5bdd042c8b4$export$a0816fa17a9e79be; }, function (v) { return $6634d5bdd042c8b4$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $6634d5bdd042c8b4$export$7292efcadded39f3; }, function (v) { return $6634d5bdd042c8b4$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $6634d5bdd042c8b4$export$da407abadb9b8f86; }, function (v) { return $6634d5bdd042c8b4$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $6634d5bdd042c8b4$export$314cfea32580671c; }, function (v) { return $6634d5bdd042c8b4$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $6634d5bdd042c8b4$export$513ccb98c53b8039; }, function (v) { return $6634d5bdd042c8b4$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $6634d5bdd042c8b4$export$dbca993bc2d264a; }, function (v) { return $6634d5bdd042c8b4$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $6634d5bdd042c8b4$export$4797a8006f0655d0; }, function (v) { return $6634d5bdd042c8b4$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $6634d5bdd042c8b4$export$c78a37762a8d58e1; }, function (v) { return $6634d5bdd042c8b4$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $6634d5bdd042c8b4$export$606f11b2eb45ecc6; }, function (v) { return $6634d5bdd042c8b4$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $6634d5bdd042c8b4$export$f7e8a0bf92324b1e; }, function (v) { return $6634d5bdd042c8b4$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $6634d5bdd042c8b4$export$83d89fbfd8236492; }, function (v) { return $6634d5bdd042c8b4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6634d5bdd042c8b4$export$69ce8ef3fe5cead0;
var $6634d5bdd042c8b4$export$d39a5bbd09211389;
var $6634d5bdd042c8b4$export$cd75ccfd720a3cd4;
var $6634d5bdd042c8b4$export$a0816fa17a9e79be;
var $6634d5bdd042c8b4$export$7292efcadded39f3;
var $6634d5bdd042c8b4$export$da407abadb9b8f86;
var $6634d5bdd042c8b4$export$314cfea32580671c;
var $6634d5bdd042c8b4$export$513ccb98c53b8039;
var $6634d5bdd042c8b4$export$dbca993bc2d264a;
var $6634d5bdd042c8b4$export$4797a8006f0655d0;
var $6634d5bdd042c8b4$export$c78a37762a8d58e1;
var $6634d5bdd042c8b4$export$606f11b2eb45ecc6;
var $6634d5bdd042c8b4$export$f7e8a0bf92324b1e;
var $6634d5bdd042c8b4$export$83d89fbfd8236492;
"use strict";

var $cvMSo = parcelRequire("cvMSo");
function $6634d5bdd042c8b4$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $6634d5bdd042c8b4$var$noop() {}
var $6634d5bdd042c8b4$var$Internals = {
    d: {
        f: $6634d5bdd042c8b4$var$noop,
        r: function() {
            throw Error($6634d5bdd042c8b4$var$formatProdErrorMessage(522));
        },
        D: $6634d5bdd042c8b4$var$noop,
        C: $6634d5bdd042c8b4$var$noop,
        L: $6634d5bdd042c8b4$var$noop,
        m: $6634d5bdd042c8b4$var$noop,
        X: $6634d5bdd042c8b4$var$noop,
        S: $6634d5bdd042c8b4$var$noop,
        M: $6634d5bdd042c8b4$var$noop
    },
    p: 0,
    findDOMNode: null
}, $6634d5bdd042c8b4$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $6634d5bdd042c8b4$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $6634d5bdd042c8b4$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $6634d5bdd042c8b4$var$ReactSharedInternals = $cvMSo.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $6634d5bdd042c8b4$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$6634d5bdd042c8b4$export$69ce8ef3fe5cead0 = $6634d5bdd042c8b4$var$Internals;
$6634d5bdd042c8b4$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($6634d5bdd042c8b4$var$formatProdErrorMessage(299));
    return $6634d5bdd042c8b4$var$createPortal$1(children, container, null, key);
};
$6634d5bdd042c8b4$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $6634d5bdd042c8b4$var$ReactSharedInternals.T, previousUpdatePriority = $6634d5bdd042c8b4$var$Internals.p;
    try {
        if ($6634d5bdd042c8b4$var$ReactSharedInternals.T = null, $6634d5bdd042c8b4$var$Internals.p = 2, fn) return fn();
    } finally{
        $6634d5bdd042c8b4$var$ReactSharedInternals.T = previousTransition, $6634d5bdd042c8b4$var$Internals.p = previousUpdatePriority, $6634d5bdd042c8b4$var$Internals.d.f();
    }
};
$6634d5bdd042c8b4$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $6634d5bdd042c8b4$var$Internals.d.C(href, options));
};
$6634d5bdd042c8b4$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $6634d5bdd042c8b4$var$Internals.d.D(href);
};
$6634d5bdd042c8b4$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6634d5bdd042c8b4$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $6634d5bdd042c8b4$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $6634d5bdd042c8b4$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$6634d5bdd042c8b4$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $6634d5bdd042c8b4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $6634d5bdd042c8b4$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $6634d5bdd042c8b4$var$Internals.d.M(href);
    }
};
$6634d5bdd042c8b4$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6634d5bdd042c8b4$var$getCrossOriginStringAs(as, options.crossOrigin);
        $6634d5bdd042c8b4$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$6634d5bdd042c8b4$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $6634d5bdd042c8b4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $6634d5bdd042c8b4$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $6634d5bdd042c8b4$var$Internals.d.m(href);
    }
};
$6634d5bdd042c8b4$export$4797a8006f0655d0 = function(form) {
    $6634d5bdd042c8b4$var$Internals.d.r(form);
};
$6634d5bdd042c8b4$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$6634d5bdd042c8b4$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $6634d5bdd042c8b4$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$6634d5bdd042c8b4$export$f7e8a0bf92324b1e = function() {
    return $6634d5bdd042c8b4$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$6634d5bdd042c8b4$export$83d89fbfd8236492 = "19.1.0";

});



parcelRegister("bH5UW", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $5nPmc = parcelRequire("5nPmc");
function $88384ce93b8b726e$var$emptyFunction() {}
function $88384ce93b8b726e$var$emptyFunctionWithReset() {}
$88384ce93b8b726e$var$emptyFunctionWithReset.resetWarningCache = $88384ce93b8b726e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $5nPmc) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $88384ce93b8b726e$var$emptyFunctionWithReset,
        resetWarningCache: $88384ce93b8b726e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("5nPmc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $3eb6f02bc8d6e0ab$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $3eb6f02bc8d6e0ab$var$ReactPropTypesSecret;

});


var $894c07836a326165$exports = {};
'use strict';

$894c07836a326165$exports = (parcelRequire("fpoVQ"));


var $8ea8309dadb916c6$exports = {};
'use strict';
function $8ea8309dadb916c6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8ea8309dadb916c6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8ea8309dadb916c6$var$checkDCE();

$8ea8309dadb916c6$exports = (parcelRequire("exX0H"));




var $cvMSo = parcelRequire("cvMSo");

parcelRequire("cvMSo");
var $1195fb9c0a409db8$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1195fb9c0a409db8$var$ReactIs, $1195fb9c0a409db8$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$1195fb9c0a409db8$exports = (parcelRequire("bH5UW"))();


var $1bbfdeebbadfe1c9$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $1bbfdeebbadfe1c9$exports) {
        classNames.default = classNames;
        $1bbfdeebbadfe1c9$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");

const $6890f3c257181b7e$var$_excluded = [
    "as",
    "disabled"
];
function $6890f3c257181b7e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $6890f3c257181b7e$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $6890f3c257181b7e$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $6890f3c257181b7e$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $6890f3c257181b7e$var$Button = /*#__PURE__*/ $cvMSo.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $6890f3c257181b7e$var$_objectWithoutPropertiesLoose(_ref, $6890f3c257181b7e$var$_excluded);
    const [buttonProps, { tagName: Component }] = $6890f3c257181b7e$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$6890f3c257181b7e$var$Button.displayName = 'Button';
var $6890f3c257181b7e$export$2e2bcd8739ae039 = $6890f3c257181b7e$var$Button;



var $cvMSo = parcelRequire("cvMSo");

"use client";
const $49d3254000d8b829$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $49d3254000d8b829$export$ff817e17bad2e091 = 'xs';
const $49d3254000d8b829$var$ThemeContext = /*#__PURE__*/ $cvMSo.createContext({
    prefixes: {},
    breakpoints: $49d3254000d8b829$export$666ad80b5007f835,
    minBreakpoint: $49d3254000d8b829$export$ff817e17bad2e091
});
const { Consumer: $49d3254000d8b829$export$b631efc24e9d5e2f, Provider: $49d3254000d8b829$var$Provider } = $49d3254000d8b829$var$ThemeContext;
function $49d3254000d8b829$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $49d3254000d8b829$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $49d3254000d8b829$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $cvMSo.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)($49d3254000d8b829$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $49d3254000d8b829$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $cvMSo.useContext)($49d3254000d8b829$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $49d3254000d8b829$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $cvMSo.useContext)($49d3254000d8b829$var$ThemeContext);
    return breakpoints;
}
function $49d3254000d8b829$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $cvMSo.useContext)($49d3254000d8b829$var$ThemeContext);
    return minBreakpoint;
}
function $49d3254000d8b829$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $cvMSo.useContext)($49d3254000d8b829$var$ThemeContext);
    return dir === 'rtl';
}
function $49d3254000d8b829$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $cvMSo.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $49d3254000d8b829$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $49d3254000d8b829$export$2e2bcd8739ae039 = $49d3254000d8b829$var$ThemeProvider;



"use client";
const $9d49bcddab7a7bc1$var$Button = /*#__PURE__*/ $cvMSo.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $6890f3c257181b7e$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$9d49bcddab7a7bc1$var$Button.displayName = 'Button';
var $9d49bcddab7a7bc1$export$2e2bcd8739ae039 = $9d49bcddab7a7bc1$var$Button;



var $cvMSo = parcelRequire("cvMSo");


var $cvMSo = parcelRequire("cvMSo");



"use client";
const $eca179c0ab3aa2d1$var$CardBody = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$eca179c0ab3aa2d1$var$CardBody.displayName = 'CardBody';
var $eca179c0ab3aa2d1$export$2e2bcd8739ae039 = $eca179c0ab3aa2d1$var$CardBody;



var $cvMSo = parcelRequire("cvMSo");



"use client";
const $317b408467546006$var$CardFooter = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$317b408467546006$var$CardFooter.displayName = 'CardFooter';
var $317b408467546006$export$2e2bcd8739ae039 = $317b408467546006$var$CardFooter;




var $cvMSo = parcelRequire("cvMSo");


var $cvMSo = parcelRequire("cvMSo");
"use client";
const $d1f2c71b64e07569$var$context = /*#__PURE__*/ $cvMSo.createContext(null);
$d1f2c71b64e07569$var$context.displayName = 'CardHeaderContext';
var $d1f2c71b64e07569$export$2e2bcd8739ae039 = $d1f2c71b64e07569$var$context;



"use client";
const $1747b39003f5e93f$var$CardHeader = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $cvMSo.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $d1f2c71b64e07569$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, prefix)
        })
    });
});
$1747b39003f5e93f$var$CardHeader.displayName = 'CardHeader';
var $1747b39003f5e93f$export$2e2bcd8739ae039 = $1747b39003f5e93f$var$CardHeader;




var $cvMSo = parcelRequire("cvMSo");


"use client";
const $705618410739ca48$var$CardImg = /*#__PURE__*/ $cvMSo.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$705618410739ca48$var$CardImg.displayName = 'CardImg';
var $705618410739ca48$export$2e2bcd8739ae039 = $705618410739ca48$var$CardImg;



var $cvMSo = parcelRequire("cvMSo");



"use client";
const $9597e7f58702ef19$var$CardImgOverlay = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$9597e7f58702ef19$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $9597e7f58702ef19$export$2e2bcd8739ae039 = $9597e7f58702ef19$var$CardImgOverlay;



var $cvMSo = parcelRequire("cvMSo");



"use client";
const $9fca297cce05ec20$var$CardLink = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$9fca297cce05ec20$var$CardLink.displayName = 'CardLink';
var $9fca297cce05ec20$export$2e2bcd8739ae039 = $9fca297cce05ec20$var$CardLink;



var $cvMSo = parcelRequire("cvMSo");



var $cvMSo = parcelRequire("cvMSo");


var $306969f682d044b0$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $cvMSo.forwardRef((p, ref)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(p.className, className)
        }));



"use client";
const $8c6c933f0b55576d$var$DivStyledAsH6 = (0, $306969f682d044b0$export$2e2bcd8739ae039)('h6');
const $8c6c933f0b55576d$var$CardSubtitle = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $8c6c933f0b55576d$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$8c6c933f0b55576d$var$CardSubtitle.displayName = 'CardSubtitle';
var $8c6c933f0b55576d$export$2e2bcd8739ae039 = $8c6c933f0b55576d$var$CardSubtitle;



var $cvMSo = parcelRequire("cvMSo");



"use client";
const $29277f703a8e1ee4$var$CardText = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$29277f703a8e1ee4$var$CardText.displayName = 'CardText';
var $29277f703a8e1ee4$export$2e2bcd8739ae039 = $29277f703a8e1ee4$var$CardText;



var $cvMSo = parcelRequire("cvMSo");




"use client";
const $95a3357032557756$var$DivStyledAsH5 = (0, $306969f682d044b0$export$2e2bcd8739ae039)('h5');
const $95a3357032557756$var$CardTitle = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $95a3357032557756$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$95a3357032557756$var$CardTitle.displayName = 'CardTitle';
var $95a3357032557756$export$2e2bcd8739ae039 = $95a3357032557756$var$CardTitle;



"use client";
const $043ca047cb2dab49$var$Card = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $eca179c0ab3aa2d1$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$043ca047cb2dab49$var$Card.displayName = 'Card';
var $043ca047cb2dab49$export$2e2bcd8739ae039 = Object.assign($043ca047cb2dab49$var$Card, {
    Img: (0, $705618410739ca48$export$2e2bcd8739ae039),
    Title: (0, $95a3357032557756$export$2e2bcd8739ae039),
    Subtitle: (0, $8c6c933f0b55576d$export$2e2bcd8739ae039),
    Body: (0, $eca179c0ab3aa2d1$export$2e2bcd8739ae039),
    Link: (0, $9fca297cce05ec20$export$2e2bcd8739ae039),
    Text: (0, $29277f703a8e1ee4$export$2e2bcd8739ae039),
    Header: (0, $1747b39003f5e93f$export$2e2bcd8739ae039),
    Footer: (0, $317b408467546006$export$2e2bcd8739ae039),
    ImgOverlay: (0, $9597e7f58702ef19$export$2e2bcd8739ae039)
});


/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $cvMSo = parcelRequire("cvMSo");

var $hVGez = parcelRequire("hVGez");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a9fafee67bdeda69$var$_extends() {
    $a9fafee67bdeda69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9fafee67bdeda69$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a9fafee67bdeda69$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a9fafee67bdeda69$export$e19cd5f9376f8cee || ($a9fafee67bdeda69$export$e19cd5f9376f8cee = {}));
const $a9fafee67bdeda69$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a9fafee67bdeda69$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a9fafee67bdeda69$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a9fafee67bdeda69$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a9fafee67bdeda69$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a9fafee67bdeda69$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a9fafee67bdeda69$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a9fafee67bdeda69$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a9fafee67bdeda69$export$fe53371bee54353d(to);
    }
    return $a9fafee67bdeda69$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a9fafee67bdeda69$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a9fafee67bdeda69$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a9fafee67bdeda69$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a9fafee67bdeda69$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a9fafee67bdeda69$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a9fafee67bdeda69$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a9fafee67bdeda69$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a9fafee67bdeda69$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a9fafee67bdeda69$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a9fafee67bdeda69$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a9fafee67bdeda69$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a9fafee67bdeda69$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a9fafee67bdeda69$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a9fafee67bdeda69$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a9fafee67bdeda69$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a9fafee67bdeda69$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a9fafee67bdeda69$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a9fafee67bdeda69$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Push;
        let location = $a9fafee67bdeda69$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a9fafee67bdeda69$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Replace;
        let location = $a9fafee67bdeda69$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a9fafee67bdeda69$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a9fafee67bdeda69$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a9fafee67bdeda69$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a9fafee67bdeda69$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a9fafee67bdeda69$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a9fafee67bdeda69$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a9fafee67bdeda69$var$ResultType || ($a9fafee67bdeda69$var$ResultType = {}));
const $a9fafee67bdeda69$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a9fafee67bdeda69$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a9fafee67bdeda69$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a9fafee67bdeda69$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a9fafee67bdeda69$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a9fafee67bdeda69$var$isIndexRoute(route)) {
            let indexRoute = $a9fafee67bdeda69$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a9fafee67bdeda69$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a9fafee67bdeda69$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $a9fafee67bdeda69$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $a9fafee67bdeda69$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $a9fafee67bdeda69$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $a9fafee67bdeda69$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a9fafee67bdeda69$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a9fafee67bdeda69$var$flattenRoutes(routes);
    $a9fafee67bdeda69$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $a9fafee67bdeda69$export$30d21fd6d7295f52(pathname);
        matches = $a9fafee67bdeda69$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $a9fafee67bdeda69$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a9fafee67bdeda69$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a9fafee67bdeda69$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a9fafee67bdeda69$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a9fafee67bdeda69$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a9fafee67bdeda69$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a9fafee67bdeda69$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a9fafee67bdeda69$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a9fafee67bdeda69$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a9fafee67bdeda69$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a9fafee67bdeda69$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a9fafee67bdeda69$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a9fafee67bdeda69$var$paramRe = /^:[\w-]+$/;
const $a9fafee67bdeda69$var$dynamicSegmentValue = 3;
const $a9fafee67bdeda69$var$indexRouteValue = 2;
const $a9fafee67bdeda69$var$emptySegmentValue = 1;
const $a9fafee67bdeda69$var$staticSegmentValue = 10;
const $a9fafee67bdeda69$var$splatPenalty = -2;
const $a9fafee67bdeda69$var$isSplat = (s)=>s === "*";
function $a9fafee67bdeda69$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a9fafee67bdeda69$var$isSplat)) initialScore += $a9fafee67bdeda69$var$splatPenalty;
    if (index) initialScore += $a9fafee67bdeda69$var$indexRouteValue;
    return segments.filter((s)=>!$a9fafee67bdeda69$var$isSplat(s)).reduce((score, segment)=>score + ($a9fafee67bdeda69$var$paramRe.test(segment) ? $a9fafee67bdeda69$var$dynamicSegmentValue : segment === "" ? $a9fafee67bdeda69$var$emptySegmentValue : $a9fafee67bdeda69$var$staticSegmentValue), initialScore);
}
function $a9fafee67bdeda69$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a9fafee67bdeda69$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a9fafee67bdeda69$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $a9fafee67bdeda69$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a9fafee67bdeda69$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a9fafee67bdeda69$export$a5c6d149b50c1d86($a9fafee67bdeda69$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a9fafee67bdeda69$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $a9fafee67bdeda69$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a9fafee67bdeda69$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a9fafee67bdeda69$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $a9fafee67bdeda69$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a9fafee67bdeda69$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a9fafee67bdeda69$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a9fafee67bdeda69$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a9fafee67bdeda69$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a9fafee67bdeda69$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a9fafee67bdeda69$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $a9fafee67bdeda69$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a9fafee67bdeda69$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $a9fafee67bdeda69$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $a9fafee67bdeda69$var$normalizeSearch(search),
        hash: $a9fafee67bdeda69$var$normalizeHash(hash)
    };
}
function $a9fafee67bdeda69$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a9fafee67bdeda69$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a9fafee67bdeda69$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a9fafee67bdeda69$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a9fafee67bdeda69$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a9fafee67bdeda69$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a9fafee67bdeda69$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a9fafee67bdeda69$var$_extends({}, toArg);
        $a9fafee67bdeda69$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a9fafee67bdeda69$var$getInvalidPathError("?", "pathname", "search", to));
        $a9fafee67bdeda69$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a9fafee67bdeda69$var$getInvalidPathError("#", "pathname", "hash", to));
        $a9fafee67bdeda69$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a9fafee67bdeda69$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a9fafee67bdeda69$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a9fafee67bdeda69$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a9fafee67bdeda69$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $a9fafee67bdeda69$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a9fafee67bdeda69$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a9fafee67bdeda69$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a9fafee67bdeda69$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $a9fafee67bdeda69$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a9fafee67bdeda69$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a9fafee67bdeda69$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $a9fafee67bdeda69$export$4051a07651545597(data, init) {
    return new $a9fafee67bdeda69$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $a9fafee67bdeda69$export$42a99a7a4bc0e76a extends Error {
}
class $a9fafee67bdeda69$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a9fafee67bdeda69$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a9fafee67bdeda69$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a9fafee67bdeda69$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a9fafee67bdeda69$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a9fafee67bdeda69$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a9fafee67bdeda69$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a9fafee67bdeda69$var$unwrapTrackedPromise(value) {
    if (!$a9fafee67bdeda69$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $a9fafee67bdeda69$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a9fafee67bdeda69$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a9fafee67bdeda69$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a9fafee67bdeda69$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a9fafee67bdeda69$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a9fafee67bdeda69$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a9fafee67bdeda69$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $a9fafee67bdeda69$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a9fafee67bdeda69$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a9fafee67bdeda69$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a9fafee67bdeda69$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a9fafee67bdeda69$var$validMutationMethods = new Set($a9fafee67bdeda69$var$validMutationMethodsArr);
const $a9fafee67bdeda69$var$validRequestMethodsArr = [
    "get",
    ...$a9fafee67bdeda69$var$validMutationMethodsArr
];
const $a9fafee67bdeda69$var$validRequestMethods = new Set($a9fafee67bdeda69$var$validRequestMethodsArr);
const $a9fafee67bdeda69$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a9fafee67bdeda69$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a9fafee67bdeda69$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a9fafee67bdeda69$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a9fafee67bdeda69$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a9fafee67bdeda69$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a9fafee67bdeda69$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a9fafee67bdeda69$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a9fafee67bdeda69$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a9fafee67bdeda69$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a9fafee67bdeda69$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a9fafee67bdeda69$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $a9fafee67bdeda69$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $a9fafee67bdeda69$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a9fafee67bdeda69$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a9fafee67bdeda69$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a9fafee67bdeda69$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$a9fafee67bdeda69$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$a9fafee67bdeda69$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a9fafee67bdeda69$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $a9fafee67bdeda69$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a9fafee67bdeda69$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a9fafee67bdeda69$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a9fafee67bdeda69$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a9fafee67bdeda69$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a9fafee67bdeda69$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a9fafee67bdeda69$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a9fafee67bdeda69$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a9fafee67bdeda69$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a9fafee67bdeda69$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a9fafee67bdeda69$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a9fafee67bdeda69$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a9fafee67bdeda69$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a9fafee67bdeda69$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a9fafee67bdeda69$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a9fafee67bdeda69$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a9fafee67bdeda69$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a9fafee67bdeda69$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a9fafee67bdeda69$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $a9fafee67bdeda69$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $a9fafee67bdeda69$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a9fafee67bdeda69$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a9fafee67bdeda69$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $a9fafee67bdeda69$var$findNearestBoundary(matches).route.id,
            {
                type: $a9fafee67bdeda69$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $a9fafee67bdeda69$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($a9fafee67bdeda69$var$isErrorResult(result) && $a9fafee67bdeda69$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $a9fafee67bdeda69$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $a9fafee67bdeda69$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a9fafee67bdeda69$var$_extends({
            matches: updatedMatches || matches
        }, $a9fafee67bdeda69$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a9fafee67bdeda69$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a9fafee67bdeda69$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $a9fafee67bdeda69$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $a9fafee67bdeda69$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $a9fafee67bdeda69$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a9fafee67bdeda69$var$ResultType.error,
            error: $a9fafee67bdeda69$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a9fafee67bdeda69$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $a9fafee67bdeda69$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a9fafee67bdeda69$var$isDeferredResult(result)) throw $a9fafee67bdeda69$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($a9fafee67bdeda69$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a9fafee67bdeda69$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $a9fafee67bdeda69$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a9fafee67bdeda69$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a9fafee67bdeda69$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($a9fafee67bdeda69$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a9fafee67bdeda69$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a9fafee67bdeda69$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a9fafee67bdeda69$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $a9fafee67bdeda69$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a9fafee67bdeda69$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $a9fafee67bdeda69$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a9fafee67bdeda69$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $a9fafee67bdeda69$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a9fafee67bdeda69$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $a9fafee67bdeda69$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a9fafee67bdeda69$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a9fafee67bdeda69$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $a9fafee67bdeda69$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a9fafee67bdeda69$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a9fafee67bdeda69$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a9fafee67bdeda69$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $a9fafee67bdeda69$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a9fafee67bdeda69$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a9fafee67bdeda69$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a9fafee67bdeda69$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $a9fafee67bdeda69$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a9fafee67bdeda69$var$isRedirectResult(actionResult) || $a9fafee67bdeda69$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a9fafee67bdeda69$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a9fafee67bdeda69$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a9fafee67bdeda69$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a9fafee67bdeda69$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a9fafee67bdeda69$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a9fafee67bdeda69$var$isDeferredResult(actionResult)) throw $a9fafee67bdeda69$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a9fafee67bdeda69$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a9fafee67bdeda69$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a9fafee67bdeda69$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a9fafee67bdeda69$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a9fafee67bdeda69$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a9fafee67bdeda69$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a9fafee67bdeda69$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $a9fafee67bdeda69$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a9fafee67bdeda69$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a9fafee67bdeda69$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a9fafee67bdeda69$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a9fafee67bdeda69$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a9fafee67bdeda69$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a9fafee67bdeda69$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a9fafee67bdeda69$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $a9fafee67bdeda69$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a9fafee67bdeda69$var$isDeferredResult(result)) result = await $a9fafee67bdeda69$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a9fafee67bdeda69$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a9fafee67bdeda69$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a9fafee67bdeda69$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a9fafee67bdeda69$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a9fafee67bdeda69$export$3e9cee6b33872309(!$a9fafee67bdeda69$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a9fafee67bdeda69$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $a9fafee67bdeda69$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $a9fafee67bdeda69$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $a9fafee67bdeda69$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a9fafee67bdeda69$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a9fafee67bdeda69$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $a9fafee67bdeda69$export$e19cd5f9376f8cee.Replace : $a9fafee67bdeda69$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a9fafee67bdeda69$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a9fafee67bdeda69$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $a9fafee67bdeda69$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a9fafee67bdeda69$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a9fafee67bdeda69$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $a9fafee67bdeda69$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $a9fafee67bdeda69$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($a9fafee67bdeda69$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $a9fafee67bdeda69$var$ResultType.redirect,
                response: $a9fafee67bdeda69$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $a9fafee67bdeda69$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $a9fafee67bdeda69$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $a9fafee67bdeda69$var$ResultType.error,
                    error: $a9fafee67bdeda69$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $a9fafee67bdeda69$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $a9fafee67bdeda69$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a9fafee67bdeda69$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $a9fafee67bdeda69$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a9fafee67bdeda69$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a9fafee67bdeda69$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a9fafee67bdeda69$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a9fafee67bdeda69$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a9fafee67bdeda69$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a9fafee67bdeda69$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a9fafee67bdeda69$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $a9fafee67bdeda69$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $a9fafee67bdeda69$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a9fafee67bdeda69$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a9fafee67bdeda69$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $a9fafee67bdeda69$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $a9fafee67bdeda69$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $a9fafee67bdeda69$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $a9fafee67bdeda69$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $a9fafee67bdeda69$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a9fafee67bdeda69$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $a9fafee67bdeda69$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a9fafee67bdeda69$export$4d0306f8f6a4585b = Symbol("deferred");
function $a9fafee67bdeda69$export$3336b097a6fbc59a(routes, opts) {
    $a9fafee67bdeda69$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a9fafee67bdeda69$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a9fafee67bdeda69$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a9fafee67bdeda69$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a9fafee67bdeda69$var$createLocation("", $a9fafee67bdeda69$export$fe53371bee54353d(url), null, "default");
        let matches = $a9fafee67bdeda69$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a9fafee67bdeda69$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a9fafee67bdeda69$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a9fafee67bdeda69$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a9fafee67bdeda69$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a9fafee67bdeda69$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($a9fafee67bdeda69$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a9fafee67bdeda69$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a9fafee67bdeda69$var$createLocation("", $a9fafee67bdeda69$export$fe53371bee54353d(url), null, "default");
        let matches = $a9fafee67bdeda69$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a9fafee67bdeda69$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a9fafee67bdeda69$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a9fafee67bdeda69$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a9fafee67bdeda69$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a9fafee67bdeda69$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a9fafee67bdeda69$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($a9fafee67bdeda69$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a9fafee67bdeda69$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $a9fafee67bdeda69$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a9fafee67bdeda69$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a9fafee67bdeda69$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $a9fafee67bdeda69$var$isResponse(result) ? result : $a9fafee67bdeda69$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($a9fafee67bdeda69$var$isDataStrategyResult(e) && $a9fafee67bdeda69$var$isResponse(e.result)) {
                if (e.type === $a9fafee67bdeda69$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a9fafee67bdeda69$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a9fafee67bdeda69$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a9fafee67bdeda69$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $a9fafee67bdeda69$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a9fafee67bdeda69$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($a9fafee67bdeda69$var$isDeferredResult(result)) {
            let error = $a9fafee67bdeda69$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a9fafee67bdeda69$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a9fafee67bdeda69$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($a9fafee67bdeda69$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $a9fafee67bdeda69$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $a9fafee67bdeda69$var$_extends({}, context, {
                statusCode: $a9fafee67bdeda69$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $a9fafee67bdeda69$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $a9fafee67bdeda69$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a9fafee67bdeda69$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1]) ? $a9fafee67bdeda69$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $a9fafee67bdeda69$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a9fafee67bdeda69$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a9fafee67bdeda69$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $a9fafee67bdeda69$var$callDataStrategyImpl(dataStrategy || $a9fafee67bdeda69$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($a9fafee67bdeda69$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $a9fafee67bdeda69$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($a9fafee67bdeda69$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $a9fafee67bdeda69$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a9fafee67bdeda69$export$fec11da027c70692(routes, context, error) {
    let newContext = $a9fafee67bdeda69$var$_extends({}, context, {
        statusCode: $a9fafee67bdeda69$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a9fafee67bdeda69$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a9fafee67bdeda69$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a9fafee67bdeda69$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a9fafee67bdeda69$export$cae722b0cc860f13(to ? to : ".", $a9fafee67bdeda69$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a9fafee67bdeda69$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $a9fafee67bdeda69$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a9fafee67bdeda69$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a9fafee67bdeda69$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a9fafee67bdeda69$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a9fafee67bdeda69$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a9fafee67bdeda69$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a9fafee67bdeda69$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a9fafee67bdeda69$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a9fafee67bdeda69$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a9fafee67bdeda69$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a9fafee67bdeda69$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a9fafee67bdeda69$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a9fafee67bdeda69$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a9fafee67bdeda69$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a9fafee67bdeda69$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a9fafee67bdeda69$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a9fafee67bdeda69$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a9fafee67bdeda69$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a9fafee67bdeda69$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a9fafee67bdeda69$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $a9fafee67bdeda69$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $a9fafee67bdeda69$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $a9fafee67bdeda69$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $a9fafee67bdeda69$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $a9fafee67bdeda69$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($a9fafee67bdeda69$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a9fafee67bdeda69$var$shouldRevalidateLoader(match, $a9fafee67bdeda69$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a9fafee67bdeda69$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a9fafee67bdeda69$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a9fafee67bdeda69$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a9fafee67bdeda69$var$shouldRevalidateLoader(fetcherMatch, $a9fafee67bdeda69$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a9fafee67bdeda69$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $a9fafee67bdeda69$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a9fafee67bdeda69$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a9fafee67bdeda69$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $a9fafee67bdeda69$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $a9fafee67bdeda69$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$a9fafee67bdeda69$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $a9fafee67bdeda69$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $a9fafee67bdeda69$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$a9fafee67bdeda69$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a9fafee67bdeda69$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a9fafee67bdeda69$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a9fafee67bdeda69$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a9fafee67bdeda69$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a9fafee67bdeda69$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $a9fafee67bdeda69$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $a9fafee67bdeda69$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $a9fafee67bdeda69$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $a9fafee67bdeda69$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $a9fafee67bdeda69$var$ResultType.data,
                result: undefined
            });
        };
        return $a9fafee67bdeda69$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $a9fafee67bdeda69$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a9fafee67bdeda69$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a9fafee67bdeda69$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a9fafee67bdeda69$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a9fafee67bdeda69$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $a9fafee67bdeda69$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $a9fafee67bdeda69$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($a9fafee67bdeda69$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a9fafee67bdeda69$var$ResultType.error,
                error: e
            };
        }
        if (type === $a9fafee67bdeda69$var$ResultType.error) return {
            type: $a9fafee67bdeda69$var$ResultType.error,
            error: new $a9fafee67bdeda69$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $a9fafee67bdeda69$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $a9fafee67bdeda69$var$ResultType.error) {
        if ($a9fafee67bdeda69$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $a9fafee67bdeda69$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $a9fafee67bdeda69$var$ResultType.error,
                error: new $a9fafee67bdeda69$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $a9fafee67bdeda69$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $a9fafee67bdeda69$var$ResultType.error,
            error: result,
            statusCode: $a9fafee67bdeda69$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($a9fafee67bdeda69$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $a9fafee67bdeda69$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($a9fafee67bdeda69$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $a9fafee67bdeda69$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $a9fafee67bdeda69$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $a9fafee67bdeda69$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $a9fafee67bdeda69$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$a9fafee67bdeda69$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $a9fafee67bdeda69$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $a9fafee67bdeda69$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($a9fafee67bdeda69$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $a9fafee67bdeda69$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a9fafee67bdeda69$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a9fafee67bdeda69$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a9fafee67bdeda69$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a9fafee67bdeda69$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a9fafee67bdeda69$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a9fafee67bdeda69$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a9fafee67bdeda69$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $a9fafee67bdeda69$export$3e9cee6b33872309(!$a9fafee67bdeda69$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a9fafee67bdeda69$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $a9fafee67bdeda69$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a9fafee67bdeda69$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($a9fafee67bdeda69$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a9fafee67bdeda69$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a9fafee67bdeda69$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $a9fafee67bdeda69$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($a9fafee67bdeda69$var$isErrorResult(result)) {
            let boundaryMatch = $a9fafee67bdeda69$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a9fafee67bdeda69$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a9fafee67bdeda69$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a9fafee67bdeda69$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a9fafee67bdeda69$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a9fafee67bdeda69$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a9fafee67bdeda69$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a9fafee67bdeda69$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a9fafee67bdeda69$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $a9fafee67bdeda69$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $a9fafee67bdeda69$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a9fafee67bdeda69$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a9fafee67bdeda69$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a9fafee67bdeda69$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a9fafee67bdeda69$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a9fafee67bdeda69$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($a9fafee67bdeda69$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $a9fafee67bdeda69$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a9fafee67bdeda69$export$8ccf933b0513f8d0(path) : path;
    return $a9fafee67bdeda69$export$fe53371bee54353d($a9fafee67bdeda69$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a9fafee67bdeda69$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a9fafee67bdeda69$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $a9fafee67bdeda69$var$ResultType.data || result.type === $a9fafee67bdeda69$var$ResultType.error);
}
function $a9fafee67bdeda69$var$isRedirectDataStrategyResultResult(result) {
    return $a9fafee67bdeda69$var$isResponse(result.result) && $a9fafee67bdeda69$var$redirectStatusCodes.has(result.result.status);
}
function $a9fafee67bdeda69$var$isDeferredResult(result) {
    return result.type === $a9fafee67bdeda69$var$ResultType.deferred;
}
function $a9fafee67bdeda69$var$isErrorResult(result) {
    return result.type === $a9fafee67bdeda69$var$ResultType.error;
}
function $a9fafee67bdeda69$var$isRedirectResult(result) {
    return (result && result.type) === $a9fafee67bdeda69$var$ResultType.redirect;
}
function $a9fafee67bdeda69$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $a9fafee67bdeda69$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a9fafee67bdeda69$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a9fafee67bdeda69$var$isRedirectResponse(result) {
    if (!$a9fafee67bdeda69$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a9fafee67bdeda69$var$isValidMethod(method) {
    return $a9fafee67bdeda69$var$validRequestMethods.has(method.toLowerCase());
}
function $a9fafee67bdeda69$var$isMutationMethod(method) {
    return $a9fafee67bdeda69$var$validMutationMethods.has(method.toLowerCase());
}
async function $a9fafee67bdeda69$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a9fafee67bdeda69$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a9fafee67bdeda69$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $a9fafee67bdeda69$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $a9fafee67bdeda69$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($a9fafee67bdeda69$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $a9fafee67bdeda69$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $a9fafee67bdeda69$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $a9fafee67bdeda69$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a9fafee67bdeda69$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a9fafee67bdeda69$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a9fafee67bdeda69$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a9fafee67bdeda69$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a9fafee67bdeda69$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a9fafee67bdeda69$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a9fafee67bdeda69$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a9fafee67bdeda69$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a9fafee67bdeda69$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a9fafee67bdeda69$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a9fafee67bdeda69$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a9fafee67bdeda69$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a9fafee67bdeda69$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a9fafee67bdeda69$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a9fafee67bdeda69$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a9fafee67bdeda69$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a9fafee67bdeda69$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a9fafee67bdeda69$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a9fafee67bdeda69$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $cvMSo = parcelRequire("cvMSo");

function $217401a2c993c609$var$_extends() {
    $217401a2c993c609$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $217401a2c993c609$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $217401a2c993c609$export$3add0d5dce533e2e = /*#__PURE__*/ $cvMSo.createContext(null);
const $217401a2c993c609$export$145dfa71566a64dc = /*#__PURE__*/ $cvMSo.createContext(null);
const $217401a2c993c609$var$AwaitContext = /*#__PURE__*/ $cvMSo.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $217401a2c993c609$export$26749e8557646306 = /*#__PURE__*/ $cvMSo.createContext(null);
const $217401a2c993c609$export$c7914228fb69b0f5 = /*#__PURE__*/ $cvMSo.createContext(null);
const $217401a2c993c609$export$9072aa6dd1f93057 = /*#__PURE__*/ $cvMSo.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $217401a2c993c609$var$RouteErrorContext = /*#__PURE__*/ $cvMSo.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $217401a2c993c609$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$217401a2c993c609$export$9c954a9d03d32f4a() && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $cvMSo.useContext($217401a2c993c609$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $217401a2c993c609$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $a9fafee67bdeda69$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $217401a2c993c609$export$9c954a9d03d32f4a() {
    return $cvMSo.useContext($217401a2c993c609$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $217401a2c993c609$export$45d76561a5302f2b() {
    !$217401a2c993c609$export$9c954a9d03d32f4a() && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    return $cvMSo.useContext($217401a2c993c609$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $217401a2c993c609$export$1b3f31771c5d07c() {
    return $cvMSo.useContext($217401a2c993c609$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $217401a2c993c609$export$6c330e8992e8a295(pattern) {
    !$217401a2c993c609$export$9c954a9d03d32f4a() && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $217401a2c993c609$export$45d76561a5302f2b();
    return $cvMSo.useMemo(()=>(0, $a9fafee67bdeda69$export$81336c211d5ff295)(pattern, (0, $a9fafee67bdeda69$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $217401a2c993c609$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $217401a2c993c609$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $cvMSo.useContext($217401a2c993c609$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cvMSo.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $217401a2c993c609$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $217401a2c993c609$var$useNavigateStable() : $217401a2c993c609$var$useNavigateUnstable();
}
function $217401a2c993c609$var$useNavigateUnstable() {
    !$217401a2c993c609$export$9c954a9d03d32f4a() && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    let dataRouterContext = $cvMSo.useContext($217401a2c993c609$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $cvMSo.useContext($217401a2c993c609$export$26749e8557646306);
    let { matches: matches } = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $217401a2c993c609$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a9fafee67bdeda69$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $cvMSo.useRef(false);
    $217401a2c993c609$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $cvMSo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $a9fafee67bdeda69$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a9fafee67bdeda69$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $217401a2c993c609$var$OutletContext = /*#__PURE__*/ $cvMSo.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $217401a2c993c609$export$4138103a3ae699cc() {
    return $cvMSo.useContext($217401a2c993c609$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $217401a2c993c609$export$a3be3530d8e40d0b(context) {
    let outlet = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $217401a2c993c609$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $217401a2c993c609$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $cvMSo.useContext($217401a2c993c609$export$26749e8557646306);
    let { matches: matches } = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $217401a2c993c609$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a9fafee67bdeda69$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $cvMSo.useMemo(()=>(0, $a9fafee67bdeda69$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $217401a2c993c609$export$5d3fca4a98652595(routes, locationArg) {
    return $217401a2c993c609$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $217401a2c993c609$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$217401a2c993c609$export$9c954a9d03d32f4a() && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $cvMSo.useContext($217401a2c993c609$export$26749e8557646306);
    let { matches: parentMatches } = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $217401a2c993c609$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $a9fafee67bdeda69$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $a9fafee67bdeda69$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $217401a2c993c609$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $a9fafee67bdeda69$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $a9fafee67bdeda69$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $217401a2c993c609$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $a9fafee67bdeda69$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $217401a2c993c609$var$DefaultErrorComponent() {
    let error = $217401a2c993c609$export$ed527bf60f6e05f2();
    let message = (0, $a9fafee67bdeda69$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $cvMSo.createElement($cvMSo.Fragment, null, /*#__PURE__*/ $cvMSo.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $cvMSo.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $cvMSo.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $217401a2c993c609$var$defaultErrorElement = /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$DefaultErrorComponent, null);
class $217401a2c993c609$var$RenderErrorBoundary extends $cvMSo.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $217401a2c993c609$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $cvMSo.useContext($217401a2c993c609$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $217401a2c993c609$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $217401a2c993c609$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $217401a2c993c609$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $cvMSo.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $217401a2c993c609$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($217401a2c993c609$var$DataRouterHook || {});
var $217401a2c993c609$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($217401a2c993c609$var$DataRouterStateHook || {});
function $217401a2c993c609$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $217401a2c993c609$var$useDataRouterContext(hookName) {
    let ctx = $cvMSo.useContext($217401a2c993c609$export$3add0d5dce533e2e);
    !ctx && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    return ctx;
}
function $217401a2c993c609$var$useDataRouterState(hookName) {
    let state = $cvMSo.useContext($217401a2c993c609$export$145dfa71566a64dc);
    !state && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    return state;
}
function $217401a2c993c609$var$useRouteContext(hookName) {
    let route = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057);
    !route && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $217401a2c993c609$var$useCurrentRouteId(hookName) {
    let route = $217401a2c993c609$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $217401a2c993c609$export$5fc8298006ad9e58() {
    return $217401a2c993c609$var$useCurrentRouteId($217401a2c993c609$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $217401a2c993c609$export$d0fd4b7106de2769() {
    let state = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $217401a2c993c609$export$600dc272ed516c15() {
    let dataRouterContext = $217401a2c993c609$var$useDataRouterContext($217401a2c993c609$var$DataRouterHook.UseRevalidator);
    let state = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseRevalidator);
    return $cvMSo.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $217401a2c993c609$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseMatches);
    return $cvMSo.useMemo(()=>matches.map((m)=>(0, $a9fafee67bdeda69$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $217401a2c993c609$export$1448a5050d252c4d() {
    let state = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseLoaderData);
    let routeId = $217401a2c993c609$var$useCurrentRouteId($217401a2c993c609$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $217401a2c993c609$export$fd5d37484eab868d(routeId) {
    let state = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $217401a2c993c609$export$fdc00f3f26066d5e() {
    let state = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseActionData);
    let routeId = $217401a2c993c609$var$useCurrentRouteId($217401a2c993c609$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $217401a2c993c609$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $cvMSo.useContext($217401a2c993c609$var$RouteErrorContext);
    let state = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseRouteError);
    let routeId = $217401a2c993c609$var$useCurrentRouteId($217401a2c993c609$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $217401a2c993c609$export$78a72ddb39bdd145() {
    let value = $cvMSo.useContext($217401a2c993c609$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $217401a2c993c609$export$17f53340677d5831() {
    let value = $cvMSo.useContext($217401a2c993c609$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $217401a2c993c609$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $217401a2c993c609$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $217401a2c993c609$var$useDataRouterContext($217401a2c993c609$var$DataRouterHook.UseBlocker);
    let state = $217401a2c993c609$var$useDataRouterState($217401a2c993c609$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $cvMSo.useState("");
    let blockerFunction = $cvMSo.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $217401a2c993c609$var$_extends({}, currentLocation, {
                pathname: (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $217401a2c993c609$var$_extends({}, nextLocation, {
                pathname: (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $cvMSo.useEffect(()=>{
        let key = String(++$217401a2c993c609$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $cvMSo.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $a9fafee67bdeda69$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $217401a2c993c609$var$useNavigateStable() {
    let { router: router } = $217401a2c993c609$var$useDataRouterContext($217401a2c993c609$var$DataRouterHook.UseNavigateStable);
    let id = $217401a2c993c609$var$useCurrentRouteId($217401a2c993c609$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $cvMSo.useRef(false);
    $217401a2c993c609$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $cvMSo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $217401a2c993c609$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $217401a2c993c609$var$alreadyWarned$1 = {};
function $217401a2c993c609$var$warningOnce(key, cond, message) {
    if (!cond && !$217401a2c993c609$var$alreadyWarned$1[key]) $217401a2c993c609$var$alreadyWarned$1[key] = true;
}
const $217401a2c993c609$var$alreadyWarned = {};
function $217401a2c993c609$var$warnOnce(key, message) {}
const $217401a2c993c609$var$logDeprecation = (flag, msg, link)=>$217401a2c993c609$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $217401a2c993c609$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $217401a2c993c609$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $217401a2c993c609$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $217401a2c993c609$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $217401a2c993c609$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $217401a2c993c609$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $217401a2c993c609$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $217401a2c993c609$var$START_TRANSITION = "startTransition";
const $217401a2c993c609$var$startTransitionImpl = $cvMSo[$217401a2c993c609$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $217401a2c993c609$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $cvMSo.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cvMSo.useCallback((newState)=>{
        if (v7_startTransition && $217401a2c993c609$var$startTransitionImpl) $217401a2c993c609$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $cvMSo.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $cvMSo.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $cvMSo.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $cvMSo.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $cvMSo.useEffect(()=>$217401a2c993c609$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $cvMSo.createElement($cvMSo.Fragment, null, /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $217401a2c993c609$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $217401a2c993c609$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $217401a2c993c609$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $cvMSo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a9fafee67bdeda69$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $cvMSo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cvMSo.useCallback((newState)=>{
        v7_startTransition && $217401a2c993c609$var$startTransitionImpl ? $217401a2c993c609$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cvMSo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cvMSo.useEffect(()=>$217401a2c993c609$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $217401a2c993c609$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$217401a2c993c609$export$9c954a9d03d32f4a() && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $cvMSo.useContext($217401a2c993c609$export$26749e8557646306);
    let { matches: matches } = $cvMSo.useContext($217401a2c993c609$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $217401a2c993c609$export$45d76561a5302f2b();
    let navigate = $217401a2c993c609$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $a9fafee67bdeda69$export$cae722b0cc860f13)(to, (0, $a9fafee67bdeda69$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $cvMSo.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $217401a2c993c609$export$910ae8079b2c2852(props) {
    return $217401a2c993c609$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $217401a2c993c609$export$e7b0ac011bb776c6(_props) {
    (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $217401a2c993c609$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $a9fafee67bdeda69$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$217401a2c993c609$export$9c954a9d03d32f4a() && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $cvMSo.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $217401a2c993c609$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $a9fafee67bdeda69$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $cvMSo.useMemo(()=>{
        let trailingPathname = (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $217401a2c993c609$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $217401a2c993c609$export$5d3fca4a98652595($217401a2c993c609$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $217401a2c993c609$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$ResolveAwait, null, children));
}
var $217401a2c993c609$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($217401a2c993c609$var$AwaitRenderStatus || {});
const $217401a2c993c609$var$neverSettledPromise = new Promise(()=>{});
class $217401a2c993c609$var$AwaitErrorBoundary extends $cvMSo.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $217401a2c993c609$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $217401a2c993c609$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $217401a2c993c609$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $217401a2c993c609$var$AwaitRenderStatus.error : "_data" in promise ? $217401a2c993c609$var$AwaitRenderStatus.success : $217401a2c993c609$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $217401a2c993c609$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $217401a2c993c609$var$AwaitRenderStatus.error && promise._error instanceof (0, $a9fafee67bdeda69$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $217401a2c993c609$var$neverSettledPromise;
        if (status === $217401a2c993c609$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $217401a2c993c609$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $217401a2c993c609$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $cvMSo.createElement($217401a2c993c609$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $217401a2c993c609$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $217401a2c993c609$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $cvMSo.createElement($cvMSo.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $217401a2c993c609$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $cvMSo.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $cvMSo.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $cvMSo.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $217401a2c993c609$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $217401a2c993c609$export$e7b0ac011bb776c6) && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $217401a2c993c609$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $217401a2c993c609$export$daf73786167a7f72(matches) {
    return $217401a2c993c609$var$_renderMatches(matches);
}
function $217401a2c993c609$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $cvMSo.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $cvMSo.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $cvMSo.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $217401a2c993c609$export$f30f7e456d254e83(routes, opts) {
    return (0, $a9fafee67bdeda69$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $217401a2c993c609$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a9fafee67bdeda69$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $217401a2c993c609$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $cc10053bf1b5cdc7$var$_extends() {
    $cc10053bf1b5cdc7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cc10053bf1b5cdc7$var$_extends.apply(this, arguments);
}
function $cc10053bf1b5cdc7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $cc10053bf1b5cdc7$var$defaultMethod = "get";
const $cc10053bf1b5cdc7$var$defaultEncType = "application/x-www-form-urlencoded";
function $cc10053bf1b5cdc7$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $cc10053bf1b5cdc7$var$isButtonElement(object) {
    return $cc10053bf1b5cdc7$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $cc10053bf1b5cdc7$var$isFormElement(object) {
    return $cc10053bf1b5cdc7$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $cc10053bf1b5cdc7$var$isInputElement(object) {
    return $cc10053bf1b5cdc7$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $cc10053bf1b5cdc7$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $cc10053bf1b5cdc7$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$cc10053bf1b5cdc7$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $cc10053bf1b5cdc7$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $cc10053bf1b5cdc7$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $cc10053bf1b5cdc7$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $cc10053bf1b5cdc7$var$_formDataSupportsSubmitter = null;
function $cc10053bf1b5cdc7$var$isFormDataSubmitterSupported() {
    if ($cc10053bf1b5cdc7$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $cc10053bf1b5cdc7$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $cc10053bf1b5cdc7$var$_formDataSupportsSubmitter = true;
    }
    return $cc10053bf1b5cdc7$var$_formDataSupportsSubmitter;
}
const $cc10053bf1b5cdc7$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $cc10053bf1b5cdc7$var$getFormEncType(encType) {
    if (encType != null && !$cc10053bf1b5cdc7$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $cc10053bf1b5cdc7$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($cc10053bf1b5cdc7$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $cc10053bf1b5cdc7$var$defaultMethod;
        encType = $cc10053bf1b5cdc7$var$getFormEncType(target.getAttribute("enctype")) || $cc10053bf1b5cdc7$var$defaultEncType;
        formData = new FormData(target);
    } else if ($cc10053bf1b5cdc7$var$isButtonElement(target) || $cc10053bf1b5cdc7$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $cc10053bf1b5cdc7$var$defaultMethod;
        encType = $cc10053bf1b5cdc7$var$getFormEncType(target.getAttribute("formenctype")) || $cc10053bf1b5cdc7$var$getFormEncType(form.getAttribute("enctype")) || $cc10053bf1b5cdc7$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$cc10053bf1b5cdc7$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($cc10053bf1b5cdc7$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $cc10053bf1b5cdc7$var$defaultMethod;
        action = null;
        encType = $cc10053bf1b5cdc7$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $cc10053bf1b5cdc7$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $cc10053bf1b5cdc7$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $cc10053bf1b5cdc7$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $cc10053bf1b5cdc7$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $cc10053bf1b5cdc7$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $cc10053bf1b5cdc7$export$1f3f55432a00e06d(routes, opts) {
    return (0, $a9fafee67bdeda69$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $cc10053bf1b5cdc7$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a9fafee67bdeda69$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $cc10053bf1b5cdc7$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $217401a2c993c609$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $cc10053bf1b5cdc7$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $a9fafee67bdeda69$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $cc10053bf1b5cdc7$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a9fafee67bdeda69$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $cc10053bf1b5cdc7$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $217401a2c993c609$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $cc10053bf1b5cdc7$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $cc10053bf1b5cdc7$var$_extends({}, state, {
        errors: $cc10053bf1b5cdc7$var$deserializeErrors(state.errors)
    });
    return state;
}
function $cc10053bf1b5cdc7$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $a9fafee67bdeda69$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $cc10053bf1b5cdc7$export$7ad602f0e94e62d1 = /*#__PURE__*/ $cvMSo.createContext({
    isTransitioning: false
});
const $cc10053bf1b5cdc7$export$148fd98d095596d4 = /*#__PURE__*/ $cvMSo.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $cc10053bf1b5cdc7$var$START_TRANSITION = "startTransition";
const $cc10053bf1b5cdc7$var$startTransitionImpl = $cvMSo[$cc10053bf1b5cdc7$var$START_TRANSITION];
const $cc10053bf1b5cdc7$var$FLUSH_SYNC = "flushSync";
const $cc10053bf1b5cdc7$var$flushSyncImpl = $hVGez[$cc10053bf1b5cdc7$var$FLUSH_SYNC];
const $cc10053bf1b5cdc7$var$USE_ID = "useId";
const $cc10053bf1b5cdc7$var$useIdImpl = $cvMSo[$cc10053bf1b5cdc7$var$USE_ID];
function $cc10053bf1b5cdc7$var$startTransitionSafe(cb) {
    if ($cc10053bf1b5cdc7$var$startTransitionImpl) $cc10053bf1b5cdc7$var$startTransitionImpl(cb);
    else cb();
}
function $cc10053bf1b5cdc7$var$flushSyncSafe(cb) {
    if ($cc10053bf1b5cdc7$var$flushSyncImpl) $cc10053bf1b5cdc7$var$flushSyncImpl(cb);
    else cb();
}
class $cc10053bf1b5cdc7$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $cc10053bf1b5cdc7$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $cvMSo.useState(router.state);
    let [pendingState, setPendingState] = $cvMSo.useState();
    let [vtContext, setVtContext] = $cvMSo.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $cvMSo.useState();
    let [transition, setTransition] = $cvMSo.useState();
    let [interruption, setInterruption] = $cvMSo.useState();
    let fetcherData = $cvMSo.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $cvMSo.useCallback((cb)=>{
        if (v7_startTransition) $cc10053bf1b5cdc7$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $cvMSo.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $cc10053bf1b5cdc7$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $cc10053bf1b5cdc7$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $cc10053bf1b5cdc7$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $cc10053bf1b5cdc7$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $cc10053bf1b5cdc7$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $cvMSo.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $cvMSo.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $cc10053bf1b5cdc7$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $cvMSo.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $cvMSo.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $cvMSo.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $cvMSo.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $cvMSo.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $cvMSo.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $cvMSo.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $cvMSo.useEffect(()=>(0, $217401a2c993c609$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $cvMSo.createElement($cvMSo.Fragment, null, /*#__PURE__*/ $cvMSo.createElement((0, $217401a2c993c609$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $cvMSo.createElement((0, $217401a2c993c609$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $cvMSo.createElement($cc10053bf1b5cdc7$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $cvMSo.createElement($cc10053bf1b5cdc7$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $cvMSo.createElement((0, $217401a2c993c609$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $cvMSo.createElement($cc10053bf1b5cdc7$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $cc10053bf1b5cdc7$var$MemoizedDataRoutes = /*#__PURE__*/ $cvMSo.memo($cc10053bf1b5cdc7$var$DataRoutes);
function $cc10053bf1b5cdc7$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $217401a2c993c609$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $cc10053bf1b5cdc7$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $cvMSo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a9fafee67bdeda69$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $cvMSo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cvMSo.useCallback((newState)=>{
        v7_startTransition && $cc10053bf1b5cdc7$var$startTransitionImpl ? $cc10053bf1b5cdc7$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cvMSo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cvMSo.useEffect(()=>(0, $217401a2c993c609$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $cvMSo.createElement((0, $217401a2c993c609$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $cc10053bf1b5cdc7$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $cvMSo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a9fafee67bdeda69$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $cvMSo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cvMSo.useCallback((newState)=>{
        v7_startTransition && $cc10053bf1b5cdc7$var$startTransitionImpl ? $cc10053bf1b5cdc7$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cvMSo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cvMSo.useEffect(()=>(0, $217401a2c993c609$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $cvMSo.createElement((0, $217401a2c993c609$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $cc10053bf1b5cdc7$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $cvMSo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cvMSo.useCallback((newState)=>{
        v7_startTransition && $cc10053bf1b5cdc7$var$startTransitionImpl ? $cc10053bf1b5cdc7$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cvMSo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cvMSo.useEffect(()=>(0, $217401a2c993c609$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $cvMSo.createElement((0, $217401a2c993c609$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $cc10053bf1b5cdc7$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $cc10053bf1b5cdc7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a = /*#__PURE__*/ $cvMSo.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $cc10053bf1b5cdc7$var$_objectWithoutPropertiesLoose(_ref7, $cc10053bf1b5cdc7$var$_excluded);
    let { basename: basename } = $cvMSo.useContext((0, $217401a2c993c609$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $cc10053bf1b5cdc7$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($cc10053bf1b5cdc7$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $217401a2c993c609$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $cc10053bf1b5cdc7$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $cvMSo.createElement("a", $cc10053bf1b5cdc7$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $cc10053bf1b5cdc7$export$b0d92dbee9b5b60d = /*#__PURE__*/ $cvMSo.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $cc10053bf1b5cdc7$var$_objectWithoutPropertiesLoose(_ref8, $cc10053bf1b5cdc7$var$_excluded2);
    let path = (0, $217401a2c993c609$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $217401a2c993c609$export$45d76561a5302f2b)();
    let routerState = $cvMSo.useContext((0, $217401a2c993c609$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $cvMSo.useContext((0, $217401a2c993c609$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cc10053bf1b5cdc7$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $cvMSo.createElement($cc10053bf1b5cdc7$export$a6c7ac8248d6e38a, $cc10053bf1b5cdc7$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $cc10053bf1b5cdc7$export$a7fed597f4b8afd8 = /*#__PURE__*/ $cvMSo.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $cc10053bf1b5cdc7$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $cc10053bf1b5cdc7$var$_objectWithoutPropertiesLoose(_ref9, $cc10053bf1b5cdc7$var$_excluded3);
    let submit = $cc10053bf1b5cdc7$export$47c85c6e3a081d3();
    let formAction = $cc10053bf1b5cdc7$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $cvMSo.createElement("form", $cc10053bf1b5cdc7$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $cc10053bf1b5cdc7$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $cc10053bf1b5cdc7$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $cc10053bf1b5cdc7$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($cc10053bf1b5cdc7$var$DataRouterHook || ($cc10053bf1b5cdc7$var$DataRouterHook = {}));
var $cc10053bf1b5cdc7$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($cc10053bf1b5cdc7$var$DataRouterStateHook || ($cc10053bf1b5cdc7$var$DataRouterStateHook = {}));
// Internal hooks
function $cc10053bf1b5cdc7$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $cc10053bf1b5cdc7$var$useDataRouterContext(hookName) {
    let ctx = $cvMSo.useContext((0, $217401a2c993c609$export$3add0d5dce533e2e));
    !ctx && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    return ctx;
}
function $cc10053bf1b5cdc7$var$useDataRouterState(hookName) {
    let state = $cvMSo.useContext((0, $217401a2c993c609$export$145dfa71566a64dc));
    !state && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $cc10053bf1b5cdc7$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $217401a2c993c609$export$9770f232ac06a008)();
    let location = (0, $217401a2c993c609$export$45d76561a5302f2b)();
    let path = (0, $217401a2c993c609$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $cvMSo.useCallback((event)=>{
        if ($cc10053bf1b5cdc7$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $a9fafee67bdeda69$export$fe53371bee54353d)(location) === (0, $a9fafee67bdeda69$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $cc10053bf1b5cdc7$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $cvMSo.useRef($cc10053bf1b5cdc7$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $cvMSo.useRef(false);
    let location = (0, $217401a2c993c609$export$45d76561a5302f2b)();
    let searchParams = $cvMSo.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $cc10053bf1b5cdc7$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $217401a2c993c609$export$9770f232ac06a008)();
    let setSearchParams = $cvMSo.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $cc10053bf1b5cdc7$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $cc10053bf1b5cdc7$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $cc10053bf1b5cdc7$var$fetcherId = 0;
let $cc10053bf1b5cdc7$var$getUniqueFetcherId = ()=>"__" + String(++$cc10053bf1b5cdc7$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $cc10053bf1b5cdc7$export$47c85c6e3a081d3() {
    let { router: router } = $cc10053bf1b5cdc7$var$useDataRouterContext($cc10053bf1b5cdc7$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $cvMSo.useContext((0, $217401a2c993c609$export$26749e8557646306));
    let currentRouteId = (0, $217401a2c993c609$export$5fc8298006ad9e58)();
    return $cvMSo.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $cc10053bf1b5cdc7$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $cc10053bf1b5cdc7$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $cc10053bf1b5cdc7$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $cc10053bf1b5cdc7$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $cvMSo.useContext((0, $217401a2c993c609$export$26749e8557646306));
    let routeContext = $cvMSo.useContext((0, $217401a2c993c609$export$9072aa6dd1f93057));
    !routeContext && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $cc10053bf1b5cdc7$var$_extends({}, (0, $217401a2c993c609$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $217401a2c993c609$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a9fafee67bdeda69$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $a9fafee67bdeda69$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $cc10053bf1b5cdc7$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $cc10053bf1b5cdc7$var$useDataRouterContext($cc10053bf1b5cdc7$var$DataRouterHook.UseFetcher);
    let state = $cc10053bf1b5cdc7$var$useDataRouterState($cc10053bf1b5cdc7$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $cvMSo.useContext($cc10053bf1b5cdc7$export$148fd98d095596d4);
    let route = $cvMSo.useContext((0, $217401a2c993c609$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    !route && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $cc10053bf1b5cdc7$var$useIdImpl ? $cc10053bf1b5cdc7$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $cvMSo.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($cc10053bf1b5cdc7$var$getUniqueFetcherId());
    // Registration/cleanup
    $cvMSo.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $cvMSo.useCallback((href, opts)=>{
        !routeId && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $cc10053bf1b5cdc7$export$47c85c6e3a081d3();
    let submit = $cvMSo.useCallback((target, opts)=>{
        submitImpl(target, $cc10053bf1b5cdc7$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $cvMSo.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $cvMSo.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $cvMSo.createElement($cc10053bf1b5cdc7$export$a7fed597f4b8afd8, $cc10053bf1b5cdc7$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $a9fafee67bdeda69$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $cvMSo.useMemo(()=>$cc10053bf1b5cdc7$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $cc10053bf1b5cdc7$export$fa996778a3a31087() {
    let state = $cc10053bf1b5cdc7$var$useDataRouterState($cc10053bf1b5cdc7$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $cc10053bf1b5cdc7$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $cc10053bf1b5cdc7$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $cc10053bf1b5cdc7$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $cc10053bf1b5cdc7$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $cc10053bf1b5cdc7$var$useDataRouterContext($cc10053bf1b5cdc7$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $cc10053bf1b5cdc7$var$useDataRouterState($cc10053bf1b5cdc7$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $cvMSo.useContext((0, $217401a2c993c609$export$26749e8557646306));
    let location = (0, $217401a2c993c609$export$45d76561a5302f2b)();
    let matches = (0, $217401a2c993c609$export$2378eb7f5ff86053)();
    let navigation = (0, $217401a2c993c609$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $cvMSo.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $cc10053bf1b5cdc7$var$usePageHide($cvMSo.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $cc10053bf1b5cdc7$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $cc10053bf1b5cdc7$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($cc10053bf1b5cdc7$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $cvMSo.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $cc10053bf1b5cdc7$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $cc10053bf1b5cdc7$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $cvMSo.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($cc10053bf1b5cdc7$var$_extends({}, location, {
                    pathname: (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($cc10053bf1b5cdc7$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $cvMSo.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $cc10053bf1b5cdc7$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $cvMSo.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $cc10053bf1b5cdc7$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $cvMSo.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $cc10053bf1b5cdc7$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $217401a2c993c609$export$b273b3273281a049)(when);
    $cvMSo.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $cvMSo.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $cc10053bf1b5cdc7$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $cvMSo.useContext($cc10053bf1b5cdc7$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $a9fafee67bdeda69$export$3e9cee6b33872309)(false);
    let { basename: basename } = $cc10053bf1b5cdc7$var$useDataRouterContext($cc10053bf1b5cdc7$var$DataRouterHook.useViewTransitionState);
    let path = (0, $217401a2c993c609$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $a9fafee67bdeda69$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $a9fafee67bdeda69$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $a9fafee67bdeda69$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



const $830815a01ff3e63b$export$9bd698419030e459 = ({ movie: movie, username: username, token: token, favoriteMovies: favoriteMovies, updateFavorites: updateFavorites })=>{
    let userFromStorage = null;
    let tokenFromStorage = null;
    try {
        const rawUser = localStorage.getItem("user");
        userFromStorage = rawUser ? JSON.parse(rawUser) : null;
    } catch (error) {
        console.error("Failed to parse user from localStorage", error);
    }
    tokenFromStorage = localStorage.getItem("token");
    const finalUsername = username || userFromStorage?.Username;
    const finalToken = token || tokenFromStorage;
    if (!finalUsername || !finalToken) {
        console.warn("DEBUG - finalUsername:", finalUsername);
        console.warn("DEBUG - finalToken:", finalToken);
    }
    const isFavorite = favoriteMovies?.some((fav)=>typeof fav === "string" ? fav === movie._id : fav._id === movie._id);
    const handleFavoriteToggle = ()=>{
        if (!finalUsername || !finalToken) {
            console.error("Username or token is missing!");
            return;
        }
        const encodedTitle = encodeURIComponent(movie.Title);
        const url = `https://movieminded-d764560749d0.herokuapp.com/users/${finalUsername}/movies/${encodedTitle}`;
        const method = isFavorite ? "DELETE" : "POST";
        fetch(url, {
            method: method,
            headers: {
                Authorization: `Bearer ${finalToken}`,
                "Content-Type": "application/json"
            }
        }).then((response)=>{
            if (!response.ok) throw new Error("Failed to update favorites");
            return response.json();
        }).then((updatedUser)=>{
            if (updateFavorites) {
                updateFavorites(updatedUser.FavoriteMovies);
                localStorage.setItem("user", JSON.stringify(updatedUser));
            }
        }).catch((error)=>{
            console.error("Error updating favorites:", error);
        });
    };
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039), {
        className: "h-100",
        children: [
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Img, {
                variant: "top",
                src: movie.ImagePath,
                onError: (e)=>e.target.src = "/fallback.jpg"
            }),
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Title, {
                        children: movie.Title
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Text, {
                        children: movie.Description
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                        variant: isFavorite ? "danger" : "success",
                        onClick: handleFavoriteToggle,
                        className: "mb-2 w-100",
                        children: isFavorite ? "Remove from Favorites" : "Add to Favorites"
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a), {
                        to: `/movies/${encodeURIComponent(movie.Title)}`,
                        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                            variant: "primary",
                            className: "w-100",
                            children: "Open"
                        })
                    })
                ]
            })
        ]
    });
};
$830815a01ff3e63b$export$9bd698419030e459.propTypes = {
    movie: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).shape({
        Title: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
        Description: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
        ImagePath: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
        Genre: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).shape({
            Name: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
            Description: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string
        }).isRequired,
        Director: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).shape({
            Name: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
            Bio: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired
        }).isRequired,
        Actors: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).array
    }).isRequired,
    username: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string,
    token: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string,
    favoriteMovies: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).array,
    updateFavorites: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).func
};



parcelRequire("cvMSo");




const $cd915859487eece6$export$78d497080ea8f89a = ({ movies: movies, username: username, token: token, favoriteMovies: favoriteMovies, updateFavorites: updateFavorites })=>{
    const { movieId: movieId } = (0, $217401a2c993c609$export$99eaa27ddbbb95ef)();
    const movie = Array.isArray(movies) ? movies.find((m)=>m?.Title && m.Title.toLowerCase() === decodeURIComponent(movieId).toLowerCase()) : null;
    if (!movie) return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
        children: "Loading movie details..."
    });
    const isFavorite = favoriteMovies?.some((fav)=>typeof fav === "string" ? fav === movie._id : fav._id === movie._id);
    const handleFavoriteToggle = ()=>{
        if (!username || !token) {
            console.error("Username or token is missing!");
            return;
        }
        const encodedTitle = encodeURIComponent(movie.Title);
        const url = `https://movieminded-d764560749d0.herokuapp.com/users/${username}/movies/${encodedTitle}`;
        const method = isFavorite ? "DELETE" : "POST";
        fetch(url, {
            method: method,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }).then((response)=>{
            if (!response.ok) throw new Error("Failed to update favorites");
            return response.json();
        }).then((updatedUser)=>{
            if (updateFavorites) {
                updateFavorites(updatedUser.FavoriteMovies);
                localStorage.setItem("user", JSON.stringify(updatedUser));
            }
        }).catch((error)=>{
            console.error("Error updating favorites:", error);
        });
    };
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039), {
        className: "my-4",
        children: [
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Img, {
                variant: "top",
                src: movie.ImagePath,
                onError: (e)=>e.target.src = "/fallback.jpg"
            }),
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Title, {
                        children: movie.Title
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Text, {
                        children: movie.Description
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Text, {
                        children: [
                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("strong", {
                                children: "Genre:"
                            }),
                            " ",
                            movie.Genre?.Name
                        ]
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Text, {
                        children: [
                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("strong", {
                                children: "Genre Description:"
                            }),
                            " ",
                            movie.Genre?.Description
                        ]
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Text, {
                        children: [
                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("strong", {
                                children: "Director:"
                            }),
                            " ",
                            movie.Director?.Name
                        ]
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Text, {
                        children: [
                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("strong", {
                                children: "Bio:"
                            }),
                            " ",
                            movie.Director?.Bio
                        ]
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)("div", {
                        className: "d-flex justify-content-between mt-3",
                        children: [
                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    children: "Back"
                                })
                            }),
                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                                variant: isFavorite ? "danger" : "success",
                                onClick: handleFavoriteToggle,
                                children: isFavorite ? "Remove from Favorites" : "Add to Favorites"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$cd915859487eece6$export$78d497080ea8f89a.propTypes = {
    movies: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).shape({
        Title: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
        Description: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
        ImagePath: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string,
        Genre: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).shape({
            Name: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string,
            Description: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string
        }),
        Director: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).shape({
            Name: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string,
            Bio: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string
        }),
        Actors: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string),
        _id: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired
    })).isRequired,
    username: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
    token: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string.isRequired,
    favoriteMovies: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string).isRequired,
    updateFavorites: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).func.isRequired
};




var $cvMSo = parcelRequire("cvMSo");



var $cvMSo = parcelRequire("cvMSo");


var $cvMSo = parcelRequire("cvMSo");


var $cvMSo = parcelRequire("cvMSo");


const $91ccfbbd04899c9d$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).elementType
};
const $91ccfbbd04899c9d$var$Feedback = /*#__PURE__*/ $cvMSo.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$91ccfbbd04899c9d$var$Feedback.displayName = 'Feedback';
$91ccfbbd04899c9d$var$Feedback.propTypes = $91ccfbbd04899c9d$var$propTypes;
var $91ccfbbd04899c9d$export$2e2bcd8739ae039 = $91ccfbbd04899c9d$var$Feedback;




var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");
"use client";
// TODO
const $02b8d5d1d462303d$var$FormContext = /*#__PURE__*/ $cvMSo.createContext({});
var $02b8d5d1d462303d$export$2e2bcd8739ae039 = $02b8d5d1d462303d$var$FormContext;




"use client";
const $887fe3c7f994b44b$var$FormCheckInput = /*#__PURE__*/ $cvMSo.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $cvMSo.useContext)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039));
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$887fe3c7f994b44b$var$FormCheckInput.displayName = 'FormCheckInput';
var $887fe3c7f994b44b$export$2e2bcd8739ae039 = $887fe3c7f994b44b$var$FormCheckInput;




var $cvMSo = parcelRequire("cvMSo");



"use client";
const $faed337fd9aa27a0$var$FormCheckLabel = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $cvMSo.useContext)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039));
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix)
    });
});
$faed337fd9aa27a0$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $faed337fd9aa27a0$export$2e2bcd8739ae039 = $faed337fd9aa27a0$var$FormCheckLabel;





var $cvMSo = parcelRequire("cvMSo");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $753ab58a74bb45a3$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $cvMSo.Children.map(children, (child)=>/*#__PURE__*/ $cvMSo.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $753ab58a74bb45a3$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $cvMSo.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $cvMSo.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $753ab58a74bb45a3$export$500fd6099226ffae(children, type) {
    return $cvMSo.Children.toArray(children).some((child)=>/*#__PURE__*/ $cvMSo.isValidElement(child) && child.type === type);
}



"use client";
const $565039d3e5a266fa$var$FormCheck = /*#__PURE__*/ $cvMSo.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $cvMSo.useContext)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039));
    const innerFormContext = (0, $cvMSo.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $753ab58a74bb45a3$export$500fd6099226ffae)(children, (0, $faed337fd9aa27a0$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $887fe3c7f994b44b$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $894c07836a326165$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $faed337fd9aa27a0$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $91ccfbbd04899c9d$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$565039d3e5a266fa$var$FormCheck.displayName = 'FormCheck';
var $565039d3e5a266fa$export$2e2bcd8739ae039 = Object.assign($565039d3e5a266fa$var$FormCheck, {
    Input: (0, $887fe3c7f994b44b$export$2e2bcd8739ae039),
    Label: (0, $faed337fd9aa27a0$export$2e2bcd8739ae039)
});




var $cvMSo = parcelRequire("cvMSo");
var $d82f79b7c19bb766$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $d82f79b7c19bb766$var$__DEV__ = false;
var $d82f79b7c19bb766$var$warning = function() {};
if ($d82f79b7c19bb766$var$__DEV__) {
    var $d82f79b7c19bb766$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $d82f79b7c19bb766$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $d82f79b7c19bb766$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$d82f79b7c19bb766$exports = $d82f79b7c19bb766$var$warning;






"use client";
const $522465e1dddc8994$var$FormControl = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $cvMSo.useContext)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039));
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$522465e1dddc8994$var$FormControl.displayName = 'FormControl';
var $522465e1dddc8994$export$2e2bcd8739ae039 = Object.assign($522465e1dddc8994$var$FormControl, {
    Feedback: $91ccfbbd04899c9d$export$2e2bcd8739ae039
});



var $cvMSo = parcelRequire("cvMSo");



"use client";
const $dd4377a2bae2de0b$var$FormFloating = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$dd4377a2bae2de0b$var$FormFloating.displayName = 'FormFloating';
var $dd4377a2bae2de0b$export$2e2bcd8739ae039 = $dd4377a2bae2de0b$var$FormFloating;



var $cvMSo = parcelRequire("cvMSo");


const $8af3b1a671fde3c6$var$FormGroup = /*#__PURE__*/ $cvMSo.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $cvMSo.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$8af3b1a671fde3c6$var$FormGroup.displayName = 'FormGroup';
var $8af3b1a671fde3c6$export$2e2bcd8739ae039 = $8af3b1a671fde3c6$var$FormGroup;




var $cvMSo = parcelRequire("cvMSo");



var $cvMSo = parcelRequire("cvMSo");


"use client";
function $6f2e0c645bc8edf3$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $49d3254000d8b829$export$8970c8db816a5863)();
    const minBreakpoint = (0, $49d3254000d8b829$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $6f2e0c645bc8edf3$var$Col = /*#__PURE__*/ $cvMSo.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $6f2e0c645bc8edf3$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, !spans.length && bsPrefix)
    });
});
$6f2e0c645bc8edf3$var$Col.displayName = 'Col';
var $6f2e0c645bc8edf3$export$2e2bcd8739ae039 = $6f2e0c645bc8edf3$var$Col;





"use client";
const $6c536a93f951e240$var$FormLabel = /*#__PURE__*/ $cvMSo.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $cvMSo.useContext)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039));
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $6f2e0c645bc8edf3$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$6c536a93f951e240$var$FormLabel.displayName = 'FormLabel';
var $6c536a93f951e240$export$2e2bcd8739ae039 = $6c536a93f951e240$var$FormLabel;




var $cvMSo = parcelRequire("cvMSo");



"use client";
const $b218e8da5788946a$var$FormRange = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $cvMSo.useContext)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039));
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$b218e8da5788946a$var$FormRange.displayName = 'FormRange';
var $b218e8da5788946a$export$2e2bcd8739ae039 = $b218e8da5788946a$var$FormRange;




var $cvMSo = parcelRequire("cvMSo");



"use client";
const $a72a5c639f00c28e$var$FormSelect = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $cvMSo.useContext)((0, $02b8d5d1d462303d$export$2e2bcd8739ae039));
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$a72a5c639f00c28e$var$FormSelect.displayName = 'FormSelect';
var $a72a5c639f00c28e$export$2e2bcd8739ae039 = $a72a5c639f00c28e$var$FormSelect;




var $cvMSo = parcelRequire("cvMSo");


"use client";
const $cd55ea10374826ce$var$FormText = /*#__PURE__*/ $cvMSo.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$cd55ea10374826ce$var$FormText.displayName = 'FormText';
var $cd55ea10374826ce$export$2e2bcd8739ae039 = $cd55ea10374826ce$var$FormText;



var $cvMSo = parcelRequire("cvMSo");


const $dc41559ffc89bfb9$var$Switch = /*#__PURE__*/ $cvMSo.forwardRef((props, ref)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $565039d3e5a266fa$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$dc41559ffc89bfb9$var$Switch.displayName = 'Switch';
var $dc41559ffc89bfb9$export$2e2bcd8739ae039 = Object.assign($dc41559ffc89bfb9$var$Switch, {
    Input: (0, $565039d3e5a266fa$export$2e2bcd8739ae039).Input,
    Label: (0, $565039d3e5a266fa$export$2e2bcd8739ae039).Label
});




var $cvMSo = parcelRequire("cvMSo");



"use client";
const $4b4960f97e6c44b4$var$FloatingLabel = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $8af3b1a671fde3c6$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$4b4960f97e6c44b4$var$FloatingLabel.displayName = 'FloatingLabel';
var $4b4960f97e6c44b4$export$2e2bcd8739ae039 = $4b4960f97e6c44b4$var$FloatingLabel;



const $222e5b8f9483b608$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).elementType
};
const $222e5b8f9483b608$var$Form = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, validated && 'was-validated')
    }));
$222e5b8f9483b608$var$Form.displayName = 'Form';
$222e5b8f9483b608$var$Form.propTypes = $222e5b8f9483b608$var$propTypes;
var $222e5b8f9483b608$export$2e2bcd8739ae039 = Object.assign($222e5b8f9483b608$var$Form, {
    Group: (0, $8af3b1a671fde3c6$export$2e2bcd8739ae039),
    Control: (0, $522465e1dddc8994$export$2e2bcd8739ae039),
    Floating: (0, $dd4377a2bae2de0b$export$2e2bcd8739ae039),
    Check: (0, $565039d3e5a266fa$export$2e2bcd8739ae039),
    Switch: $dc41559ffc89bfb9$export$2e2bcd8739ae039,
    Label: (0, $6c536a93f951e240$export$2e2bcd8739ae039),
    Text: (0, $cd55ea10374826ce$export$2e2bcd8739ae039),
    Range: (0, $b218e8da5788946a$export$2e2bcd8739ae039),
    Select: (0, $a72a5c639f00c28e$export$2e2bcd8739ae039),
    FloatingLabel: $4b4960f97e6c44b4$export$2e2bcd8739ae039
});



const $66e0ba9eddc32cbb$export$b378b4d12a0dcbde = ({ user: user, movies: movies, token: token, onDeregister: onDeregister, onUpdateProfile: onUpdateProfile, favoriteMovies: favoriteMovies, updateFavorites: updateFavorites })=>{
    const [username, setUsername] = (0, $cvMSo.useState)(user.Username);
    const [email, setEmail] = (0, $cvMSo.useState)(user.Email);
    const [birthday, setBirthday] = (0, $cvMSo.useState)(user.Birthday?.split('T')[0] || '');
    const [password, setPassword] = (0, $cvMSo.useState)("");
    const [newPassword, setNewPassword] = (0, $cvMSo.useState)("");
    const [favMoviesList, setFavMoviesList] = (0, $cvMSo.useState)([]);
    (0, $cvMSo.useEffect)(()=>{
        if (!Array.isArray(favoriteMovies)) return;
        const favs = movies.filter((movie)=>favoriteMovies.some((fav)=>fav._id === movie._id));
        setFavMoviesList(favs);
    }, [
        favoriteMovies,
        movies
    ]);
    const handleSubmit = (event)=>{
        event.preventDefault();
        const updatedUser = {
            Username: username,
            Email: email,
            Birthday: birthday,
            Password: password,
            ...newPassword && {
                NewPassword: newPassword
            }
        };
        onUpdateProfile(updatedUser);
    };
    const handleDeregister = ()=>{
        onDeregister(user.Username);
    };
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039), {
        className: "p-4 shadow-sm mt-4",
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Body, {
            children: [
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Title, {
                    className: "text-center mb-4 fs-3",
                    children: "My Account"
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039), {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formUsername",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Username"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    value: username,
                                    onChange: (e)=>setUsername(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formEmail",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formBirthday",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Birthday"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "date",
                                    value: birthday,
                                    onChange: (e)=>setBirthday(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formPassword",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Current Password"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formNewPassword",
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "New Password (Optional)"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "password",
                                    value: newPassword,
                                    onChange: (e)=>setNewPassword(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                            variant: "primary",
                            type: "submit",
                            className: "w-100",
                            children: "Update Profile"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                    variant: "danger",
                    onClick: handleDeregister,
                    className: "w-100 mt-3",
                    children: "Delete Account"
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("h5", {
                    className: "mt-5 mb-3",
                    children: "Your Favorite Movies"
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
                    className: "d-flex flex-wrap justify-content-start",
                    children: favMoviesList.length === 0 ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("p", {
                        children: "You have no favorite movies yet."
                    }) : favMoviesList.map((movie)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
                            className: "me-3 mb-4",
                            style: {
                                width: "18rem"
                            },
                            children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $830815a01ff3e63b$export$9bd698419030e459), {
                                movie: movie,
                                username: user.Username,
                                token: token,
                                favoriteMovies: favoriteMovies,
                                updateFavorites: updateFavorites
                            })
                        }, movie._id))
                })
            ]
        })
    });
};




var $cvMSo = parcelRequire("cvMSo");

const $85cb3a5693533e02$export$1582048ca8384970 = ({ onLoggedIn: onLoggedIn })=>{
    const [username, setUsername] = (0, $cvMSo.useState)("");
    const [password, setPassword] = (0, $cvMSo.useState)("");
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const data = {
            Username: username,
            Password: password
        };
        try {
            const response = await fetch("https://movieminded-d764560749d0.herokuapp.com/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                const errorData = await response.json();
                alert(`Login failed: ${errorData.message || "Invalid credentials"}`);
                return;
            }
            const result = await response.json();
            if (result.token) {
                localStorage.setItem("token", result.token);
                localStorage.setItem("user", JSON.stringify(result.user));
                onLoggedIn(result.user, result.token);
            } else alert("Login failed: Token not received.");
        } catch (error) {
            console.error("Login error:", error);
            alert("An unexpected error occurred during login.");
        }
    };
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039), {
        className: "p-4 shadow-sm",
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Body, {
            children: [
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Title, {
                    className: "text-center",
                    children: "Login"
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039), {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formUsername",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Username:"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    value: username,
                                    onChange: (e)=>setUsername(e.target.value),
                                    required: true,
                                    minLength: 3,
                                    placeholder: "Enter username"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formPassword",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Password:"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value),
                                    required: true,
                                    placeholder: "Enter password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                            variant: "primary",
                            type: "submit",
                            className: "w-100",
                            children: "Submit"
                        })
                    ]
                })
            ]
        })
    });
};




var $cvMSo = parcelRequire("cvMSo");


const $58b05434b0d3053a$export$25f3896ea1e09820 = ({ onSignupSuccess: onSignupSuccess })=>{
    const [username, setUsername] = (0, $cvMSo.useState)("");
    const [password, setPassword] = (0, $cvMSo.useState)("");
    const [email, setEmail] = (0, $cvMSo.useState)("");
    const [birthday, setBirthday] = (0, $cvMSo.useState)("");
    const navigate = (0, $217401a2c993c609$export$9770f232ac06a008)();
    const handleSubmit = async (event)=>{
        event.preventDefault();
        const data = {
            Username: username,
            Password: password,
            Email: email,
            Birthday: birthday
        };
        try {
            const response = await fetch("https://movieminded-d764560749d0.herokuapp.com/users", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(data)
            });
            const responseData = await response.json();
            if (response.ok) {
                alert("Signup successful. You may now log in.");
                navigate('/login');
            } else alert(`Signup failed: ${responseData.errors?.[0]?.msg || responseData.message || "Unknown error"}`);
        } catch (error) {
            console.error("Signup error:", error);
            alert("An unexpected error occurred during signup.");
        }
    };
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039), {
        className: "p-4 shadow-sm",
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Body, {
            children: [
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $043ca047cb2dab49$export$2e2bcd8739ae039).Title, {
                    className: "text-center",
                    children: "Sign Up"
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039), {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formUsername",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Username:"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    value: username,
                                    onChange: (e)=>setUsername(e.target.value),
                                    required: true,
                                    minLength: 3,
                                    placeholder: "Choose a username"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formPassword",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Password:"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value),
                                    required: true,
                                    placeholder: "Enter a secure password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formEmail",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Email:"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    required: true,
                                    placeholder: "Enter your email"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Group, {
                            controlId: "formBirthday",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Label, {
                                    children: "Birthday:"
                                }),
                                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                    type: "date",
                                    value: birthday,
                                    onChange: (e)=>setBirthday(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $9d49bcddab7a7bc1$export$2e2bcd8739ae039), {
                            variant: "success",
                            type: "submit",
                            className: "w-100",
                            children: "Sign Up"
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("cvMSo");


var $cvMSo = parcelRequire("cvMSo");
function $e265d35c26adfbdc$export$2e2bcd8739ae039() {
    return $e265d35c26adfbdc$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e265d35c26adfbdc$export$2e2bcd8739ae039.apply(null, arguments);
}


function $e265e3d32611180b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $cvMSo = parcelRequire("cvMSo");
var $7b495b66aeb577e8$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $7b495b66aeb577e8$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$7b495b66aeb577e8$exports = $7b495b66aeb577e8$var$invariant;


var $72e2ed43aa5d1e20$var$noop = function noop() {};
function $72e2ed43aa5d1e20$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $72e2ed43aa5d1e20$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $72e2ed43aa5d1e20$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$72e2ed43aa5d1e20$export$26cbf8c37e721e67(prop)] = $72e2ed43aa5d1e20$var$noop;
        var handler;
    });
    return propTypes;
}
function $72e2ed43aa5d1e20$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $72e2ed43aa5d1e20$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $72e2ed43aa5d1e20$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $d18e359bff0ebe69$var$_toPropertyKey(arg) {
    var key = $d18e359bff0ebe69$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $d18e359bff0ebe69$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d18e359bff0ebe69$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $cvMSo.useRef)(propValue !== undefined);
    var _useState = (0, $cvMSo.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $cvMSo.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $d18e359bff0ebe69$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$72e2ed43aa5d1e20$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $e265e3d32611180b$export$2e2bcd8739ae039)(_ref, [
            $72e2ed43aa5d1e20$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($d18e359bff0ebe69$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $d18e359bff0ebe69$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $e265d35c26adfbdc$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $03f5c87110c1a5a9$export$2e2bcd8739ae039(t, e) {
    return $03f5c87110c1a5a9$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $03f5c87110c1a5a9$export$2e2bcd8739ae039(t, e);
}


function $084bb6dd9ab2356d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $03f5c87110c1a5a9$export$2e2bcd8739ae039)(t, o);
}



var $cvMSo = parcelRequire("cvMSo");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $e6dc18fc10d74970$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $e6dc18fc10d74970$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $e6dc18fc10d74970$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$e6dc18fc10d74970$var$componentWillMount.__suppressDeprecationWarning = true;
$e6dc18fc10d74970$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$e6dc18fc10d74970$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $e6dc18fc10d74970$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $e6dc18fc10d74970$var$componentWillMount;
        prototype.componentWillReceiveProps = $e6dc18fc10d74970$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $e6dc18fc10d74970$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $8d5b77651e6816cd$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $8d5b77651e6816cd$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $72e2ed43aa5d1e20$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($72e2ed43aa5d1e20$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($7b495b66aeb577e8$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $084bb6dd9ab2356d$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $e265d35c26adfbdc$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$72e2ed43aa5d1e20$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $e265d35c26adfbdc$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$72e2ed43aa5d1e20$export$12ae2baa35bd9b8b(props, key) && $72e2ed43aa5d1e20$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$72e2ed43aa5d1e20$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $e265e3d32611180b$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).createElement(Component, (0, $e265d35c26adfbdc$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).Component);
    (0, $e6dc18fc10d74970$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $e265d35c26adfbdc$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $72e2ed43aa5d1e20$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).createElement(UncontrolledComponent, (0, $e265d35c26adfbdc$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $8d5b77651e6816cd$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $8d5b77651e6816cd$export$2e2bcd8739ae039(newComponent, (0, $e265d35c26adfbdc$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}




var $23229361e3254c56$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $23229361e3254c56$export$2e2bcd8739ae039(element, selector) {
    return $23229361e3254c56$var$toArray(element.querySelectorAll(selector));
}



var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");
function $bec0d1bd07bb2bab$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $cvMSo.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $cvMSo = parcelRequire("cvMSo");
const $4d6aa9cbb5747ed4$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $4d6aa9cbb5747ed4$export$c9058316764c140e(refA, refB) {
    const a = $4d6aa9cbb5747ed4$var$toFnRef(refA);
    const b = $4d6aa9cbb5747ed4$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $4d6aa9cbb5747ed4$var$useMergedRefs(refA, refB) {
    return (0, $cvMSo.useMemo)(()=>$4d6aa9cbb5747ed4$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $4d6aa9cbb5747ed4$export$2e2bcd8739ae039 = $4d6aa9cbb5747ed4$var$useMergedRefs;



var $cvMSo = parcelRequire("cvMSo");
const $40bf8a1a3233c1ee$var$NavContext = /*#__PURE__*/ $cvMSo.createContext(null);
$40bf8a1a3233c1ee$var$NavContext.displayName = 'NavContext';
var $40bf8a1a3233c1ee$export$2e2bcd8739ae039 = $40bf8a1a3233c1ee$var$NavContext;



var $cvMSo = parcelRequire("cvMSo");
const $3b8598338029d6c3$var$SelectableContext = /*#__PURE__*/ $cvMSo.createContext(null);
const $3b8598338029d6c3$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $3b8598338029d6c3$export$2e2bcd8739ae039 = $3b8598338029d6c3$var$SelectableContext;



var $cvMSo = parcelRequire("cvMSo");
const $59c9f0fcb7d32240$var$TabContext = /*#__PURE__*/ $cvMSo.createContext(null);
var $59c9f0fcb7d32240$export$2e2bcd8739ae039 = $59c9f0fcb7d32240$var$TabContext;


const $f1501030c0a5679f$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $f1501030c0a5679f$export$635202801f9383a0 = `rrUi`;
function $f1501030c0a5679f$export$5cc3b7b83e34ade7(property) {
    return `${$f1501030c0a5679f$export$fd7bcb7e9bef4e8a}${property}`;
}
function $f1501030c0a5679f$export$7776c0a7cd2eb3e0(property) {
    return `${$f1501030c0a5679f$export$635202801f9383a0}${property}`;
}



var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $2ea0ecd4525f7986$var$useCommittedRef(value) {
    const ref = (0, $cvMSo.useRef)(value);
    (0, $cvMSo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $2ea0ecd4525f7986$export$2e2bcd8739ae039 = $2ea0ecd4525f7986$var$useCommittedRef;


function $b7b6366282ef06df$export$2e2bcd8739ae039(fn) {
    const ref = (0, $2ea0ecd4525f7986$export$2e2bcd8739ae039)(fn);
    return (0, $cvMSo.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}








const $1f59683f8dd7d585$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $1f59683f8dd7d585$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $1f59683f8dd7d585$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $cvMSo.useContext)((0, $3b8598338029d6c3$export$2e2bcd8739ae039));
    const navContext = (0, $cvMSo.useContext)((0, $40bf8a1a3233c1ee$export$2e2bcd8739ae039));
    const tabContext = (0, $cvMSo.useContext)((0, $59c9f0fcb7d32240$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $f1501030c0a5679f$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $1f59683f8dd7d585$var$NavItem = /*#__PURE__*/ $cvMSo.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $6890f3c257181b7e$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $1f59683f8dd7d585$var$_objectWithoutPropertiesLoose(_ref, $1f59683f8dd7d585$var$_excluded);
    const [props, meta] = $1f59683f8dd7d585$export$d7a68693710982a(Object.assign({
        key: (0, $3b8598338029d6c3$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $f1501030c0a5679f$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$1f59683f8dd7d585$var$NavItem.displayName = 'NavItem';
var $1f59683f8dd7d585$export$2e2bcd8739ae039 = $1f59683f8dd7d585$var$NavItem;



const $a789cbbf2f0273df$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $a789cbbf2f0273df$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $a789cbbf2f0273df$var$noop = ()=>{};
const $a789cbbf2f0273df$var$EVENT_KEY_ATTR = (0, $f1501030c0a5679f$export$5cc3b7b83e34ade7)('event-key');
const $a789cbbf2f0273df$var$Nav = /*#__PURE__*/ $cvMSo.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $a789cbbf2f0273df$var$_objectWithoutPropertiesLoose(_ref, $a789cbbf2f0273df$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $bec0d1bd07bb2bab$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $cvMSo.useRef)(false);
    const parentOnSelect = (0, $cvMSo.useContext)((0, $3b8598338029d6c3$export$2e2bcd8739ae039));
    const tabContext = (0, $cvMSo.useContext)((0, $59c9f0fcb7d32240$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $cvMSo.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $23229361e3254c56$export$2e2bcd8739ae039)(currentListNode, `[${$a789cbbf2f0273df$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $f1501030c0a5679f$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $cvMSo.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$a789cbbf2f0273df$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $4d6aa9cbb5747ed4$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $3b8598338029d6c3$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $40bf8a1a3233c1ee$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $3b8598338029d6c3$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $a789cbbf2f0273df$var$noop,
                getControllerId: getControllerId || $a789cbbf2f0273df$var$noop
            },
            children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$a789cbbf2f0273df$var$Nav.displayName = 'Nav';
var $a789cbbf2f0273df$export$2e2bcd8739ae039 = Object.assign($a789cbbf2f0273df$var$Nav, {
    Item: (0, $1f59683f8dd7d585$export$2e2bcd8739ae039)
});




var $cvMSo = parcelRequire("cvMSo");
"use client";
// TODO: check
const $503501a2d6507d7b$var$context = /*#__PURE__*/ $cvMSo.createContext(null);
$503501a2d6507d7b$var$context.displayName = 'NavbarContext';
var $503501a2d6507d7b$export$2e2bcd8739ae039 = $503501a2d6507d7b$var$context;




var $cvMSo = parcelRequire("cvMSo");



"use client";
const $4549f35af80ee3eb$var$NavItem = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$4549f35af80ee3eb$var$NavItem.displayName = 'NavItem';
var $4549f35af80ee3eb$export$2e2bcd8739ae039 = $4549f35af80ee3eb$var$NavItem;




var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");
function $87bf576a8bfc6b19$export$2e2bcd8739ae039() {
    return (0, $cvMSo.useState)(null);
}





var $cvMSo = parcelRequire("cvMSo");

function $1aecea97b099e3ec$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)(listener);
    (0, $cvMSo.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $cvMSo = parcelRequire("cvMSo");
function $00c389996ceaba43$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $cvMSo.useCallback)(()=>document, []);
    return (0, $1aecea97b099e3ec$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $cvMSo = parcelRequire("cvMSo");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $554ee078400187b4$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $2ea0ecd4525f7986$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $2ea0ecd4525f7986$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $cvMSo.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $554ee078400187b4$export$2e2bcd8739ae039 = $554ee078400187b4$var$useInterval;



var $cvMSo = parcelRequire("cvMSo");

function $dc82865275822765$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $2ea0ecd4525f7986$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $2ea0ecd4525f7986$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $cvMSo.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $dc82865275822765$export$2e2bcd8739ae039 = $dc82865275822765$var$useRafInterval;



var $cvMSo = parcelRequire("cvMSo");
function $b744782bdd5dd8b2$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $cvMSo.useState)(initialState);
    const updater = (0, $cvMSo.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $96ef6c29ebddd113$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $b744782bdd5dd8b2$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $cvMSo = parcelRequire("cvMSo");
function $d429b1212587e536$export$2e2bcd8739ae039() {
    const mounted = (0, $cvMSo.useRef)(true);
    const isMounted = (0, $cvMSo.useRef)(()=>mounted.current);
    (0, $cvMSo.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $cvMSo = parcelRequire("cvMSo");
function $11e3693a1e9fbf01$export$2e2bcd8739ae039(value) {
    const ref = (0, $cvMSo.useRef)(null);
    (0, $cvMSo.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $cvMSo = parcelRequire("cvMSo");
function $377e831d195823ea$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $cvMSo.useState)({
        image: null,
        error: null
    });
    (0, $cvMSo.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");
const $7b58ce246166bb60$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $7b58ce246166bb60$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $7b58ce246166bb60$export$2e2bcd8739ae039 = $7b58ce246166bb60$var$isDOM || $7b58ce246166bb60$var$isReactNative ? (0, $cvMSo.useLayoutEffect) : (0, $cvMSo.useEffect);


const $e38729a5bdd93cf7$var$targetMap = new WeakMap();
let $e38729a5bdd93cf7$var$resizeObserver;
function $e38729a5bdd93cf7$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $e38729a5bdd93cf7$var$resizeObserver = $e38729a5bdd93cf7$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $e38729a5bdd93cf7$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $e38729a5bdd93cf7$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $cvMSo.useState)(null);
    (0, $7b58ce246166bb60$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $e38729a5bdd93cf7$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $e38729a5bdd93cf7$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $e38729a5bdd93cf7$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $baef442816ef1de9$var$_excluded = [
    "onKeyDown"
];
function $baef442816ef1de9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $baef442816ef1de9$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $baef442816ef1de9$var$Anchor = /*#__PURE__*/ $cvMSo.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $baef442816ef1de9$var$_objectWithoutPropertiesLoose(_ref, $baef442816ef1de9$var$_excluded);
    const [buttonProps] = (0, $6890f3c257181b7e$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($baef442816ef1de9$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$baef442816ef1de9$var$Anchor.displayName = 'Anchor';
var $baef442816ef1de9$export$2e2bcd8739ae039 = $baef442816ef1de9$var$Anchor;






"use client";
const $e90006ef1a9698a4$var$NavLink = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $baef442816ef1de9$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $1f59683f8dd7d585$export$d7a68693710982a)({
        key: (0, $3b8598338029d6c3$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$e90006ef1a9698a4$var$NavLink.displayName = 'NavLink';
var $e90006ef1a9698a4$export$2e2bcd8739ae039 = $e90006ef1a9698a4$var$NavLink;



"use client";
const $34d8d0f5e95d2c56$var$Nav = /*#__PURE__*/ $cvMSo.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $d18e359bff0ebe69$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $cvMSo.useContext)((0, $503501a2d6507d7b$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $cvMSo.useContext)((0, $d1f2c71b64e07569$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $a789cbbf2f0273df$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$34d8d0f5e95d2c56$var$Nav.displayName = 'Nav';
var $34d8d0f5e95d2c56$export$2e2bcd8739ae039 = Object.assign($34d8d0f5e95d2c56$var$Nav, {
    Item: (0, $4549f35af80ee3eb$export$2e2bcd8739ae039),
    Link: (0, $e90006ef1a9698a4$export$2e2bcd8739ae039)
});



var $cvMSo = parcelRequire("cvMSo");




var $cvMSo = parcelRequire("cvMSo");


"use client";
const $f375e0a5750211ff$var$NavbarBrand = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix)
    });
});
$f375e0a5750211ff$var$NavbarBrand.displayName = 'NavbarBrand';
var $f375e0a5750211ff$export$2e2bcd8739ae039 = $f375e0a5750211ff$var$NavbarBrand;



var $cvMSo = parcelRequire("cvMSo");

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $3d5366ebfa862638$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $6a95bd1bfe43e096$export$2e2bcd8739ae039(node) {
    var doc = (0, $3d5366ebfa862638$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $382bafc9405da2b3$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $6a95bd1bfe43e096$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $94ee5576300dabdb$var$rUpper = /([A-Z])/g;
function $94ee5576300dabdb$export$2e2bcd8739ae039(string) {
    return string.replace($94ee5576300dabdb$var$rUpper, '-$1').toLowerCase();
}


var $b14470fe784161a6$var$msPattern = /^ms-/;
function $b14470fe784161a6$export$2e2bcd8739ae039(string) {
    return (0, $94ee5576300dabdb$export$2e2bcd8739ae039)(string).replace($b14470fe784161a6$var$msPattern, '-ms-');
}


var $01af488d9de12e90$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $01af488d9de12e90$export$2e2bcd8739ae039(value) {
    return !!(value && $01af488d9de12e90$var$supportedTransforms.test(value));
}


function $d354a179261bfa4e$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $b14470fe784161a6$export$2e2bcd8739ae039)(property)) || (0, $382bafc9405da2b3$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b14470fe784161a6$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b14470fe784161a6$export$2e2bcd8739ae039)(key));
        else if ((0, $01af488d9de12e90$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b14470fe784161a6$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $d354a179261bfa4e$export$2e2bcd8739ae039 = $d354a179261bfa4e$var$style;



var $cvMSo = parcelRequire("cvMSo");




var $cvMSo = parcelRequire("cvMSo");

var $hVGez = parcelRequire("hVGez");
var $a63d8b6118795af5$export$2e2bcd8739ae039 = {
    disabled: false
};




var $cvMSo = parcelRequire("cvMSo");
var $913acb7899999450$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).createContext(null);


var $31d353e962f8488c$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $d66e8c750ed4fa8d$export$bb38bb9a1161268 = 'unmounted';
var $d66e8c750ed4fa8d$export$84cbff306f539230 = 'exited';
var $d66e8c750ed4fa8d$export$df38205c966be359 = 'entering';
var $d66e8c750ed4fa8d$export$78e9e6e3e014d60a = 'entered';
var $d66e8c750ed4fa8d$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $d66e8c750ed4fa8d$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $084bb6dd9ab2356d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $d66e8c750ed4fa8d$export$84cbff306f539230;
                _this.appearStatus = $d66e8c750ed4fa8d$export$df38205c966be359;
            } else initialStatus = $d66e8c750ed4fa8d$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $d66e8c750ed4fa8d$export$bb38bb9a1161268;
        else initialStatus = $d66e8c750ed4fa8d$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $d66e8c750ed4fa8d$export$bb38bb9a1161268) return {
            status: $d66e8c750ed4fa8d$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $d66e8c750ed4fa8d$export$df38205c966be359 && status !== $d66e8c750ed4fa8d$export$78e9e6e3e014d60a) nextStatus = $d66e8c750ed4fa8d$export$df38205c966be359;
            } else if (status === $d66e8c750ed4fa8d$export$df38205c966be359 || status === $d66e8c750ed4fa8d$export$78e9e6e3e014d60a) nextStatus = $d66e8c750ed4fa8d$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $d66e8c750ed4fa8d$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($hVGez))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $31d353e962f8488c$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $d66e8c750ed4fa8d$export$84cbff306f539230) this.setState({
            status: $d66e8c750ed4fa8d$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($hVGez))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $a63d8b6118795af5$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $d66e8c750ed4fa8d$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $d66e8c750ed4fa8d$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $d66e8c750ed4fa8d$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($hVGez))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $a63d8b6118795af5$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $d66e8c750ed4fa8d$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $d66e8c750ed4fa8d$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $d66e8c750ed4fa8d$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($hVGez))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $d66e8c750ed4fa8d$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $e265e3d32611180b$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).createElement((0, $913acb7899999450$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).Component);
$d66e8c750ed4fa8d$var$Transition.contextType = (0, $913acb7899999450$export$2e2bcd8739ae039);
$d66e8c750ed4fa8d$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $d66e8c750ed4fa8d$var$noop() {}
$d66e8c750ed4fa8d$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $d66e8c750ed4fa8d$var$noop,
    onEntering: $d66e8c750ed4fa8d$var$noop,
    onEntered: $d66e8c750ed4fa8d$var$noop,
    onExit: $d66e8c750ed4fa8d$var$noop,
    onExiting: $d66e8c750ed4fa8d$var$noop,
    onExited: $d66e8c750ed4fa8d$var$noop
};
$d66e8c750ed4fa8d$var$Transition.UNMOUNTED = $d66e8c750ed4fa8d$export$bb38bb9a1161268;
$d66e8c750ed4fa8d$var$Transition.EXITED = $d66e8c750ed4fa8d$export$84cbff306f539230;
$d66e8c750ed4fa8d$var$Transition.ENTERING = $d66e8c750ed4fa8d$export$df38205c966be359;
$d66e8c750ed4fa8d$var$Transition.ENTERED = $d66e8c750ed4fa8d$export$78e9e6e3e014d60a;
$d66e8c750ed4fa8d$var$Transition.EXITING = $d66e8c750ed4fa8d$export$4aacc83d4d59139f;
var $d66e8c750ed4fa8d$export$2e2bcd8739ae039 = $d66e8c750ed4fa8d$var$Transition;



var $cvMSo = parcelRequire("cvMSo");
function $a321096db2e910a1$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $a321096db2e910a1$export$13e065f3a74cfe36() {
    const parts = $cvMSo.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $a321096db2e910a1$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $a321096db2e910a1$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}




/* eslint-disable no-return-assign */ var $b49345dff7a3390d$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $61df329483e38a83$export$63fefd044b2bc624 = false;
var $61df329483e38a83$export$a614c6b395900f69 = false;
try {
    var $61df329483e38a83$var$options = {
        get passive () {
            return $61df329483e38a83$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $61df329483e38a83$export$a614c6b395900f69 = $61df329483e38a83$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $b49345dff7a3390d$export$2e2bcd8739ae039) {
        window.addEventListener('test', $61df329483e38a83$var$options, $61df329483e38a83$var$options);
        window.removeEventListener('test', $61df329483e38a83$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $61df329483e38a83$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$61df329483e38a83$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$61df329483e38a83$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $61df329483e38a83$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $61df329483e38a83$export$2e2bcd8739ae039 = $61df329483e38a83$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $dc7ef1764806337c$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $dc7ef1764806337c$export$2e2bcd8739ae039 = $dc7ef1764806337c$var$removeEventListener;


function $02a41ea078db19c1$var$listen(node, eventName, handler, options) {
    (0, $61df329483e38a83$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $dc7ef1764806337c$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $02a41ea078db19c1$export$2e2bcd8739ae039 = $02a41ea078db19c1$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $f92c9b7eee8d2cda$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $d770ec8cb1ad7809$var$parseDuration(node) {
    var str = (0, $d354a179261bfa4e$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d770ec8cb1ad7809$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $f92c9b7eee8d2cda$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $02a41ea078db19c1$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $d770ec8cb1ad7809$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $d770ec8cb1ad7809$var$parseDuration(element) || 0;
    var removeEmulate = $d770ec8cb1ad7809$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $02a41ea078db19c1$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $b075631c90185d13$var$parseDuration(node, property) {
    const str = (0, $d354a179261bfa4e$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $b075631c90185d13$export$2e2bcd8739ae039(element, handler) {
    const duration = $b075631c90185d13$var$parseDuration(element, 'transitionDuration');
    const delay = $b075631c90185d13$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $d770ec8cb1ad7809$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $5df0590412bba1fb$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $5df0590412bba1fb$export$2e2bcd8739ae039 = $5df0590412bba1fb$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $ffe2a6c9e96fee2a$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $cvMSo = parcelRequire("cvMSo");


var $cvMSo = parcelRequire("cvMSo");
const $74c5d1582363bd07$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $74c5d1582363bd07$export$c9058316764c140e(refA, refB) {
    const a = $74c5d1582363bd07$var$toFnRef(refA);
    const b = $74c5d1582363bd07$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $74c5d1582363bd07$var$useMergedRefs(refA, refB) {
    return (0, $cvMSo.useMemo)(()=>$74c5d1582363bd07$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $74c5d1582363bd07$export$2e2bcd8739ae039 = $74c5d1582363bd07$var$useMergedRefs;



var $hVGez = parcelRequire("hVGez");
function $9348ed74aaffea67$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($hVGez))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $caaab0e4e346aa67$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $cvMSo.useRef)(null);
    const mergedRef = (0, $74c5d1582363bd07$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $9348ed74aaffea67$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $cvMSo.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $cvMSo.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $cvMSo.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $cvMSo.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $cvMSo.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $cvMSo.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $cvMSo.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $d66e8c750ed4fa8d$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $caaab0e4e346aa67$export$2e2bcd8739ae039 = $caaab0e4e346aa67$var$TransitionWrapper;



const $27d62c2db44bda84$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $27d62c2db44bda84$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $27d62c2db44bda84$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $d354a179261bfa4e$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $d354a179261bfa4e$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $27d62c2db44bda84$var$collapseStyles = {
    [(0, $d66e8c750ed4fa8d$export$84cbff306f539230)]: 'collapse',
    [(0, $d66e8c750ed4fa8d$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $d66e8c750ed4fa8d$export$df38205c966be359)]: 'collapsing',
    [(0, $d66e8c750ed4fa8d$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $27d62c2db44bda84$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $27d62c2db44bda84$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $cvMSo.useMemo)(()=>(0, $5df0590412bba1fb$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $cvMSo.useMemo)(()=>(0, $5df0590412bba1fb$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $cvMSo.useMemo)(()=>(0, $5df0590412bba1fb$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $cvMSo.useMemo)(()=>(0, $5df0590412bba1fb$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $ffe2a6c9e96fee2a$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $cvMSo.useMemo)(()=>(0, $5df0590412bba1fb$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $caaab0e4e346aa67$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $b075631c90185d13$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $a321096db2e910a1$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cvMSo))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, children.props.className, $27d62c2db44bda84$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
var // @ts-ignore
$27d62c2db44bda84$export$2e2bcd8739ae039 = $27d62c2db44bda84$var$Collapse;





"use client";
const $371696c62c353163$var$NavbarCollapse = /*#__PURE__*/ $cvMSo.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $cvMSo.useContext)((0, $503501a2d6507d7b$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $27d62c2db44bda84$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$371696c62c353163$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $371696c62c353163$export$2e2bcd8739ae039 = $371696c62c353163$var$NavbarCollapse;




var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $4a3f868c1050089b$var$useCommittedRef(value) {
    const ref = (0, $cvMSo.useRef)(value);
    (0, $cvMSo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $4a3f868c1050089b$export$2e2bcd8739ae039 = $4a3f868c1050089b$var$useCommittedRef;


function $f8172f67631a2abc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $4a3f868c1050089b$export$2e2bcd8739ae039)(fn);
    return (0, $cvMSo.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}





"use client";
const $f7516e9782da95e8$var$NavbarToggle = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $cvMSo.useContext)((0, $503501a2d6507d7b$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $f8172f67631a2abc$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$f7516e9782da95e8$var$NavbarToggle.displayName = 'NavbarToggle';
var $f7516e9782da95e8$export$2e2bcd8739ae039 = $f7516e9782da95e8$var$NavbarToggle;



var $cvMSo = parcelRequire("cvMSo");



var $cvMSo = parcelRequire("cvMSo");
const $c1a05be69ffffa0e$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $c1a05be69ffffa0e$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $c1a05be69ffffa0e$export$2e2bcd8739ae039 = $c1a05be69ffffa0e$var$isDOM || $c1a05be69ffffa0e$var$isReactNative ? (0, $cvMSo.useLayoutEffect) : (0, $cvMSo.useEffect);



var $cvMSo = parcelRequire("cvMSo");
const $897422c123831f29$var$matchersByWindow = new WeakMap();
const $897422c123831f29$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $897422c123831f29$var$matchersByWindow.get(targetWindow) || new Map();
    $897422c123831f29$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $897422c123831f29$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $897422c123831f29$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $cvMSo.useState)(()=>mql ? mql.matches : false);
    (0, $c1a05be69ffffa0e$export$2e2bcd8739ae039)(()=>{
        let mql = $897422c123831f29$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $897422c123831f29$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $cvMSo = parcelRequire("cvMSo");
function $2b34ab7919c7ef65$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $cvMSo.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $897422c123831f29$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $2b34ab7919c7ef65$var$useBreakpoint = $2b34ab7919c7ef65$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $2b34ab7919c7ef65$export$2e2bcd8739ae039 = $2b34ab7919c7ef65$var$useBreakpoint;




var $cvMSo = parcelRequire("cvMSo");

function $978455cf6100642f$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $3d5366ebfa862638$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $c73063a8e6a8f7b9$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $cvMSo = parcelRequire("cvMSo");

var $hVGez = parcelRequire("hVGez");


var $cvMSo = parcelRequire("cvMSo");
function $407432cc452ccc4f$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $cvMSo.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $cvMSo = parcelRequire("cvMSo");
function $736b8faff9fb9ebe$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $407432cc452ccc4f$export$2e2bcd8739ae039)(fn);
    (0, $cvMSo.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $63918224d3e7f9e6$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $8591344c2cb67b2d$export$1a88c12b8b979fa0 = (0, $f1501030c0a5679f$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $8591344c2cb67b2d$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $63918224d3e7f9e6$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $d354a179261bfa4e$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($8591344c2cb67b2d$export$1a88c12b8b979fa0, '');
        (0, $d354a179261bfa4e$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($8591344c2cb67b2d$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $8591344c2cb67b2d$export$2e2bcd8739ae039 = $8591344c2cb67b2d$var$ModalManager;





var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");

const $040091c9695e74a4$var$Context = /*#__PURE__*/ (0, $cvMSo.createContext)((0, $b49345dff7a3390d$export$2e2bcd8739ae039) ? window : undefined);
const $040091c9695e74a4$export$f7d306aeb1cf5fbc = $040091c9695e74a4$var$Context.Provider;
function $040091c9695e74a4$export$2e2bcd8739ae039() {
    return (0, $cvMSo.useContext)($040091c9695e74a4$var$Context);
}


const $d4b2b86d3c92a79e$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $b49345dff7a3390d$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $3d5366ebfa862638$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $d4b2b86d3c92a79e$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $040091c9695e74a4$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $cvMSo.useState)(()=>$d4b2b86d3c92a79e$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $d4b2b86d3c92a79e$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $cvMSo.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $cvMSo.useEffect)(()=>{
        const nextRef = $d4b2b86d3c92a79e$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $cvMSo = parcelRequire("cvMSo");



var $cvMSo = parcelRequire("cvMSo");

function $21b3863c69856aeb$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $cvMSo.useRef)(null);
    const hasEnteredRef = (0, $cvMSo.useRef)(inProp);
    const handleExited = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)(onExited);
    (0, $cvMSo.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $4d6aa9cbb5747ed4$export$2e2bcd8739ae039)(ref, (0, $a321096db2e910a1$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $cvMSo.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $21b3863c69856aeb$export$2e2bcd8739ae039 = $21b3863c69856aeb$var$NoopTransition;



var $cvMSo = parcelRequire("cvMSo");

var $cvMSo = parcelRequire("cvMSo");


const $7df7e01cf3e25d32$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $7df7e01cf3e25d32$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $7df7e01cf3e25d32$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $7df7e01cf3e25d32$var$_objectWithoutPropertiesLoose(_ref, $7df7e01cf3e25d32$var$_excluded);
    const nodeRef = (0, $cvMSo.useRef)(null);
    const mergedRef = (0, $4d6aa9cbb5747ed4$export$2e2bcd8739ae039)(nodeRef, (0, $a321096db2e910a1$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $cvMSo.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $cvMSo.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $cvMSo.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $cvMSo.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $cvMSo.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $cvMSo.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $cvMSo.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $cvMSo.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $0eb5aeb229135812$var$_excluded = [
    "component"
];
function $0eb5aeb229135812$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $0eb5aeb229135812$var$RTGTransition = /*#__PURE__*/ $cvMSo.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $0eb5aeb229135812$var$_objectWithoutPropertiesLoose(_ref, $0eb5aeb229135812$var$_excluded);
    const transitionProps = (0, $7df7e01cf3e25d32$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $0eb5aeb229135812$export$2e2bcd8739ae039 = $0eb5aeb229135812$var$RTGTransition;




function $b55720740e6703fe$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $cvMSo.useRef)(null);
    const isInitialRef = (0, $cvMSo.useRef)(true);
    const handleTransition = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)(onTransition);
    (0, $7b58ce246166bb60$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $7b58ce246166bb60$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $b55720740e6703fe$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $cvMSo.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $b55720740e6703fe$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $4d6aa9cbb5747ed4$export$2e2bcd8739ae039)(ref, (0, $a321096db2e910a1$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $cvMSo.cloneElement)(children, {
        ref: combinedRef
    });
}
function $b55720740e6703fe$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $0eb5aeb229135812$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)($b55720740e6703fe$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $21b3863c69856aeb$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $46524fc2fd5ee679$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $46524fc2fd5ee679$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $46524fc2fd5ee679$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $46524fc2fd5ee679$var$getManager(window) {
    if (!$46524fc2fd5ee679$var$manager) $46524fc2fd5ee679$var$manager = new (0, $8591344c2cb67b2d$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $46524fc2fd5ee679$var$manager;
}
function $46524fc2fd5ee679$var$useModalManager(provided) {
    const window = (0, $040091c9695e74a4$export$2e2bcd8739ae039)();
    const modalManager = provided || $46524fc2fd5ee679$var$getManager(window);
    const modal = (0, $cvMSo.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $cvMSo.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $cvMSo.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $46524fc2fd5ee679$var$Modal = /*#__PURE__*/ (0, $cvMSo.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $46524fc2fd5ee679$var$_objectWithoutPropertiesLoose(_ref, $46524fc2fd5ee679$var$_excluded);
    const ownerWindow = (0, $040091c9695e74a4$export$2e2bcd8739ae039)();
    const container = (0, $d4b2b86d3c92a79e$export$2e2bcd8739ae039)(containerRef);
    const modal = $46524fc2fd5ee679$var$useModalManager(providedManager);
    const isMounted = (0, $d429b1212587e536$export$2e2bcd8739ae039)();
    const prevShow = (0, $11e3693a1e9fbf01$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $cvMSo.useState)(!show);
    const lastFocusRef = (0, $cvMSo.useRef)(null);
    (0, $cvMSo.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $b49345dff7a3390d$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $978455cf6100642f$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $02a41ea078db19c1$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $02a41ea078db19c1$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $978455cf6100642f$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $c73063a8e6a8f7b9$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $cvMSo.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $cvMSo.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $736b8faff9fb9ebe$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $978455cf6100642f$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $c73063a8e6a8f7b9$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $b7b6366282ef06df$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $a321096db2e910a1$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $cvMSo.useRef)();
    const removeKeydownListenerRef = (0, $cvMSo.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $cvMSo.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $b55720740e6703fe$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $b55720740e6703fe$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $894c07836a326165$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($hVGez))).createPortal(/*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $894c07836a326165$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$46524fc2fd5ee679$var$Modal.displayName = 'Modal';
var $46524fc2fd5ee679$export$2e2bcd8739ae039 = Object.assign($46524fc2fd5ee679$var$Modal, {
    Manager: (0, $8591344c2cb67b2d$export$2e2bcd8739ae039)
});




var $cvMSo = parcelRequire("cvMSo");






const $e92029a5ef9e12b0$var$fadeStyles = {
    [(0, $d66e8c750ed4fa8d$export$df38205c966be359)]: 'show',
    [(0, $d66e8c750ed4fa8d$export$78e9e6e3e014d60a)]: 'show'
};
const $e92029a5ef9e12b0$var$Fade = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $cvMSo.useCallback)((node, isAppearing)=>{
        (0, $ffe2a6c9e96fee2a$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $caaab0e4e346aa67$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $b075631c90185d13$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $a321096db2e910a1$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $cvMSo.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))('fade', className, children.props.className, $e92029a5ef9e12b0$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$e92029a5ef9e12b0$var$Fade.displayName = 'Fade';
var $e92029a5ef9e12b0$export$2e2bcd8739ae039 = $e92029a5ef9e12b0$var$Fade;



var $cvMSo = parcelRequire("cvMSo");



"use client";
const $aa5885bf37e7dc13$var$OffcanvasBody = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$aa5885bf37e7dc13$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $aa5885bf37e7dc13$export$2e2bcd8739ae039 = $aa5885bf37e7dc13$var$OffcanvasBody;




var $cvMSo = parcelRequire("cvMSo");






"use client";
const $d8a0a14fb9048d58$var$transitionStyles = {
    [(0, $d66e8c750ed4fa8d$export$df38205c966be359)]: 'show',
    [(0, $d66e8c750ed4fa8d$export$78e9e6e3e014d60a)]: 'show'
};
const $d8a0a14fb9048d58$var$OffcanvasToggling = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $caaab0e4e346aa67$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $b075631c90185d13$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $a321096db2e910a1$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $cvMSo.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, children.props.className, (status === (0, $d66e8c750ed4fa8d$export$df38205c966be359) || status === (0, $d66e8c750ed4fa8d$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $d8a0a14fb9048d58$var$transitionStyles[status])
            })
    });
});
$d8a0a14fb9048d58$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $d8a0a14fb9048d58$export$2e2bcd8739ae039 = $d8a0a14fb9048d58$var$OffcanvasToggling;



var $cvMSo = parcelRequire("cvMSo");
"use client";
const $32bfb890d9dc6758$var$ModalContext = /*#__PURE__*/ $cvMSo.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $32bfb890d9dc6758$export$2e2bcd8739ae039 = $32bfb890d9dc6758$var$ModalContext;




var $cvMSo = parcelRequire("cvMSo");


var $cvMSo = parcelRequire("cvMSo");



var $cvMSo = parcelRequire("cvMSo");


const $0c272a989e8a2572$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($1195fb9c0a409db8$exports))).oneOf([
        'white'
    ])
};
const $0c272a989e8a2572$var$CloseButton = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$0c272a989e8a2572$var$CloseButton.displayName = 'CloseButton';
$0c272a989e8a2572$var$CloseButton.propTypes = $0c272a989e8a2572$var$propTypes;
var $0c272a989e8a2572$export$2e2bcd8739ae039 = $0c272a989e8a2572$var$CloseButton;




"use client";
const $7b15ce0eef6a495f$var$AbstractModalHeader = /*#__PURE__*/ $cvMSo.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $cvMSo.useContext)((0, $32bfb890d9dc6758$export$2e2bcd8739ae039));
    const handleClick = (0, $f8172f67631a2abc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $0c272a989e8a2572$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $7b15ce0eef6a495f$export$2e2bcd8739ae039 = $7b15ce0eef6a495f$var$AbstractModalHeader;



"use client";
const $c4925502222301d0$var$OffcanvasHeader = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $7b15ce0eef6a495f$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$c4925502222301d0$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $c4925502222301d0$export$2e2bcd8739ae039 = $c4925502222301d0$var$OffcanvasHeader;



var $cvMSo = parcelRequire("cvMSo");




"use client";
const $7ecad6f76c315c7d$var$DivStyledAsH5 = (0, $306969f682d044b0$export$2e2bcd8739ae039)('h5');
const $7ecad6f76c315c7d$var$OffcanvasTitle = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $7ecad6f76c315c7d$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$7ecad6f76c315c7d$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $7ecad6f76c315c7d$export$2e2bcd8739ae039 = $7ecad6f76c315c7d$var$OffcanvasTitle;



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $27a257fda80a6db1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $169db417cc404a11$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $27a257fda80a6db1$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $27be5044ca7c631c$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $27be5044ca7c631c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $27be5044ca7c631c$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $27be5044ca7c631c$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $9ab6ce3f3bc69c5c$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $9ab6ce3f3bc69c5c$var$BootstrapModalManager extends (0, $8591344c2cb67b2d$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $d354a179261bfa4e$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $d354a179261bfa4e$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $d354a179261bfa4e$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $169db417cc404a11$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $23229361e3254c56$export$2e2bcd8739ae039)(container, $9ab6ce3f3bc69c5c$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $23229361e3254c56$export$2e2bcd8739ae039)(container, $9ab6ce3f3bc69c5c$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $23229361e3254c56$export$2e2bcd8739ae039)(container, $9ab6ce3f3bc69c5c$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $27be5044ca7c631c$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $23229361e3254c56$export$2e2bcd8739ae039)(container, $9ab6ce3f3bc69c5c$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $23229361e3254c56$export$2e2bcd8739ae039)(container, $9ab6ce3f3bc69c5c$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $23229361e3254c56$export$2e2bcd8739ae039)(container, $9ab6ce3f3bc69c5c$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $9ab6ce3f3bc69c5c$var$sharedManager;
function $9ab6ce3f3bc69c5c$export$a03641438014b436(options) {
    if (!$9ab6ce3f3bc69c5c$var$sharedManager) $9ab6ce3f3bc69c5c$var$sharedManager = new $9ab6ce3f3bc69c5c$var$BootstrapModalManager(options);
    return $9ab6ce3f3bc69c5c$var$sharedManager;
}
var $9ab6ce3f3bc69c5c$export$2e2bcd8739ae039 = $9ab6ce3f3bc69c5c$var$BootstrapModalManager;



"use client";
function $afef05aca3bdf953$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $d8a0a14fb9048d58$export$2e2bcd8739ae039), {
        ...props
    });
}
function $afef05aca3bdf953$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $e92029a5ef9e12b0$export$2e2bcd8739ae039), {
        ...props
    });
}
const $afef05aca3bdf953$var$Offcanvas = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $cvMSo.useRef)();
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $cvMSo.useState)(false);
    const handleHide = (0, $f8172f67631a2abc$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $2b34ab7919c7ef65$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $cvMSo.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $cvMSo.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $9ab6ce3f3bc69c5c$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $9ab6ce3f3bc69c5c$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $cvMSo.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $894c07836a326165$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $32bfb890d9dc6758$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $46524fc2fd5ee679$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $afef05aca3bdf953$var$DialogTransition,
                    backdropTransition: $afef05aca3bdf953$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$afef05aca3bdf953$var$Offcanvas.displayName = 'Offcanvas';
var $afef05aca3bdf953$export$2e2bcd8739ae039 = Object.assign($afef05aca3bdf953$var$Offcanvas, {
    Body: (0, $aa5885bf37e7dc13$export$2e2bcd8739ae039),
    Header: (0, $c4925502222301d0$export$2e2bcd8739ae039),
    Title: (0, $7ecad6f76c315c7d$export$2e2bcd8739ae039)
});




"use client";
const $772f94296fcb200c$var$NavbarOffcanvas = /*#__PURE__*/ $cvMSo.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $cvMSo.useContext)((0, $503501a2d6507d7b$export$2e2bcd8739ae039));
    const handleHide = (0, $f8172f67631a2abc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $afef05aca3bdf953$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$772f94296fcb200c$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $772f94296fcb200c$export$2e2bcd8739ae039 = $772f94296fcb200c$var$NavbarOffcanvas;





var $cvMSo = parcelRequire("cvMSo");



"use client";
const $4072dd724384413f$var$NavbarText = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$4072dd724384413f$var$NavbarText.displayName = 'NavbarText';
var $4072dd724384413f$export$2e2bcd8739ae039 = $4072dd724384413f$var$NavbarText;



"use client";
const $e389b622fa47b28f$var$Navbar = /*#__PURE__*/ $cvMSo.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $d18e359bff0ebe69$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $cvMSo.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $cvMSo.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $503501a2d6507d7b$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $3b8598338029d6c3$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$e389b622fa47b28f$var$Navbar.displayName = 'Navbar';
var $e389b622fa47b28f$export$2e2bcd8739ae039 = Object.assign($e389b622fa47b28f$var$Navbar, {
    Brand: (0, $f375e0a5750211ff$export$2e2bcd8739ae039),
    Collapse: (0, $371696c62c353163$export$2e2bcd8739ae039),
    Offcanvas: (0, $772f94296fcb200c$export$2e2bcd8739ae039),
    Text: (0, $4072dd724384413f$export$2e2bcd8739ae039),
    Toggle: (0, $f7516e9782da95e8$export$2e2bcd8739ae039)
});



const $8745244a58520804$export$214ae410b202e65a = ({ user: user, onLoggedOut: onLoggedOut, onSearch: onSearch })=>{
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $e389b622fa47b28f$export$2e2bcd8739ae039), {
        className: "custom-navbar",
        expand: "lg",
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $e389b622fa47b28f$export$2e2bcd8739ae039).Brand, {
                    as: (0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a),
                    to: "/",
                    children: "MovieMinded"
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $e389b622fa47b28f$export$2e2bcd8739ae039).Toggle, {
                    "aria-controls": "navbar-nav"
                }),
                /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $e389b622fa47b28f$export$2e2bcd8739ae039).Collapse, {
                    id: "navbar-nav",
                    children: [
                        user && /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039), {
                            className: "d-flex search-form-wrapper flex-grow-1 mx-lg-3 mx-md-2 mx-sm-1",
                            children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $222e5b8f9483b608$export$2e2bcd8739ae039).Control, {
                                type: "search",
                                placeholder: "Which movies move you?",
                                className: "me-2 search-input",
                                "aria-label": "Search",
                                onChange: (e)=>onSearch(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $34d8d0f5e95d2c56$export$2e2bcd8739ae039), {
                            className: "ms-auto",
                            children: user ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $894c07836a326165$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $34d8d0f5e95d2c56$export$2e2bcd8739ae039).Link, {
                                        as: (0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a),
                                        to: "/profile",
                                        children: "Profile"
                                    }),
                                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $34d8d0f5e95d2c56$export$2e2bcd8739ae039).Link, {
                                        onClick: onLoggedOut,
                                        children: "Logout"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $894c07836a326165$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $34d8d0f5e95d2c56$export$2e2bcd8739ae039).Link, {
                                        as: (0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a),
                                        to: "/login",
                                        children: "Login"
                                    }),
                                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $34d8d0f5e95d2c56$export$2e2bcd8739ae039).Link, {
                                        as: (0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a),
                                        to: "/signup",
                                        children: "Signup"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};





var $cvMSo = parcelRequire("cvMSo");




var $cvMSo = parcelRequire("cvMSo");




"use client";
const $7003414ec0c4c280$var$DivStyledAsH4 = (0, $306969f682d044b0$export$2e2bcd8739ae039)('h4');
$7003414ec0c4c280$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $7003414ec0c4c280$var$AlertHeading = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $7003414ec0c4c280$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$7003414ec0c4c280$var$AlertHeading.displayName = 'AlertHeading';
var $7003414ec0c4c280$export$2e2bcd8739ae039 = $7003414ec0c4c280$var$AlertHeading;



var $cvMSo = parcelRequire("cvMSo");




"use client";
const $88baa83943b54dc5$var$AlertLink = /*#__PURE__*/ $cvMSo.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $baef442816ef1de9$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, bsPrefix),
        ...props
    });
});
$88baa83943b54dc5$var$AlertLink.displayName = 'AlertLink';
var $88baa83943b54dc5$export$2e2bcd8739ae039 = $88baa83943b54dc5$var$AlertLink;





"use client";
const $638e3430b1a98053$var$Alert = /*#__PURE__*/ $cvMSo.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $e92029a5ef9e12b0$export$2e2bcd8739ae039), ...props } = (0, $d18e359bff0ebe69$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $f8172f67631a2abc$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $e92029a5ef9e12b0$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $0c272a989e8a2572$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$638e3430b1a98053$var$Alert.displayName = 'Alert';
var $638e3430b1a98053$export$2e2bcd8739ae039 = Object.assign($638e3430b1a98053$var$Alert, {
    Link: (0, $88baa83943b54dc5$export$2e2bcd8739ae039),
    Heading: (0, $7003414ec0c4c280$export$2e2bcd8739ae039)
});



var $cvMSo = parcelRequire("cvMSo");


"use client";
const $91981f252195e985$var$Container = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$91981f252195e985$var$Container.displayName = 'Container';
var $91981f252195e985$export$2e2bcd8739ae039 = $91981f252195e985$var$Container;



var $cvMSo = parcelRequire("cvMSo");


"use client";
const $ff0466621e8733c9$var$Row = /*#__PURE__*/ $cvMSo.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $49d3254000d8b829$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $49d3254000d8b829$export$8970c8db816a5863)();
    const minBreakpoint = (0, $49d3254000d8b829$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1bbfdeebbadfe1c9$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$ff0466621e8733c9$var$Row.displayName = 'Row';
var $ff0466621e8733c9$export$2e2bcd8739ae039 = $ff0466621e8733c9$var$Row;


const $59a76f783edf8a27$var$MainView = ()=>{
    const storedUser = (()=>{
        try {
            const userData = JSON.parse(localStorage.getItem("user"));
            if (userData && !Array.isArray(userData.FavoriteMovies)) userData.FavoriteMovies = [];
            return userData;
        } catch (e) {
            console.warn("Invalid JSON for user in localStorage, clearing it.");
            localStorage.removeItem("user");
            return null;
        }
    })();
    const storedToken = localStorage.getItem("token");
    const [user, setUser] = (0, $cvMSo.useState)(storedUser);
    const [token, setToken] = (0, $cvMSo.useState)(storedToken);
    const [movies, setMovies] = (0, $cvMSo.useState)([]);
    const [favoriteMovies, setFavoriteMovies] = (0, $cvMSo.useState)(storedUser?.FavoriteMovies || []);
    const [searchQuery, setSearchQuery] = (0, $cvMSo.useState)("");
    const [isLoadingMovies, setIsLoadingMovies] = (0, $cvMSo.useState)(false);
    (0, $cvMSo.useEffect)(()=>{
        if (!token) {
            setMovies([]);
            setIsLoadingMovies(false);
            return;
        }
        setIsLoadingMovies(true);
        fetch("https://movieminded-d764560749d0.herokuapp.com/movies", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response)=>{
            if (!response.ok) {
                // If unauthorized, token might be expired - clear it
                if (response.status === 401 || response.status === 403) {
                    // Clear session data
                    setUser(null);
                    setToken(null);
                    setFavoriteMovies([]);
                    setSearchQuery("");
                    localStorage.clear();
                    throw new Error("Session expired. Please log in again.");
                }
                throw new Error(`Failed to fetch movies: ${response.status} ${response.statusText}`);
            }
            return response.json();
        }).then((data)=>{
            setMovies(Array.isArray(data) ? data : []);
            setIsLoadingMovies(false);
        }).catch((error)=>{
            console.error("Error fetching movies:", error);
            setMovies([]);
            setIsLoadingMovies(false);
        });
    }, [
        token
    ]);
    const handleSearch = (query)=>{
        setSearchQuery(query);
    };
    const filteredMovies = movies.filter((movie)=>movie.Title.toLowerCase().includes(searchQuery.toLowerCase()));
    const handleLoggedIn = (user, token)=>{
        if (!Array.isArray(user.FavoriteMovies)) user.FavoriteMovies = [];
        setUser(user);
        setToken(token);
        setFavoriteMovies(user.FavoriteMovies);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", token);
    };
    const handleLoggedOut = ()=>{
        setUser(null);
        setToken(null);
        setFavoriteMovies([]);
        setSearchQuery("");
        localStorage.clear();
    };
    const updateFavorites = (newFavorites)=>{
        setFavoriteMovies(newFavorites);
        const updatedUser = {
            ...user,
            FavoriteMovies: newFavorites
        };
        setUser(updatedUser);
        localStorage.setItem("user", JSON.stringify(updatedUser));
    };
    const handleUpdateProfile = (updatedUserData)=>{
        fetch(`https://movieminded-d764560749d0.herokuapp.com/users/${user.Username}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(updatedUserData)
        }).then((res)=>{
            if (!res.ok) throw new Error("Profile update failed");
            return res.json();
        }).then((updatedUser)=>{
            setUser(updatedUser);
            setFavoriteMovies(updatedUser.FavoriteMovies || []);
            localStorage.setItem("user", JSON.stringify(updatedUser));
            alert("Profile updated successfully");
        }).catch((err)=>console.error("Profile update error:", err));
    };
    const handleDeregister = ()=>{
        fetch(`https://movieminded-d764560749d0.herokuapp.com/users/${user.Username}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((res)=>{
            if (!res.ok) throw new Error("Deregistration failed");
            alert("Account deleted");
            handleLoggedOut();
        }).catch((err)=>console.error("Deregister error:", err));
    };
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $cc10053bf1b5cdc7$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $8745244a58520804$export$214ae410b202e65a), {
                user: user,
                onLoggedOut: handleLoggedOut,
                onSearch: handleSearch
            }),
            /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $217401a2c993c609$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: user ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $91981f252195e985$export$2e2bcd8739ae039), {
                            className: "mt-4",
                            children: isLoadingMovies ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $638e3430b1a98053$export$2e2bcd8739ae039), {
                                variant: "info",
                                className: "text-center",
                                children: "Loading movies..."
                            }) : filteredMovies.length === 0 ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $638e3430b1a98053$export$2e2bcd8739ae039), {
                                variant: "warning",
                                className: "text-center",
                                children: movies.length === 0 ? "No movies available. Please try refreshing the page." : "No movies match your search."
                            }) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $ff0466621e8733c9$export$2e2bcd8739ae039), {
                                className: "justify-content-center",
                                children: filteredMovies.map((movie)=>/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $6f2e0c645bc8edf3$export$2e2bcd8739ae039), {
                                        className: "mb-4",
                                        xs: 12,
                                        sm: 6,
                                        md: 4,
                                        lg: 3,
                                        xl: 2,
                                        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $830815a01ff3e63b$export$9bd698419030e459), {
                                            movie: movie,
                                            user: user,
                                            token: token,
                                            favoriteMovies: favoriteMovies,
                                            updateFavorites: updateFavorites
                                        })
                                    }, movie._id))
                            })
                        }) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $91981f252195e985$export$2e2bcd8739ae039), {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)((0, $638e3430b1a98053$export$2e2bcd8739ae039), {
                                variant: "info",
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $638e3430b1a98053$export$2e2bcd8739ae039).Heading, {
                                        children: "Welcome to MovieMinded!"
                                    }),
                                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)("p", {
                                        children: [
                                            "Please ",
                                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a), {
                                                to: "/login",
                                                children: "log in"
                                            }),
                                            " to browse and discover movies."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsxs)("p", {
                                        className: "mb-0",
                                        children: [
                                            "Don't have an account? ",
                                            /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $cc10053bf1b5cdc7$export$a6c7ac8248d6e38a), {
                                                to: "/signup",
                                                children: "Sign up"
                                            }),
                                            " to get started."
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$e7b0ac011bb776c6), {
                        path: "/movies/:movieId",
                        element: user ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $cd915859487eece6$export$78d497080ea8f89a), {
                            movies: movies,
                            username: user.Username,
                            token: token,
                            favoriteMovies: favoriteMovies,
                            updateFavorites: updateFavorites
                        }) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$444b3ab0cb9aec40), {
                            to: "/login",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$e7b0ac011bb776c6), {
                        path: "/profile",
                        element: user ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $66e0ba9eddc32cbb$export$b378b4d12a0dcbde), {
                            user: user,
                            token: token,
                            movies: movies,
                            favoriteMovies: favoriteMovies,
                            updateFavorites: updateFavorites,
                            onUpdateProfile: handleUpdateProfile,
                            onDeregister: handleDeregister
                        }) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$444b3ab0cb9aec40), {
                            to: "/login",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: user ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$444b3ab0cb9aec40), {
                            to: "/",
                            replace: true
                        }) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $85cb3a5693533e02$export$1582048ca8384970), {
                            onLoggedIn: handleLoggedIn
                        })
                    }),
                    /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$e7b0ac011bb776c6), {
                        path: "/signup",
                        element: user ? /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $217401a2c993c609$export$444b3ab0cb9aec40), {
                            to: "/",
                            replace: true
                        }) : /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $58b05434b0d3053a$export$25f3896ea1e09820), {})
                    })
                ]
            })
        ]
    });
};
var $59a76f783edf8a27$export$2e2bcd8739ae039 = $59a76f783edf8a27$var$MainView;





const $ac484fd9ee6aa010$var$MyFlixApplication = ()=>{
    return /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $91981f252195e985$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $894c07836a326165$exports.jsx)((0, $59a76f783edf8a27$export$2e2bcd8739ae039), {})
    });
};
const $ac484fd9ee6aa010$var$container = document.querySelector("#root");
const $ac484fd9ee6aa010$var$root = (0, $8ea8309dadb916c6$exports.createRoot)($ac484fd9ee6aa010$var$container);
$ac484fd9ee6aa010$var$root.render(/*#__PURE__*/ (0, $894c07836a326165$exports.jsx)($ac484fd9ee6aa010$var$MyFlixApplication, {}));

})();
//# sourceMappingURL=repo.a78a44b8.js.map
